// --- i18n SYSTEM (TypeScript) ---
import type { TranslationValue, TranslationMap } from './types';

// Default NO (norwescy księgowi). PL = opcja toggle.
let _currentLang: string = 'no';
try { const saved = localStorage.getItem('audit-lang'); if (saved === 'no' || saved === 'pl') _currentLang = saved; } catch (e) { /* SSR safe */ }

export function getCurrentLang(): string { return _currentLang; }
export function setCurrentLang(lang: string): void { _currentLang = lang; }

export const TRANSLATIONS: Record<string, TranslationMap> = {
    no: {
        balance_age_no_transactions: 'Saldoens sammensetning per måned er ikke fastslått fordi transaksjonslinjer mangler.',
        balance_age_atypical: (account, ub) => `Konto ${account}: UB ${ub}. Saldo på unormal side, sannsynligvis feil. Kontroller og korriger føringen.`,
        balance_age_older: (account, ub, parts) => `Konto ${account}: UB ${ub}. Saldoen tilordnes de nyeste posteringene på kontoens normale side, med rest til IB fra forrige år. Sammensetning fra eldst til nyest: ${parts}.`,
        balance_age_unavailable: (account, ub) => `Konto ${account}: UB ${ub}. Perioden eller månedsgrunnlaget mangler; saldoens alder kan ikke fastslås. Kontroller grunnlaget.`,
        rule_saldo_1530: 'Opptjent, ikke fakturert driftsinntekt – konto 1530',
        rule_saldo_1530_amounts: (ib, change, ub) => `Konto 1530: IB ${ib}, bevegelse i perioden ${change}, UB ${ub}.`,
        rule_saldo_1530_negative_ub: 'Fordringskontoen har negativ saldo. Kontroller og korriger føringen.',
        rule_saldo_1530_current_year: 'Saldoen har oppstått i inneværende år. Kontroller at inntekten er riktig periodisert.',
        rule_saldo_1530_negative_ib: 'Inngående saldo fra forrige år var negativ. Kontroller grunnlaget og korriger eventuelle feil.',
        rule_saldo_1530_unreversed: 'Beløpet fra forrige år er ikke reversert. Reverser periodiseringen.',
        rule_saldo_1530_increased: 'Inngående saldo er ikke reversert, eller nye beløp er lagt til. Kontroller periodiseringen.',
        rule_saldo_1530_partial: 'En del av inngående saldo gjenstår. Kontroller om resten skal reverseres.',
        rule_saldo_1530_ub_only: (ub) => `Konto 1530 har UB ${ub}. Grunnlaget for IB og bevegelse er ikke komplett. Kontroller opptjent, ikke fakturert driftsinntekt.`,
        action_saldo_1530: 'Beløp fra forrige år og eldre måneder skal allerede være reversert. Kontroller reverseringen på konto 1530.',
        action_balance_age_atypical: 'Kontroller hvilken postering som gir saldo på unormal side, og korriger føringen.',
        action_balance_age_unavailable: 'Saldoen er ikke fordelt på måneder fordi posteringslinjer mangler. Avstem saldoen mot bilag.',
        rule_personalkostnader_negative: 'Negative personalkostnader 5000–5999',
        rule_personalkostnader_negative_desc: (total, top) => `Summen av kontoene 5000–5999 i perioden er ${total}. Største bidrag (inntil tre kontoer): ${top}. Kontroller korreksjoner og fortegn.`,
        action_personalkostnader_negative: 'Avstem negative personalkostnader mot lønnsgrunnlag og korrigeringsbilag.',
        rule_arsregnskap_mangler: 'Årsregnskap mangler i Regnskapsregisteret',
        arsregnskap_no_year: 'ingen registrerte årsregnskap',
        rule_arsregnskap_mangler_desc: (required, last, year) => `Årsregnskap for ${required} mangler i Regnskapsregisteret. Siste registrerte regnskapsår: ${last}. Fristen 31.07.${year} er passert. Forsinkelsen medfører forsinkelsesgebyr for hver uke. Kontroller i Altinn at årsregnskapet er sendt inn og godkjent.`,
        action_arsregnskap_mangler: 'Kontroller innsendingskvittering og godkjenning i Altinn; avklar manglende årsregnskap.',
        rule_skattetrekk_2610_balance: 'Saldo på skattetrekkonto 2610',
        rule_skattetrekk_2610_balance_desc: (months) => 'Konto 2610 har en utgående saldo med absoluttverdi over 1 kr. Avklar og avstem saldoen.' + (months == null ? '' : ` Antall måneder med netto bevegelse ulik null på konto 2610 i tilgjengelige transaksjoner: ${months}.`),
        action_skattetrekk_2610_balance: 'Trekk fra før siste måned skal allerede være betalt. Avstem mot innbetalinger til Skatteetaten.',
        rule_skattetrekk_1950_balance: 'Saldo på tidligere skattetrekkskonto 1950',
        rule_skattetrekk_1950_balance_desc: 'Konto 1950 har en utgående saldo med absoluttverdi over 1 kr. Ordningen med skattetrekkskonto er avviklet fra 2026; saldoen må avklares.',
        action_skattetrekk_1950_balance: 'Kontroller bankdokumentasjon og avklar overføring eller ompostering av restsaldo på konto 1950.',
        rule_financial_income_sign_80xx: 'Uventet fortegn på finansinntekter 8050/8060',
        rule_financial_income_sign_80xx_desc: 'Konto 8050 eller 8060 har minst 500 kr i absolutt perioderesultat med motsatt fortegn av inntekt i valgt regnskapssystem.',
        action_financial_income_sign_80xx: 'Kontroller bilag, reverseringer og kontovalg på 8050/8060; korriger eventuelle feilføringer.',
        rule_financial_cost_sign_815x_816x: 'Uventet fortegn på finanskostnader 8150–8169',
        rule_financial_cost_sign_815x_816x_desc: 'En konto i intervallet 8150–8169 har minst 500 kr i absolutt perioderesultat med motsatt fortegn av kostnad i valgt regnskapssystem.',
        action_financial_cost_sign_815x_816x: 'Kontroller bilag og reverseringer på 8150–8169 mot rente- og finansdokumentasjon.',
        rule_periodisering_2900_balance: 'Saldo på periodiseringskonto 2900',
        rule_periodisering_2900_balance_desc: 'Konto 2900 har en utgående saldo med absoluttverdi over 1 kr. Avklar grunnlag og tidspunkt for reversering av periodiseringen.',
        action_periodisering_2900_balance: 'Beløp eldre enn siste måned er ikke gjort opp. Kontroller periodiseringen på konto 2900.',
        rule_7790_7798: 'Samtidig bruk av konto 7790 og 7798',
        rule_7790_7798_desc: 'Både konto 7790 og 7798 har saldo ulik null. Kontroller om samme type kostnad er fordelt mellom kontoene.',
        action_7790_7798: 'Velg én av kontoene 7790 eller 7798 og ombokfør den andre.',
        action_conflict_7790_7798: 'Velg én av kontoene 7790 eller 7798 og ombokfør den andre.',
        rule_mva_registered_no_vat_postings: 'MVA-registrert uten påvist MVA-aktivitet',
        rule_mva_registered_no_vat_postings_desc: (company) => `${company || 'Selskapet'} er registrert i MVA-registeret, men tilgjengelige data viser ingen bevegelse eller saldo med absoluttverdi over 1 kr på kontoene 2700–2749 og ingen tilgjengelige transaksjonslinjer på disse kontoene.`,
        action_mva_registered_no_vat_postings: 'Kontroller periodens aktivitet, MVA-koder, MVA-meldinger og om bokføringsgrunnlaget er komplett.',
        otp_basis_mixed: "Kontoen omfatter både OTP og AFP. Uten fordeling beregnes ikke OTP-forholdet.",
        otp_ytd_missing: "Mangler lønn og pensjonskostnader fra januar til slutten av revisjonsperioden; OTP-kontrollen er ikke utført.",
        otp_source_unverified: 'Firmaets identitet er ikke bekreftet i begge kildesvar. Hent data på nytt for å beregne OTP.',
        project_pnl_missing_ids: 'Noen posteringer har prosjektnavn uten identifikator. Fordelingen mellom prosjektene kan ikke bekreftes.',
        evidence_voucher: "Bokføringsnummer (bilag)",
        evidence_stamp: "Stempel (dokument-ID)",
        evidence_invoice: "Fakturanummer",
        evidence_date: "Bokføringsdato",
        evidence_description: "Beskrivelse",
        evidence_amount: "Beløp (NOK)",
        evidence_record_id: "Post-ID",
        evidence_project: "Prosjekt",
        evidence_project_id: "Prosjekt-ID",
        evidence_assigned_sales: "Prosjektførte inntekter (NOK)",
        evidence_assigned_costs: "Prosjektførte kostnader (NOK)",
        evidence_assigned_net: "Resultat av prosjektførte poster (NOK)",
        evidence_tx_count: "Antall posteringer",
        evidence_note: "Periode / merknad",
        evidence_entity_type: "Type",
        evidence_entity_name: "Prosjekt / kunde",
        evidence_booked_sales: "Bokførte nettoinntekter (NOK)",
        invoice_registry_missing: "Mangler komplett fakturaregister med nummerserier og annulleringer; nummerrekkefølgen er ikke kontrollert.",
        vat_document_evidence_missing: "Mangler MVA-beløp og MVA-kode fra originaldokumentet; MVA er ikke kontrollert.",
        otp_period_unknown: "Perioden for OTP-kontrollen er ikke tilgjengelig.",
        audit_history_score: "Historisk score. Kjør en ny revisjon for å få en oppdatert vurdering.",
        audit_history_notice: "Funn fra utgåtte kontroller er skjult. Opprinnelig rapport, dokumentasjon og score er bevart; scoren er ikke beregnet på nytt.",
        vat_legacy_scope: "Den lagrede rapporten mangler terminopplysninger og Oppgaver-statuser. Historiske kontosaldoer er bevart. Kjør en ny revisjon; innholdet i MVA-meldingen er ikke kontrollert.",
        otp_period_scope: (year,from,to) => (year + ', kontrollmåneder OTP: ' + from + '-' + to + '.'),
        utbytte_change_unknown: 'Netto endring på 2800/2801 er ikke tilgjengelig; ingen konklusjon om betalinger.',
        mva_carried: "Saldo videreført fra forrige termin, fortsatt uavklart",
        duplicates_weak_title: "Like beløp i ulike bilag: svakt kontrollsignal",
        previous_balance_date_unknown: "dato for tidligere saldo ikke tilgjengelig",
        no_data: "Ingen data",
        evidence_no_monthly_breakdown: 'Rapporten inneholder ikke månedsfordeling',
        evidence_monthly_movements: 'Månedskolonnene viser netto bevegelser. Saldo (UB) viser saldo ved periodens slutt.',
        none: "Ingen",
        duplicates_evidence_desc: (all,strong,weak) => `${all} grupper med samme fakturanummer, identifisert motpart og lik fullstendig bokføring i ulike bilag. Ingen tilstrekkelig reversering ble funnet. Kontroller originaldokumentene før korrigering.`,
        bank_change_no_comparison: 'Mangler sammenligningsgrunnlag',
        bank_eom_observed: (negative,drops) => `1920, negative månedssluttsaldoer: ${negative}. Fall over 50 % fra forrige måned: ${drops}. Historiske hovedbokssaldoer, ikke dagens banksaldo.`,
        revisor_registered: (names, date) => `Registrert revisor i Brreg: ${names}. Lest: ${date}.`,
        revisor_empty: (date) => `Ingen registrert revisor i Brreg-svaret. Lest: ${date}.`,
        revisor_unknown: 'Kunne ikke bekrefte registrert revisor i Brreg. Manglende data betyr ikke at selskapet mangler revisor.',
        revisor_boundary: 'Opplysningen gjelder registeret ved avlesning, ikke historisk status i revisjonsperioden. Registrering bekrefter ikke at revisjonen er utført.',
        revisor_source: (source) => `Kilde: Brreg, registrerte roller (REVI). ${source}`,
        dividend_net_desc: (amount) => `Netto saldo på 2800/2801: ${amount} kr. Avstem vedtak, utbetalinger og omposteringer. Saldoen alene beviser ikke vedtatt eller ubetalt utbytte.`,

        selectSystem: 'Velg regnskapssystem',
        changeSystem: 'Bytt system',
        uploadFiles: 'Last opp filer',
        dropHere: 'Slipp filene her!',
        dragHere: 'Dra filene hit',
        filesDesc: 'Saldobalanse og Resultatrapport (CSV)',
        selectFromDisk: 'Velg fra disk',
        waitingSaldo: 'Venter på Saldobalanse...',
        waitingResultat: 'Venter på Resultatrapport...',
        runAuditBtn: 'Kjør revisjon',
        auditResult: 'Revisjonsresultat',
        collapse: 'Skjul',
        expand: 'Vis',
        fullPreview: 'Full visning',
        newFiles: 'Nye filer',
        exportData: 'Eksporter behandlede data:',
        zipAll: 'ZIP (Alle)',
        generatingPdf: 'Genererer PDF...',
        downloadPdf: 'Last ned rapport (PDF)',
        noErrors: 'Ingen ekstra feil funnet!',
        dataPreviewTitle: 'Fullstendig datavisning',
        tabSaldo: 'Saldobalanse',
        tabResultat: 'Resultatrapport',
        searchAccount: 'Søk etter konto...',
        account: 'Konto',
        accountName: 'Navn',
        change: 'Endring',
        sum: 'Sum',
        saldoUB: 'Saldo (UB)',
        currentIb: 'IB i år',
        previousUb: 'UB i fjor',
        diff: 'Differanse',
        month: 'Måned',
        sumVertical: 'Sum (Vertikal)',
        status: 'Status',
        algoStatus: 'Algoritmestatus',
        retired: 'Avgang/Null',
        noDepreciation: 'MANGLER AVSKRIVNING',
        deprAccumulated: 'OK (samlet avskr.)',
        newPurchase: 'Nytt kj\u00f8p?',
        investment: 'Investering (+)',
        wrongSign: 'FEIL FORTEGN',
        noResultsFor: 'Ingen resultater for',
        errorOccurred: 'Det oppstod en feil',
        errorDesc: 'Applikasjonen fikk et uventet problem. Oppdater siden og prøv igjen.',
        refreshPage: 'Oppdater siden',
        sumLabel: 'SUM',
        sumAccounts5xxx: 'Sum kontoer 5000-5999',
        positive: 'positiv',
        negative: 'negativ',
        subtitle_home: 'Automatisk revisjon av norsk regnskap',
        label_system: 'System',
        label_score: 'Poengsum',
        label_total: 'Totalt',
        label_analyzing: 'Analyserer...',
        label_active_clients: 'aktive klienter',
        label_audit_done: (name) => `Revisjon fullf\u00f8rt: ${name}`,
        label_dark_mode: 'Mørk modus',
        label_light_mode: 'Lys modus',
        label_saldo_csv: 'Saldobalanse (CSV)',
        label_resultat_csv: 'Resultatrapport (CSV)',
        label_missing_key: 'Oppgi b\u00e5de URL og API-n\u00f8kkel.',
        label_disabled_rules: (n) => `${n} regler deaktivert \u2014 vurderingen kan v\u00e6re ufullstendig.`,
        // Toasts
        toast_file_too_big: (name, sizeMB) => `Filen "${name}" overskrider grensen på 10 MB (${sizeMB} MB).`,
        toast_bad_mime: (name, mime) => `Ikke-støttet filformat "${name}" (${mime}). Godkjent: CSV, XLS, XLSX.`,
        toast_excel_error: (name, msg) => `Feil ved Excel-konvertering (${name}): ${msg}`,
        toast_unknown_type: (name, sysName) => `Kunne ikke gjenkjenne filtypen: "${name}". Sjekk at du valgte riktig system (${sysName}).`,
        toast_parse_error: (name, msg) => `Feil ved parsing av ${name}: ${msg}`,
        toast_no_accounts: (name, sysName) => `Ingen kontoer funnet i "${name}". Sjekk system (${sysName}) og filformat.`,
        toast_loaded: (type, count, name) => `${type === 'saldo' ? 'Saldobalanse' : 'Resultatrapport'}: lastet ${count} kontoer fra "${name}"`,
        toast_missing_saldo: 'Advarsel: Saldobalanse mangler — balanserevisjonen utføres ikke. Resultatet kan være ufullstendig.',
        toast_missing_resultat: 'Advarsel: Resultatrapport mangler — resultatanalysen utføres ikke. Resultatet kan være ufullstendig.',
        toast_no_data: 'Ingen data å laste ned. Last opp filer først.',
        toast_no_data_type: (type) => `Ingen data for ${type}. Last opp riktig fil først.`,
        toast_pdf_ok: 'PDF generert.',
        toast_pdf_error: 'Feil ved PDF-generering.',
        toast_zip_error: 'Kunne ikke opprette ZIP-arkiv.',
        toast_header_missing: 'Mangler header',
        // Audit rules
        rule_financial_profit: 'Finansielt resultat: OVERSKUDD',
        rule_financial_loss: 'Finansielt resultat: UNDERSKUDD',
        rule_financial_desc: (amount) => `Totalresultat: ${amount}.`,
        rule_neg_assets: 'Negativ saldo eiendeler (1xxx)',
        rule_neg_assets_desc: "Negative saldoer på de markerte 1xxx-kontoene må avklares ut fra kontotype og posteringer.",
        rule_1580_title: 'Konto 1580 — tapsavsetning',
        rule_1580_desc: 'Konto 1580 viser saldo (tapsavsetning). Verifiser fordringens status:\n\n\u2022 Er det sendt purring/inkassovarsel?\n\u2022 B\u00f8r tapet overf\u00f8res til konstatert tap?\n\u2022 Har debitor g\u00e5tt konkurs, eller er tapet kun sannsynliggjort?',
        rule_pos_liabilities: 'Positiv saldo gjeld (2xxx)',
        rule_pos_liabilities_desc: 'Gjeldskontoer har normalt negativ saldo (kredit), men enkelte 2xxx-kontoer kan v\u00e6re unntak. Sjekk om saldoen skyldes korrekt kontotype eller feil periodisering/klassifisering.',
        rule_pos_liabilities_payroll_bridge: 'Lønnssystem: 2780/2785 overgang',
        rule_pos_liabilities_payroll_bridge_desc: 'Positiv saldo på 2780/2785 kan skyldes overgang mellom lønnssystemer eller manglende inngående balanse. Kontroller sammenheng mot 2785 fra forrige år før punktet behandles som feil.',
        rule_pos_liabilities_periodization: 'Periodiseringskonto 29xx med debetsaldo',
        rule_pos_liabilities_periodization_desc: '29xx-kontoen har positiv saldo. Dette kan være midlertidig periodisering som reverseres i neste periode, så punktet er kun til orientering med mindre saldoen blir stående.',
        rule_high_1571: 'H\u00f8y saldo 1571',
        rule_high_1571_desc: 'Saldo over 50 000 NOK. Krever verifisering.',
        rule_high_1370: 'H\u00f8y saldo 1370',
        rule_high_1370_desc: 'Saldo over 50 000 NOK p\u00e5 konto 1370 (fordringer p\u00e5 eiere). B\u00f8r dokumenteres \u2014 sjekk l\u00e5neavtale.',
        rule_7100: 'Kilometergodtgj\u00f8relse (7100)',
        rule_7100_desc: (amount, hasLonnSystem) => `Bel\u00f8p: ${amount}\n\nSjekk f\u00f8lgende:\n\u2022 Finnes det kj\u00f8rebok? (dato, strekning, form\u00e5l, km)\n\u2022 Er satsen korrekt? (maks 3,50 kr/km f\u00f8rste 10 000 km)\n${hasLonnSystem ? '\u2714 Selskapet har l\u00f8nnssystem \u2014 verifiser at 7100 er innrapportert via A-melding (opplysningspliktig ytelse).' : '\u26a0 Selskapet mangler l\u00f8nnssystem (5000/2600) \u2014 kan ikke verifisere A-melding. Sjekk om godtgj\u00f8relsen er korrekt rapportert.'}`,
        rule_6301_no_rent: 'Fradrag (6301) uten husleie (6300)',
        rule_6301_no_rent_desc: 'Det er bokf\u00f8rt fradrag for bolig, men ingen husleiekostnad.',
        rule_6301_high: 'Fradrag h\u00f8yere enn husleie (6301 > 6300)',
        rule_6301_high_desc: 'Selskapet viser gevinst p\u00e5 personalbolig.',
        rule_7791_7799: 'Konflikt 7791 og 7799',
        rule_7791_7799_desc: 'Begge kontoer er brukt samtidig. Velg \u00e9n.',
        rule_high_7791: 'H\u00f8y saldo 7791',
        rule_high_7791_desc: 'Over 30 000 NOK.',
        rule_4000_4300: 'Konflikt Handel/Produksjon',
        rule_4000_4300_desc: 'Varekonto (4000) og produksjonskonto (4300) er brukt samtidig. Anbefales \u00e5 skille.',
        rule_amort_12xx: 'Analyse av avskrivninger (12xx)',
        rule_amort_12xx_desc: 'Sammenligning av bokførte eiendeler og avskrivninger; anleggsregisteret er ikke kontrollert.',
        rule_amort_system_error: 'Systemfeil avskrivninger',
        rule_amort_system_error_desc: 'Det finnes eiendeler, men ingen bokf\u00f8ringer p\u00e5 avskrivningskontoer (60xx). Merk: ved revisjon for deler av \u00e5ret kan avskrivninger bokf\u00f8res ved \u00e5rsoppgj\u00f8r.',
        rule_amort_partial_missing: 'Avskrivninger mangler i delperiode',
        rule_amort_partial_missing_desc: 'Det finnes anleggsmidler, men ingen bokf\u00f8ringer p\u00e5 avskrivningskontoer (60xx) i denne delperioden. Dette kan v\u00e6re korrekt hvis avskrivninger bokf\u00f8res ved \u00e5rsoppgj\u00f8r, men b\u00f8r sjekkes.',
        rule_wrong_sign_costs: 'Kostnader med motsatt fortegn (4xxx-7xxx)',
        rule_wrong_sign_costs_desc: (sysName, expected) => `For ${sysName} sammenligner kontrollen kostnadssummens fortegn med konvensjonen i konfigurasjonen (${expected}). Et annet fortegn krever kontroll av rapportkonvensjon og posteringer; det alene bekrefter ikke en feil.`,
        rule_anomalies_6xxx: 'Anomalier i kostnader (6xxx)',
        rule_anomalies_6xxx_desc: "De markerte månedene har verdier på 0 eller beløp som avviker fra månedsgjennomsnittet. Dette er et sammenligningssignal, ikke en bekreftet bokføringsfeil.",
        rule_high_6540: 'H\u00f8yt utstyrskj\u00f8p (6540)',
        rule_high_6540_desc: 'Enkeltbilag/postering p\u00e5 6540 overstiger 30 000 NOK. Verifiser om kostnaden b\u00f8r aktiveres som anleggsmiddel.',
        rule_salary_sign: 'Lønn: månedssum 5xxx til avklaring',
        rule_salary_sign_desc: 'Månedssummen på kontoer 5000-5999 har motsatt fortegn av kostnadskonvensjonen. Dette er et kontrollsignal, ikke en bekreftet feil. Kontroller kontoene og de markerte månedene.',
        rule_missing_5920: 'Manglende yrkesskadeforsikring (5920)',
        rule_missing_5920_desc: 'Det er bokf\u00f8rt l\u00f8nn (konto 5000), men mangler yrkesskadeforsikring p\u00e5 konto 5920. Yrkesskadeforsikring er p\u00e5lagt.',
        rule_skattetrekk: 'Skattetrekk: mangler forskuddstrekk (2600)',
        rule_skattetrekk_desc: 'Selskapet utbetaler l\u00f8nn (konto 5000), men konto 2600/26xx vises ikke i rapporten. Sjekk om forskuddstrekk er beregnet og betalt sammen med l\u00f8nnen. Hvis det er avstemt, merk punktet Sjekket.',
        rule_aga: 'Arbeidsgiveravgift: mangler AGA (5400)',
        rule_aga_desc: 'Selskapet utbetaler l\u00f8nn (konto 5000), men beregner ikke arbeidsgiveravgift (konto 5400). AGA er p\u00e5lagt ved l\u00f8nnsutbetaling.',
        rule_feriepenger: 'Feriepenger: mangler avsetning',
        rule_feriepenger_desc: 'Selskapet utbetaler l\u00f8nn (konto 5000), men avsetter ikke feriepenger (konto 5020/5021/5090-5093/5210/5211). Feriepenger = 10,2 % (12 % for 60+) av l\u00f8nn.',
        rule_otp: "OTP: pensjonskostnad i forhold til lønn",
        rule_otp_desc: "Forholdet mellom pensjonskostnad og lønn er et kontrollsignal, ikke en beregning av plikt eller restanse.",
        rule_balanse_error: 'Balansekontroll: eiendeler \u2260 gjeld',
        rule_balanse_error_desc: (sumA, sumP, diff) => `Sum eiendeler (1xxx): ${sumA}\nSum gjeld (2xxx): ${sumP}\nDifferanse: ${diff}\n\nEiendeler + Gjeld skal summeres til 0. Avvik kan skyldes manglende inng\u00e5ende balanse (IB/tilleggspostering) eller bokf\u00f8ringsfeil.`,
        rule_balanse_partial: 'Balansekontroll: mangler full rapportsum',
        rule_balanse_partial_desc: (sumA, sumP, diff) => `API-sum eiendeler (1xxx): ${sumA}\nAPI-sum gjeld/egenkapital (2xxx): ${sumP}\nDifferanse etter resultat: ${diff}\n\nGetAggregated-data fra API-et inneholder ikke alltid samme totalsum som balanserapporten, f.eks. "Sum egenkapital og gjeld". Dette er et datagrunnlag-signal, ikke en bokforingsfeil, og trekker ikke score.`,
        rule_balanse_ok: 'Balansekontroll: OK',
        rule_balanse_ok_desc: (sumA, sumP) => `Eiendeler (${sumA}) + Gjeld (${sumP}) = balanse OK.`,
        rule_neg_equity: 'Negativ egenkapital (konto 2050)',
        rule_neg_equity_desc: (amount) => `Egenkapital er positiv (${amount}) \u2014 dette betyr at selskapet har tapt egenkapitalen.\nHandleplikt jf. aksjeloven \u00a7 3-4: styret m\u00e5 iverksette tiltak.`,
        rule_kasse_neg: 'Kassekonto 1900: negativ saldo',
        rule_kasse_neg_desc: (amount) => `Kassesaldo: ${amount}. Negativt kassesaldo er fysisk umulig \u2014 du kan ikke ha mindre enn 0 NOK i kassen. Det mangler sannsynligvis bilag eller det er en bokf\u00f8ringsfeil.`,
        rule_mva: 'MVA-avstemming: netto MVA-posisjon',
        rule_mva_desc: (utg, inn, netto) => `Utg\u00e5ende MVA (2700-2709): ${utg}\nInng\u00e5ende MVA (2710-2719): ${inn}\nNetto MVA-posisjon: ${netto}\n\nNetto MVA b\u00f8r v\u00e6re tiln\u00e6rmet 0 n\u00e5r alle terminer er innrapportert og betalt.`,
        rule_mva_period: 'MVA-periodekontroll',
        rule_mva_period_desc: (month) => 'Hver termin viser innsendingsstatus fra Oppgaver og saldo på MVA-kontoene. Restsaldo må avstemmes, men beviser ikke i seg selv at poster mangler i meldingen.',
        mva_balance_latest: (month) => 'saldo ved ' + month,
        mva_balance_since: (from, to) => 'samme saldo ved terminslutt fra ' + from + ' til ' + to,
        rule_mva_period_ok: 'Ingen nye, uforklarte restsaldoer funnet i den kontrollerte hovedboken.',
        rule_bil: 'Privat bruk av bil: mangler korreksjon (7099)',
        rule_bil_desc: 'Selskapet har bilkostnader (konto 7000), men ingen korreksjon for privat bruk (konto 7099). Korreksjon er p\u00e5lagt dersom bilen brukes privat.',
        rule_period_label: 'Periodisering: store bel\u00f8p i siste m\u00e5ned',
        rule_period: (month, accId) => `Periodisering: stor sum i ${month} p\u00e5 konto ${accId}`,
        rule_period_desc: (accId, accName, month, amount, avg) => `Konto ${accId} (${accName}): bel\u00f8p i ${month} = ${amount}, gjennomsnitt \u00f8vrige m\u00e5neder = ${avg}.\n\n${month} > 3\u00d7 gjennomsnitt \u2014 sjekk om kostnaden b\u00f8r periodiseres.`,
        rule_kundefordringer: 'Kundefordringer vs omsetning: h\u00f8yt niv\u00e5',
        rule_kundefordringer_desc: (kf, oms, pct) => `Kundefordringer (1500): ${kf}\nOmsetning (3xxx): ${oms}\nForhold: ${pct}%\n\nKundefordringer utgj\u00f8r over 25 % av omsetningen. Sjekk inkassostatus og tapsavsetning.`,
        rule_revisjon: 'Revisjonsplikt: ingen registrert revisor',
        rule_revisjon_fravalg_mulig: 'Registrert revisor: mulig fravalg må avklares',
        rule_revisjon_fravalg_mulig_desc: (income, assets, year) => `Selskapet har registrert revisor. Tallene fra siste hele regnskapsår (${year}) er under beløpsgrensene i aksjeloven § 7-6: driftsinntekter for samlet virksomhet ${income} (< 7 000 000 kr), balansesum ${assets} (< 27 000 000 kr). Avklar at grunnlaget er siste årsregnskap. AUDYTOR kontrollerer ikke vilkåret om gjennomsnittlig høyst 10 årsverk (≤ 10). For morselskap gjelder vilkårene for konsernet samlet. Fravalg er ikke mulig dersom annen lov krever revisjon. Det kreves beslutning i generalforsamling og registrering i Foretaksregisteret. Dette er et signal til samtale med kunden, ikke en anbefaling om fravalg. Denne informasjonen vises én gang i året (kontroll av perioden til og med september).`,
        action_revisjon_fravalg_mulig: 'Drøft med kunden; avklar siste årsregnskap, årsverk, konsern og øvrige revisjonskrav før eventuell beslutning og registrering.',
        rule_revisjon_desc: (year, income, assets, auditYear) => `Årsregnskapet for ${year} viser driftsinntekter ${income} og balansesum ${assets} (grenser for fravalg: driftsinntekter under 7 000 000 kr og balansesum under 27 000 000 kr). Årsregnskapet for ${auditYear} er derfor revisjonspliktig etter aksjeloven § 7-6 tredje ledd. Ingen revisor er registrert i Brreg. Styret skal uten opphold innkalle til generalforsamling for valg av revisor og melde valget til Foretaksregisteret (§ 7-6 syvende ledd). AUDYTOR kontrollerer ikke vilkåret om gjennomsnittlig høyst 10 årsverk.`,
        // Nye regler v17
        rule_skattetrekk_bank: 'Skattetrekk: bankkonto (1950) \u2260 gjeld (2600)',
        rule_skattetrekk_bank_desc: (bank, gjeld, diff) => `Bankkonto skattetrekk (1950): ${bank}\nSkyldig skattetrekk (2600): ${gjeld}\nDifferanse: ${diff}\n\nSelskapet setter ikke av nok midler til skattetrekk. Konto 1950 skal dekke forpliktelsen p\u00e5 2600.`,
        rule_likviditet: 'Likviditetsgrad under 1,0',
        rule_likviditet_desc: (ratio, om, kg) => `Likviditetsgrad: ${ratio}\nOml\u00f8psmidler: ${om}\nKortsiktig gjeld: ${kg}\n\nSelskapet kan ha problemer med \u00e5 betale kortsiktige forpliktelser. Anbefalt: > 1,5.`,
        rule_levgjeld: 'H\u00f8y leverand\u00f8rgjeld vs varekj\u00f8p',
        rule_levgjeld_desc: (lev, varekjop, pct) => `Leverand\u00f8rgjeld (2400): ${lev}\nVarekj\u00f8p (4xxx): ${varekjop}\nForhold: ${pct}%\n\nLeverand\u00f8rgjeld utgj\u00f8r over 40 % av \u00e5rlige varekj\u00f8p. Sjekk om det er forfalte fakturaer.`,
        rule_husleie: 'Husleie: uregelm. m\u00e5nedsbelastning',
        rule_husleie_desc: (accId, accName, months) => `Konto ${accId} (${accName}):\n${months}\n\nHusleie b\u00f8r v\u00e6re jevn m\u00e5nedlig. Store avvik kan bety feil bokf\u00f8ring eller manglende periodisering.`,
        rule_prior_year_not_closed: 'Fjoråret er ikke avsluttet til null',
        rule_prior_year_not_closed_desc: (remainder, disposition) => `Rest etter disponering: ${remainder}\nBokført disponering (88xx-89xx): ${disposition}\n\nÅrsresultatet for fjoråret er disponert, men resultatkontoene 3000-8999 summerer ikke til null. Resten står igjen i resultatet.`,
        prior_year_remainder_row: 'Rest av fjorårets resultat etter disponering',
        rule_neg_bank: 'Negativ banksaldo (1920-1999)',
        rule_neg_bank_desc: (amount) => `Banksaldo: ${amount}\n\nNegativ banksaldo betyr kassekreditt. Verifiser:\n\u2022 Har selskapet kassekredittavtale?\n\u2022 Er renten bokf\u00f8rt korrekt (konto 8150)?`,
        rule_aksjonaerlan: 'Fordringssaldo på 1370: avklar motpart',
        rule_aksjonaerlan_desc: (amount) => `Debetsaldo 1370: ${amount}. Beløpet overstiger kontrollens tekniske grense 50 000 NOK, ikke en skattegrense. Kontoen alene identifiserer ikke låntaker. Kontroller motpart, bilag og avtale. Hvis dette er lån til personlig aksjonær, vurder skattereglene og aktuelle unntak ut fra datoer og beløp.`,
        rule_utbytte_2800: 'Saldo på 2800/2801',
        rule_utbytte_2800_desc: (amount) => `Avsatt utbytte: ${amount}\n\nUtbytte er vedtatt men ikke utbetalt. Sjekk:\n\u2022 N\u00e5r ble utbyttet vedtatt?\n\u2022 Er det innenfor fri egenkapital?\n\u2022 Er skattetrekk (konto 5900) vurdert?`,
        rule_no_accountant: 'Mangler regnskapsf\u00f8rer (6705)',
        rule_no_accountant_desc: 'Ingen bokf\u00f8ring p\u00e5 konto 6705 (Honorar regnskap). Hvem f\u00f8rer regnskapet? Hvis selskapet f\u00f8rer selv, verifiser kompetanse og rutiner.',
        rule_lonn_aga: 'L\u00f8nn vs AGA: mistenkelig avvik',
        rule_lonn_aga_desc: (lonn, aga, pct) => `L\u00f8nn (5000+5020): ${lonn}\nAGA (5400): ${aga}\nAGA-andel: ${pct}%\n\nForventet AGA: 0\u201314,1 % avhengig av sone. Avviket er utenfor normalomr\u00e5det.`,
        // Settings
        settingsTitle: 'Revisjonsregler',
        settingsDesc: 'Sl\u00e5 av/p\u00e5 regler for auditen. Innstillinger lagres automatisk.',
        settingsAllSystems: 'Alle systemer',
        settingsRulesActive: (on, total) => `${on} av ${total} regler aktive`,
        settingsEnableAll: 'Aktiver alle',
        settingsDisableAll: 'Deaktiver alle',
        settingsBack: 'Tilbake',
        settingsCategory_financial: '\u00d8konomisk resultat',
        settingsCategory_balance: 'Balanse (Saldo)',
        settingsCategory_result: 'Resultatrapport',
        settingsCategory_compliance: 'L\u00f8nn & compliance',
        settingsCategory_analysis: 'Analyse & periodisering',
        rulesDisabledBanner: (count) => `${count} regler deaktivert`,
        // Scoring
        rule_scoring_title: (score) => `Samlet vurdering: ${score}/10`,
        rule_scoring_desc: (errors, warnings, infos) => `Høyt prioriterte varsler: ${errors} • Advarsler: ${warnings} • Informasjon: ${infos}\n\nResultat av screening av tilgjengelige data. Varsler må avklares; resultatet bekrefter verken regnskapsfeil eller at regnskapet er korrekt.`,
        // localStorage
        loadLastAudit: 'Last inn forrige revisjon',
        lastAuditInfo: (sysName, date) => `${sysName} \u2014 ${date}`,
        toast_last_loaded: 'Forrige revisjon lastet inn.',
        // === PIRAMIDA WARTOŚCI: Verdict & Tier & Category UI ===
        verdict_excellent: 'Høy score i kontrollene som er utført. Se eventuelle funn nedenfor.',
        verdict_good: 'Høy score; gjennomgå åpne funn. Scoren bekrefter ikke at regnskapet er korrekt.',
        verdict_acceptable: 'Flere funn krever avklaring før eventuell korrigering.',
        verdict_needs_fix: (n) => `${n} høyt prioriterte funn krever avklaring. Bekreft årsaken før korrigering.`,
        verdict_critical: 'Lav score: prioriter avklaring av funnene og korriger bekreftede feil.',
        tier_critical: 'Høy prioritet: avklar',
        tier_check: 'Bør sjekkes',
        tier_info: 'Til orientering',
        tier_passed: 'Ingen avvik',
        summary_title: 'Oppsummering for regnskapsfører',
        summary_fix: 'Høy prioritet:',
        summary_check: 'Bør sjekkes:',
        summary_ok: "Ingen åpne feil eller varsler i kontrollert omfang. Se også kontrollsignaler og kontroller som ikke er utført nedenfor.",
        summary_copy: 'Kopier oppsummering',
        summary_copied: 'Kopiert!',
        action_label: 'Hva bør gjøres:',
        // Kontrakt karty (11.10.2026): dlaczego, sjekket for deg, pewność.
        card_why_label: 'Hvorfor det kan være et problem',
        card_verified_label: 'Sjekket for deg',
        confidence_confirmed: 'Bekreftet avvik',
        confidence_open: 'Til avklaring',
        confidence_info: 'Til orientering',
        period_end_generic: 'periodens slutt',
        rule_neg_assets_desc_at: (date) => `Negative saldoer på de markerte 1xxx-kontoene per ${date} må avklares. Kolonnen Endring gjelder perioden; fortegnet alene bekrefter ikke en feil.`,
        neg_assets_why: "Fortegnet alene forklarer ikke årsaken til saldoen og bekrefter ikke en feil. Kontroller kontotype, posteringer og dokumentasjon før en eventuell korrigering.",
        neg_assets_mirror: (a, b, amt) => `${a} og ${b} har samme beløp med motsatt fortegn (${amt}). Dette angir kontoer som bør sammenlignes; det bekrefter ikke at posteringene hører sammen eller er feil. Kontroller dokumentene før en eventuell ompostering.`,
        neg_assets_no_mirror: 'Ingen konto i samme gruppe har motsatt beløp; speilposten er ikke funnet automatisk.',
        wrong_sign_transfer_note: (account, refs, amount) => `Konto ${account}: I tilgjengelige posteringer for bilag ${refs} er ${amount} NOK overført til andre kostnadskontoer. Dette forklarer en del av de negative posteringene, men bekrefter ikke at klassifiseringen er korrekt.`,
        wrong_sign_why: 'Motsatt fortegn kan skyldes en korreksjon, ompostering, reversering av en avsetning eller en feil. Årsaken må avklares ut fra tilknyttede posteringer og dokumenter.',
        wrong_sign_provision_first_month: (acc, month) => `${acc} negativ bare i ${month}: oppløsning av avsetning fra 31.12 forrige år, ikke flagget.`,
        rule_neg_bank_desc_at: (amount, date) => `Banksaldo per ${date}: ${amount}\n\nNegativ banksaldo betyr kassekreditt. Verifiser:\n• Har selskapet kassekredittavtale?\n• Er renten bokført korrekt (konto 8150)?`,
        neg_bank_why: 'Saldoen er bokført saldo ved periodens slutt, ikke bankens; et minus som forsvinner første dag i neste måned er timing, et varig minus er kassekreditt eller manglende bokføring.',
        bank_last_entry: (acc, date, end) => `Siste postering på ${acc}: ${date}; perioden slutter ${end}. Avstemming mot kontoutskrift er ikke gjort her.`,
        bank_last_entry_nodate: (acc, date) => `Siste postering på ${acc}: ${date}. Avstemming mot kontoutskrift er ikke gjort her.`,
        bank_last_entry_none: (acc) => `Ingen posteringer på ${acc} i de hentede transaksjonene.`,
        bank_last_entry_unknown: 'Siste posteringsdato på bankkontoen er ikke tilgjengelig uten transaksjoner.',
        duplicates_why: 'Kontrollen krever samme faktura, motpart og fullstendig balansert bilag. Like beskrivelser eller gebyrbeløp alene tas ikke med.',
        duplicates_netted: (v, i) => `Fjernet før paring: ${v} bilag som nuller seg selv og ${i} fakturaer der storno og ny bokføring etterlater én kopi.`,
        duplicates_nothing_netted: 'Ingen storno eller selvnullende bilag funnet blant kandidatene.',
        invoice_gap_why: 'Hull i fakturanummerrekken kan være fakturaer bokført i neste periode, kreditnotaer eller slettede utkast; bare et nummer som ikke finnes noe sted er en mangel.',
        invoice_gap_checked: 'Numre som finnes i andre år eller på kundefordringer (1500) er trukket fra. Neste måned er ikke hentet, så numre bokført etter periodens slutt vises fortsatt som hull.',
        project_pnl_no_conflicts: 'ingen',
        project_pnl_allocation_note: (sales,costs,conflicts) => `Ufullstendig prosjektfordeling: inntekter uten prosjekt ${sales} NOK, kostnader uten prosjekt ${costs} NOK. Ulike navn med samme ID: ${conflicts}. Tabellen viser bare prosjektførte poster og bekrefter ikke tap eller lønnsomhet. Informasjon uten poengtrekk.`,
        project_pnl_why: 'Et prosjekt med kostnader uten salg i perioden er enten fakturert i en annen periode, feil allokert eller reelt ulønnsomt; datoene viser hvor lenge prosjektet har hatt posteringer.',
        project_pnl_span: (from, to) => `posteringer ${from}–${to}`,
        project_pnl_span_note: 'Datoer per prosjekt er første og siste postering i den kontrollerte perioden, ikke prosjektets start og slutt.',
        project_pnl_prior_checked: (year) => `Prosjekter som fantes i ${year} er skilt ut; de står ikke på listen med mindre omsetningen er over terskelen.`,
        amort_why: 'Avklar tilgang, avgang, brukstid og avskrivningsplan i anleggsregisteret. Full avskrivning betyr ikke at eiendelen skal avhendes.',
        amort_depr_in_period: (sum) => `Avskrivninger (60xx) bokført i perioden: ${sum}.`,
        amort_no_depr: 'Ingen avskrivninger (60xx) bokført i perioden.',
        otp_why: 'Pensjonskostnad og lønn kan ha ulikt grunnlag og periodisering. Forholdstallet er bare et kontrollsignal.',
        otp_ratio_ok: (ratio) => `Bokført forholdstall: ${ratio} %. Over referansen 2 %, men ansattgrunnlag og oppfylt OTP-plikt er ikke bekreftet.`,
        otp_ratio_low: (ratio) => `Bokført forholdstall: ${ratio} %, under referansen 2 %. Dette beregner ikke en restanse.`,
        utbytte_why: 'Debet- og kreditsaldo kan ha ulike årsaker. Avklar vedtak, utbetalinger og omposteringer på bilagene.',
        dividend_net_desc_at: (amount, date) => `Netto saldo på 2800/2801 per ${date}: ${amount} kr. Avstem vedtak, utbetalinger og omposteringer. Saldoen alene beviser ikke vedtatt eller ubetalt utbytte.`,
        utbytte_unpaid: (date) => `Ingen netto endring på 2800/2801 i kontrollperioden fram til ${date}. Dette utelukker ikke betaling og ny avsetning med samme beløp.`,
        utbytte_unpaid_period: 'Ingen netto endring på 2800/2801 i kontrollperioden. Bilagene må avklare eventuelle betalinger.',
        utbytte_moved: (amt) => `Bevegelse på 2800/2801 i perioden, netto ${amt}; hva som er utbetalt og hva som er ompostert, må leses av bilagene.`,
        salary_why: 'Endringer kan skyldes feriepenger, bonus, bemanning, etterbetaling eller periodisering. Årsaken må avklares på bilagene.',
        rule_salary_periodisering_desc_months: (list) => `Sum personalkostnader (5xxx) endrer seg over 50 % mellom måneder: ${list}.`,
        reverse_period_why: 'Periodisering kan gjelde flere måneder og dokumenter. Saldoen må knyttes til bilag før årsaken kan fastslås.',
        rule_reverse_period_desc_plain: (movement, balance, date) => `Netto bevegelse på 3009 i perioden: ${movement}. Saldo på 1530 per ${date}: ${balance}. Fortegn og saldo alene viser ikke om en bestemt periodisering er reversert. Kontroller bilag og fakturering.`,
        reverse_period_pair: (acc,a,b) => `1530 (${a}) og ${acc} (${b}) har motsatte saldoer. Beløpslikhet alene beviser ikke at bilagene hører sammen eller er feilført.`,
        reverse_period_no_pair: 'Ingen speilkonto med motsatt beløp i 153x.',
        score_breakdown: 'Poengberegning (% bestått)',
        category_breakdown: 'Detaljer per kategori',
        category_label_compliance: 'Lønn & compliance',
        category_label_balance: 'Balanse',
        category_label_financial: 'Økonomisk resultat',
        category_label_result: 'Resultatrapport',
        category_label_analysis: 'Analyse & periodisering',
        col_category: 'Kategori',
        col_weight: 'Vekt',
        col_errors: 'Feil',
        col_warnings: 'Advarsler',
        col_deduction: 'Resultat',
        col_passed: 'Bestått',
        passed_rules_label: 'bestått',
        show_details: 'Vis detaljer',
        hide_details: 'Skjul detaljer',
        // === Actions per rule (directed TO accountant) ===
        action_neg_assets: "Avstem de markerte 1xxx-kontoene med dokumentasjon og kontotype. Forklar den negative saldoen; korriger bare når en feil er bekreftet.",
        action_acc_1580: 'Vurder om fordringen bør avskrives som konstatert tap, eller om inkassosteg bør igangsettes.',
        action_pos_liabilities: 'Sjekk om gjeldskontoen faktisk skal kunne ha debetsaldo, eller om det skyldes feil periodisering/klassifisering.',
        action_high_1571: 'Avstem konto 1571 mot faktiske fordringer. Vurder om saldo bør bokføres om.',
        action_high_1370: 'Sjekk om fordringen til eier bør innrapporteres som lønn/utbytte. Skatteplikt vurderes.',
        action_mileage_7100: 'Sjekk kjørebok (dato, strekning, formål, km). Verifiser sats og A-melding.',
        action_rent_6301: 'Sjekk at husleie (6300) er bokført. Fradrag uten husleie er feil.',
        action_conflict_7791_7799: 'Velg én av kontoene 7791 eller 7799 og ombokfør den andre.',
        action_conflict_4000_4300: 'Skill varekonto (4000) fra produksjonskonto (4300) — velg riktig klassifisering.',
        action_amortization_12xx: 'Verifiser anleggsmidler og at avskrivninger (60xx) er korrekt bokført.',
        action_balance_control: 'Finn differansen mellom eiendeler og gjeld. Sjekk alle posteringer.',
        action_neg_equity_2050: 'Handlingsplikt jf. aksjeloven § 3-4. Styret må iverksette tiltak.',
        action_negative_cash_1900: 'Sjekk kassekonto for manglende bilag eller feilbokføringer.',
        action_mva_reconciliation: 'Avstem MVA-kontoer mot innsendte MVA-meldinger.',
        action_mva_period_check: 'Sammenlign saldoene i tabellen med bokføringen av MVA-oppgjøret. Innsendingsstatus vises separat fra Oppgaver.',
        action_private_car_7000: 'Bokfør korreksjon for privat bruk av bil (7099).',
        action_wrong_sign_costs: 'Avklar kreditnota, reversering eller feil. Korriger bare når feilføringen er bekreftet.',
        action_anomalies_6xxx: "Sammenlign de markerte månedene med dokumentasjon, rapportperiode og virksomhetens aktivitet. Avklar om variasjonen følger fakturering, periodisering eller endret aktivitet.",
        action_high_6540: 'Vurder bilaget/posteringen over 30 000 NOK og om det bør aktiveres som anleggsmiddel.',
        action_salary_sign: 'Avstem de markerte månedene mot lønnsgrunnlag, periodisering og kreditnotaer for pensjon. Fortegnet alene begrunner ikke en korreksjon.',
        action_missing_5920: 'Bokfør yrkesskadeforsikring (5920) hvis den finnes. Hvis klienten mangler forsikring eller må avklare, bruk Til klient med kort notat.',
        action_skattetrekk: 'Sjekk konto 2600 — sørg for at forskuddstrekk beregnes ved lønnsutbetaling.',
        action_aga_5400: 'Bokfør arbeidsgiveravgift (5400) — pålagt ved lønnsutbetaling.',
        action_feriepenger: 'Bokfør feriepenger (5210/5211) — 10,2 % av lønn (12 % for 60+).',
        action_otp_5930: 'Avklar hvilke ansatte som omfattes av OTP-plikt, og sammenlign med avtalen. Kontroller grunnlag, perioder, fakturaer og premiefond.',
        action_periodisering: 'Sjekk om store beløp bør periodiseres over flere måneder.',
        action_kundefordringer_vs_omsetning: 'Sjekk inkassostatus og vurder tapsavsetning for utestående fordringer.',
        action_revisjonsplikt: 'Avklar valg av revisor og melding til Foretaksregisteret med kunden.',
        action_skattetrekk_bank: 'Avstem skattetrekk-bankkonto (1950) mot skyldig skattetrekk (2600).',
        action_likviditetsgrad: 'Vurder likviditeten — kortsiktig gjeld overskrider omløpsmidler.',
        action_leverandorgjeld_ratio: 'Sjekk om det er forfalte fakturaer. Vurder betalingsplan.',
        action_husleie_consistency: 'Sjekk uregelmessigheter i husleie — bør være jevn månedlig.',
        action_negativ_bank: "Avstem den negative hovedbokssaldoen mot kontoutskrift og bankdokumentasjon. Avklar årsaken og eventuelle omposteringer; saldoen alene viser ikke om en kredittavtale finnes.",
        action_prior_year_not_closed: 'Sjekk årsoppgjørsbilagene for fjoråret: beløp, fortegn, dobbeltføring og kostnader bokført etter disponeringen.',
        action_aksjonaerlan_skatt: 'Identifiser motpart og grunnlag før eventuell vurdering av aksjonærlån.',
        action_utbytte_2800: 'Avstem vedtak og betalinger. Vurder skatt ut fra mottaker og transaksjon, ikke kontosaldo alene.',
        action_no_accountant: 'Verifiser hvem som fører regnskapet og rutiner for kvalitetssikring.',
        action_lonn_vs_aga: 'Sjekk AGA-beregning — avviket er utenfor normalområdet (0–14,1 %).',

        // v18 — leasing, banklån, nye regler
        rule_leasing_6440: 'Leasing: manglende månedlig kostnad',
        rule_leasing_6440_desc: 'Leasingkonto brukes, men kostnad mangler i noen måneder fra første bokføring.',
        action_leasing_6440: 'Sjekk leasingkontrakt — leasing bør bokføres månedlig fra oppstart.',
        rule_banklan_8150: '8150 brukt uten gjenkjent lånesaldo ved periodeslutt',
        rule_banklan_8150_fallback: 'Rentekostnad banklån',
        rule_banklan_8150_desc: (name) => `8150 (${name}) er brukt i perioden. Ingen lånesaldo ble gjenkjent i de kontrollerte balansekontoene ved periodeslutt. Lånet kan være tilbakebetalt eller ført på en annen konto. Avklar bilag og kontoplan.`,
        action_banklan_8150: 'Verifiser om 8150 er riktig rentekonto for klienten. Rett bare hvis renten faktisk gjelder leverandørgjeld eller feil klassifisering.',
        rule_salary_periodisering: 'Personalkostnader: stor endring mellom måneder',
        rule_salary_periodisering_desc: 'Sum personalkostnader (5xxx) varierer mer enn 50 % fra måned til måned. Sjekk om periodisering er korrekt.',
        action_salary_periodisering: 'Verifiser lønnskostnader i markerte måneder — mulig feil i periodisering eller etterbetaling.',

        // v23 — dead months, cost spike extended, IB mismatch
        rule_dead_months: 'Døde måneder — ingen bokføring',
        rule_dead_months_desc: (months, count) => `${count} måned(er) uten bokføring midt i aktiv periode: ${months}.\nDette kan tyde på manglende bilag eller forsinket bokføring.`,
        action_dead_months: 'Sjekk om det mangler bilag i de markerte månedene. Verifiser med klient.',
        rule_cost_spike_ext: 'Kostnadstopp på driftskonto (4xxx–7xxx)',
        rule_cost_spike_ext_desc: (count) => `${count} konto(er) med verdier over sammenligningsgrensen (>3,5× gjennomsnitt). Utslaget krever forklaring og bekrefter ikke en bokføringsfeil.`,
        action_cost_spike_extended: "Sammenlign de markerte beløpene med dokumentasjon, rapportperiode og engangskostnader. Korriger bare når en feil er bekreftet.",
        rule_ib_mismatch: 'IB-avvik mellom år',
        rule_ib_mismatch_desc: (count) => `${count} konto(er) der inngående balanse (IB) i år ikke stemmer med utgående balanse (UB) forrige år.\nDette betyr at årsavslutningen har feil eller at det er gjort korreksjoner i feil periode.`,
        action_yoy_ib_ub_continuity: 'Sjekk årsavslutning — UB forrige år må stemme med IB inneværende år for alle balansekontoer.',

        // v24 — transaction-based rules (Phase 6)
        rule_duplicate_sales: 'Er samme salg fakturert to ganger?',
        rule_duplicate_sales_ok: 'Ingen grupper oppfyller kontrollkriteriene for mulige doble salgsfakturaer. Fakturaer uten fingeravtrykk av fakturalinjene er ikke sammenlignet.',
        duplicate_sales_desc: (count) => `${count} gruppe(r) med samme kunde, dato, beløp, fakturalinjer og kontosaldoer, men ulike fakturanumre. Gjelder fakturaene samme arbeid? Det kan være to ulike oppdrag. Sjekk dokumentene.`,
        duplicate_sales_why: 'Like fakturalinjer og posteringer kan tyde på dobbeltfakturering, men kan også gjelde to ulike oppdrag. Regnskapsføreren må kontrollere hva som faktisk er levert.',
        duplicate_sales_verified: 'Sammenlignet kunden, datoen, beløpet, fingeravtrykket av fakturalinjene og netto kontosaldoer i balanserte bilag uten netto bankposteringer. Kreditnotaer for samme kunde og beløp er tatt med i antallet.',
        invoice_lines_missing: 'Ikke kontrollert: kilden mangler fingeravtrykk av fakturalinjene som trengs for å sammenligne salgsfakturaer.',
        action_duplicate_sales_invoices: 'Gjelder fakturaene samme arbeid eller to ulike oppdrag? Sjekk fakturaene og leveransen. Hvis samme arbeid er fakturert to ganger, utsted en kreditnota og korriger MVA ved behov.',
        rule_duplicates: 'Mulige duplikater i bokføringen',
        rule_duplicates_ok: 'Ingen gjentakelser som oppfyller de strenge kontrollkriteriene ble funnet. Dokumenter uten tilstrekkelig identifikasjon er ikke bekreftet unike.',
        rule_duplicates_desc: (count) => `${count} potensielle duplikatposteringer funnet (samme konto, dato og beløp i ulike bilag).`,
        action_duplicate_entries: 'Sjekk de markerte bilagene — beløp, konto og dato er identiske. Verifiser at det ikke er dobbeltbokført.',
        rule_round_amounts: 'Mange runde beløp på kostnadskontoer',
        rule_round_amounts_ok: '✓ Andelen runde beløp er innenfor normalen — ingen tegn på estimater.',
        rule_round_amounts_desc: (pct, round, total) => `${pct}% av kostnadspostene er runde beløp (delelig med 1000): ${round} av ${total} transaksjoner.\nDette kan tyde på estimater/anslag i stedet for faktiske fakturaer.`,
        action_round_amounts: 'Verifiser at kostnadene er basert på faktiske fakturaer, ikke anslag. Spesielt store runde beløp bør dokumenteres.',
        rule_mva_voucher: 'Bilag uten MVA-postering',
        rule_mva_voucher_ok: '✓ Alle kostnadsbilag over 1 000 kr har MVA-postering (konto 27xx).',
        rule_mva_voucher_desc: (count, extra) => `${count} kostnadsbilag i kontrollens omfang uten MVA-beløp (27xx).${extra || ""} Kontroller faktura og fradragsrett. Gjentakelse beviser verken fritak eller feil.`,
        action_mva_per_voucher: 'Verifiser de markerte bilagene — kan være utenlandsk faktura, reverse charge eller avgiftsfritt kjøp.',
        rule_mva_sales: 'Fakturering uten utgående MVA',
        rule_mva_sales_ok: '✓ Alle salgsbilag over 500 kr har utgående MVA-postering (konto 2700-2709).',
        rule_mva_sales_desc: (count, extra) => `${count} bilag på konto 3000 uten utgående MVA-beløp (2700-2709).${extra || ""} Kontroller bilag, leveringssted og grunnlag for sats eller fritak. Antallet beviser ikke feil.`,
        action_mva_sales_voucher: "Kontroller bilagene og grunnlaget for MVA-behandlingen. Ikke endre sats kun ut fra kontonummer.",
        rule_mva_not_registered_vat_postings: 'MVA bokført uten MVA-registrering',
        rule_mva_not_registered_vat_postings_desc: (count, company) => `Brreg viser at ${company || 'selskapet'} ikke er registrert i MVA-registeret, men ${count} MVA-kontoer eller MVA-koder er funnet i bokføringen.`,
        action_mva_not_registered_vat_postings: 'Sjekk Brreg-status og korriger MVA-koder/posteringer. Hvis selskapet faktisk skal være MVA-pliktig, må registrering avklares.',
        rule_invoice_numbering: 'Hull i fakturanummerering',
        rule_invoice_numbering_ok: (count, first, last) => `${count} observerte fakturanumre (${first} til ${last}): ingen hull over regelens terskel. Hele fakturaregisteret og andre serier er ikke kontrollert.`,
        rule_invoice_numbering_desc: (gaps, missing) => `${gaps} hull i nummerrekken: ${missing} numre finnes ikke på salgs- eller fordringstransaksjoner i den valgte perioden. Sekvensen bestemmes av salgskontoer (3xxx); nummer på kundefordringer (1500) teller som tilstede, men dokumenterer ikke alene at fakturaen er utstedt. Fakturaene kan være bokført i en annen periode. Dette bekrefter ikke manglende bilag.`,
        action_invoice_numbering: 'Søk etter numrene i fakturalisten, også utenfor den valgte perioden, før du vurderer om bilag mangler.',
        fromInvoice: 'Fra faktura',
        toInvoice: 'Til faktura',
        missingCount: 'Mangler',
        missingInvoices: 'Manglende numre',
        rule_varelager: 'Manglende varelager (1400-1499)',
        rule_varelager_desc: (total) => `Firmaet har varekostnad på ${total}, men ingen varelager i balansen. Vurder om varetelling bør gjennomføres ved årsslutt.`,
        action_varelager_check: 'Vurder om det bør gjennomføres varetelling og aktiveres varelager ved årsslutt.',
        rule_bank_eom: 'Banksaldo per måned',
        rule_bank_eom_desc: (months) => `Bankkontoen (1920) viser negativt saldo eller dramatisk fall i ${months}.`,
        rule_bank_eom_action: 'Sammenlign de markerte månedene med kontoutskrift og betalinger. Et fall alene viser ikke negativ saldo eller dagens likviditet.',
        rule_bank_eom_ok: 'Banksaldo stabilt gjennom perioden.',
        action_bank_saldo_eom: "Sammenlign de markerte månedssluttsaldoene og endringene med kontoutskrift og betalinger. Avklar dokumenterte forhold; historiske saldoer alene viser ikke dagens likviditet eller bruk av bankkreditt.",
        rule_reverse_period: 'Periodisering: bevegelse 3009 og saldo 1530',
        rule_reverse_period_desc: 'Konto 3009 og 1530 indikerer reversering/periodisering av inntekt. Dette kan være helt normalt ved periodisering mellom måneder/kvartaler, så punktet er kun til orientering.',
        rule_reverse_period_action: 'Sjekk at periodiseringen er forventet. Hvis dette er normal reversering, legg eventuelt inn en kort kommentar.',
        action_reverse_periodisering: 'Sjekk at periodiseringen er forventet. Hvis dette er normal reversering, legg eventuelt inn en kort kommentar.',
        rule_tx_skipped: 'Transaksjonsregler hoppet over',
        rule_tx_verified_empty: 'Bekreftet ingen transaksjoner',
        rule_tx_verified_empty_desc: 'Kilden har bekreftet at det er ingen transaksjoner i perioden. Transaksjonskontrollene er ikke utført og står fortsatt som ikke kontrollert.',
        rule_tx_skipped_desc: 'Regler for duplikater og MVA per bilag krever transaksjonsdata fra API. Disse reglene kjøres kun i batch-modus via API.',
        rule_recurring: 'Gjentakende kostnader oppdaget',
        rule_recurring_desc: (count) => `${count} gjentakende kostnadspost(er) identifisert (samme beløp ±10%, minst 3 ganger).`,
        action_recurring_detection: 'Informasjon: dette er identifiserte faste kostnader. Nyttig for budsjettering og cash flow-analyse.',
        rule_project_pnl: 'Resultat av prosjektførte poster',
        rule_project_pnl_ok: (count) => `${count} prosjekter har ikke-negativ sum av prosjektførte poster i perioden.`,
        rule_project_pnl_desc: (losing,total,loss) => `${losing} av ${total} prosjekter har negativt bokført netto i perioden, samlet ${loss}. Dette er ikke prosjektets livstidsresultat. Kontroller perioder for fakturering og kostnadsfordeling.`,
        rule_project_pnl_partial_desc: (losing, total, totalLoss) => `${losing} av ${total} prosjekter har negativ sum av prosjektførte poster: ${totalLoss}. Perioden er kortere enn et kvartal. Dette bekrefter ikke tap på prosjektet.`,
        action_project_pnl_summary: 'Sjekk prosjekter med negativt netto: mangler det fakturering, er kostnadene feilallokert, eller er prosjektet faktisk ulønnsomt?',
        project_pnl_costs: 'kostnader',
        project_pnl_sales: 'salg',
        project_pnl_net: 'netto',
        // 11.10.2026 — kortet viser bare prosjekter som trenger oppfølging (eierbeslutning)
        project_pnl_scope_note: (shown, listed, omitted, priorYear, profitable, terskel) =>
            `Vist: ${shown} prosjekt(er) i minus som ikke finnes i fjorårets datagrunnlag eller har omsetning over ${terskel}${listed < shown ? ` (${listed} i listen)` : ''}.`
            + (omitted > 0 ? ` Utelatt: ${omitted} prosjekt(er) fra ${priorYear} under terskelen — resultatet kan ligge i fjorårets fakturering.` : '')
            + ` ${profitable} prosjekt(er) går i pluss og er ikke listet.`,
        project_pnl_scope_note_unknown: (shown, listed, profitable) =>
            `Vist: ${shown} prosjekt(er) i minus${listed < shown ? ` (${listed} i listen)` : ''}. ${profitable} prosjekt(er) går i pluss og er ikke listet.`,
        project_pnl_prior_unknown: 'Fjorårets prosjektliste var ikke tilgjengelig, så alle prosjekter i minus vises.',
        project_pnl_from_prior_year: (year) => `fra ${year}`,
        mva_voucher_series: (count, from, to) => `${count} bilag ${from} – ${to}`,
        mva_voucher_grouped: (series, rows) => `Gjentatt bilag fra samme konto og motpart er slått sammen (${series} serier, ${rows} linjer).`,
        action_prosjektregnskap_terskel: 'Avklar kontraktsverdi, bransje og terskel på relevant dato; kontroller deretter prosjektregnskapet.',
        action_import_integrity: 'Sammenlign alle linjer, debet, kredit og datoer med kildebilaget.',
        // v40 — IB/UB-kontinuitet, import-integritet, prosjektregnskap
        rule_ib_ub_continuity: 'Inngående balanse stemmer ikke med fjorårets utgående',
        rule_ib_ub_continuity_desc: (count, total) => `${count} balansekonto(er) har en inngående balanse som ikke stemmer med fjorårets utgående balanse — avvik totalt ${total}. IB skal være lik fjorårets UB. Sjekk åpningsbalansen, manuelle posteringer eller føringer i avsluttet år.`,
        rule_import_integrity: 'Bilag som ikke balanserer (debet ≠ kredit)',
        rule_import_integrity_ok: (count) => `✓ ${count} bilag kontrollert — alle balanserer (debet = kredit).`,
        rule_import_integrity_desc: (bad,total) => `${bad} av ${total} bilag summerer ikke til null i de hentede linjene. Årsaken er ikke fastslått. Sammenlign hele bilaget og datoutvalget med kilden før korrigering.`,
        rule_prosjektregnskap: 'Prosjektregnskap — terskel passert (sjekk manuelt)',
        rule_prosjektregnskap_missing_desc: (count,limit) => `${count} kunder har netto bokført omsetning over kontrollgrensen ${limit}, og færre enn 20 % av kostnadslinjene har prosjekt. Standardgrensen er 650 800 NOK (5 × G fra 01.05.2025), eventuelt konfigurert lokalt. Avklar bransje, kontraktsverdi og relevant G-dato. Dette er screening, ikke fastslått manglende prosjektregnskap.`,
        rule_prosjektregnskap_check_desc: (p,c,limit) => `Netto bokført omsetning over kontrollgrensen ${limit}: ${p} prosjekter og ${c} kunder. Standardgrensen er 5 × G fra 01.05.2025 (650 800 NOK), eventuelt konfigurert lokalt. Dette er screening, ikke vurdering av kontraktsverdi eller gjeldende plikt. Avklar bransje, kontrakt og relevant G-dato.`,
        prosjektregnskap_project: 'Prosjekt',
        prosjektregnskap_customer: 'Kunde',
        showing: 'viser',

        // --- 24SO API ---
        api_mode: '24SO API',
        api_mode_desc: 'Koble til 24SO via RAPPORTER API',
        api_url_label: 'API URL',
        api_key_label: 'API-nøkkel',
        api_connect: 'Koble til',
        api_select_client: 'Velg klient',
        api_search_placeholder: 'Søk etter firma...',
        api_year: 'År',
        api_month_from: 'Fra måned',
        api_month_to: 'Til måned',
        api_run_audit: (name) => `Kjør revisjon — ${name}`,
        api_fetching_clients: 'Henter klientliste...',
        api_fetching_data: 'Henter regnskapsdata...',
        api_no_clients: 'Ingen aktive klienter funnet',
        api_connection_error: 'Kunne ikke koble til API. Sjekk URL og nøkkel.',
        api_data_error: 'Kunne ikke hente regnskapsdata. Prøv igjen.',
        rapporter_err_empty_period: 'Ingen bokføringer på resultatkontoene i perioden. Perioden er ikke ført, eller postene nuller hverandre ut.',
        rapporter_err_no_fiscal_year: 'Perioden ligger utenfor klientens regnskapsår i Finago.',
        rapporter_err_busy: 'Finago er opptatt med en annen rapport. Prøv igjen om litt.',
        rapporter_err_timeout: 'Finago svarte ikke i tide. Prøv igjen om noen minutter.',
        api_or: 'eller',
        api_back: 'Tilbake til valg',
        // === Batch & Dashboard (v17) ===
        period_label: 'Periode',
        period_per: 'Per',
        batch_mode: 'Batch-revisjon',
        batch_connect_first: 'Koble til API først for å bruke batch-revisjon.',
        batch_select_title: 'Velg klienter for batch-revisjon',
        batch_select_all: 'Velg alle',
        batch_deselect_all: 'Fjern alle',
        batch_start: (n) => `Start revisjon (${n} firma)`,
        batch_running: 'Kjører batch-revisjon...',
        batch_progress: (done, total, name) => `${done}/${total} — ${name}`,
        batch_rule_progress: (rDone, rTotal, ruleName) => `Sjekker regel ${rDone}/${rTotal}: ${ruleName}`,
        batch_eta: (mins) => `ca. ${mins} min igjen`,
        batch_done: (n) => `Ferdig! ${n} firma revidert.`,
        batch_abort: 'Avbryt',
        batch_aborted: 'Batch avbrutt.',
        batch_error_count: (n) => `${n} feil`,
        batch_period_label: 'Revisjonsperiode',
        dashboard_title: 'Revisjonsoversikt',
        dashboard_empty_title: 'Ingen revisjonsresultater ennå',
        dashboard_empty_desc: 'Velg klienter og kjør revisjon for å se resultater her.',
        dashboard_empty_go: 'Gå til klientlisten',
        dashboard_firms: 'Firma',
        dashboard_avg_score: 'Gj.snitt',
        dashboard_critical: (n) => `${n} kritiske`,
        dashboard_top_error: 'Vanligste feil',
        dashboard_filter_all: 'Alle',
        dashboard_filter_critical: (n) => `Kritisk (<${n})`,
        dashboard_filter_warning: (a, b) => `Må sjekkes (${a}–<${b})`,
        dashboard_filter_ok: (n) => `Score ≥ ${n}`,
        dashboard_filter_unreviewed: 'Ikke gjennomgått',
        dashboard_filter_assigned: 'Tildelt',
        dashboard_export_csv: 'Eksporter CSV',
        dashboard_mark_reviewed: 'Gjennomgått',
        dashboard_assign: 'Tildel',
        dashboard_full_report: 'Full rapport',
        dashboard_ranking_title: 'TOP 10 vanligste problemer',
        dashboard_back: 'Tilbake til oversikt',
        dashboard_no_results: 'Ingen firma matcher filteret.',
        dashboard_score: 'Score',
        dashboard_errors: 'Feil',
        dashboard_warnings: 'Adv.',
        dashboard_system: 'System',
        dashboard_status_bar: (done, total) => `${done} av ${total} revidert`,
        dashboard_filter_audited: 'Revidert',
        dashboard_filter_not_audited: 'Ikke revidert',
        dashboard_select_unaudited: (n) => `Velg alle ikke-reviderte (${n})`,
        history_label: 'Tidligere kjøringer',
        history_load: 'Last inn',
        history_delete: 'Slett',
        history_empty: 'Ingen tidligere kjøringer.',
        history_firms: (n) => `${n} firma`,
        history_date: 'Dato',
        team_unassigned: 'Ikke tildelt',
        team_manage: 'Rediger team',
        team_add: 'Legg til person',
        team_name_placeholder: 'Navn...',
        team_title: 'Revisjonsteam',
        // v18 — Kundeliste
        kundeliste_section: 'Kundeliste (firma → regnskapsfører)',
        kundeliste_import: 'Importer CSV',
        kundeliste_import_desc: 'Eksporter kundeliste fra Google Sheets som CSV og last opp her.',
        kundeliste_count: (n) => `${n} firmaer lastet`,
        kundeliste_clear: 'Fjern kundeliste',
        kundeliste_col_accountant: 'Regnskapsfører',
        kundeliste_drop: 'Slipp CSV-fil her eller klikk for å velge',
        cat_compliance: 'Samsvar',
        cat_balance: 'Balanse',
        cat_result: 'Resultat',
        cat_financial: 'Finans',
        cat_analysis: 'Analyse',
        // v18 — Navigation
        nav_home: 'Klienter',
        nav_dashboard: 'Dashboard',
        nav_settings: 'Innstillinger',
        nav_users: 'Brukere',
        nav_work_activity: 'Arbeidsaktivitet',
        nav_activity: 'Aktivitetslogg',
        nav_report: 'Rapport',
        nav_reports: 'Rapporter',
        nav_notifications: 'Varslinger',
        nav_history: 'Historikk',
        nav_permanent_acks: 'Permanent log',
        nav_my_firms: 'Min oversikt',
        // Model B — My firms dashboard
        myfirms_title: 'Min oversikt — mine klienter',
        myfirms_period: 'Periode',
        myfirms_firms: 'klienter',
        myfirms_no_run: 'Ingen revisjon å vise ennå',
        myfirms_kpi_all: 'Alle',
        myfirms_kpi_attention: 'Krever handling',
        myfirms_kpi_in_progress: 'Under arbeid',
        myfirms_kpi_done: 'Ferdig',
        myfirms_kpi_clean: 'Uten feil',
        myfirms_overall_progress: 'Totalt fremdrift',
        myfirms_col_firm: 'Klient',
        myfirms_col_progress: 'Fremdrift',
        myfirms_col_status: 'Status',
        myfirms_col_notified: 'Sendt',
        myfirms_col_opened: 'Åpnet',
        myfirms_status_waiting: 'Venter',
        myfirms_status_in_progress: 'Under arbeid',
        myfirms_status_done: 'Ferdig',
        myfirms_status_no_issues: 'Uten feil',
        myfirms_status_not_notified: 'Ikke sendt',
        myfirms_errors: 'feil',
        myfirms_empty_filter: 'Ingen klienter i dette filteret',
        myfirms_show_all: 'Vis alle',
        myfirms_admin_note: 'Som admin ser du alle klienter fra siste revisjon.',
        myfirms_period_selector_label: 'Periode',
        myfirms_period_all: 'Alle perioder',
        myfirms_no_periods: 'Ingen perioder tilgjengelig',
        myfirms_period_firms_count: 'klienter',
        myfirms_period_acked_pct: 'acked',
        refresh: 'Oppdater',
        // Phase 3 D++ — Permanent acks log admin screen
        permanent_acks_title: 'Permanent ignore — revisjonslogg',
        permanent_acks_subtitle: 'Alle regler permanent ignorert (cross-period). Kun admin.',
        permanent_acks_total: 'Totalt permanent',
        permanent_acks_top_user: 'Toppbruker',
        permanent_acks_top_rules: 'Mest permanent ignorert',
        permanent_acks_search_placeholder: 'Søk i notater / klient / regel / bruker...',
        permanent_acks_all_users: 'Alle brukere',
        permanent_acks_col_date: 'Dato',
        permanent_acks_col_user: 'Bruker',
        permanent_acks_col_client: 'Klient',
        permanent_acks_col_rule: 'Regel',
        permanent_acks_col_notes: 'Notater (begrunnelse)',
        permanent_acks_empty: 'Ingen permanent acks',
        permanent_acks_rows_shown: 'rader',
        permanent_acks_truncated: 'grense 500 — innsnevre filter',
        collapse_sidebar: 'Skjul meny',
        // P0 fix (2026-04-25): empty state Historikk + loading
        loading: 'Laster...',
        history_title: 'Revisjonshistorikk',
        history_empty_desc: 'Ingen revisjoner registrert ennå. Start din første revisjon for å bygge opp historikken.',
        history_run_first_audit: 'Start første revisjon',
        // P2 fix (2026-04-25): aria-label for status pills (WCAG SC 1.4.1)
        status_errors: 'Feil',
        status_warnings: 'Advarsler',
        status_ok: 'OK',
        // P1 fix (2026-04-25): KPI tooltips
        hero_audited_tooltip: 'Antall firmaer som er auditert / totalt antall firmaer i listen',
        hero_average_tooltip: 'Gjennomsnittlig poengsum (0-10) av alle audited firmaer. Høyere = bedre kvalitet',
        hero_critical_tooltip: (n) => `Firmaer med poengsum under ${n} krever gjennomgang`,
        hero_fixed_tooltip: 'Antall feil markert som "Fikset" / totalt antall feil funnet',
        // EN4 fix (2026-04-25): YoY disabled message
        rule_yoy_disabled_desc: 'YoY-sammenligning ikke tilgjengelig — last opp data fra forrige år for å aktivere trendanalyse.',
        // P0 fix (2026-04-25): firm row click → full report
        open_full_report: 'Åpne full rapport',
        // P1 fix (2026-04-25): Executive summary nad VerdictBanner
        error: 'feil',
        errors: 'feil',
        warning: 'advarsel',
        warnings: 'advarsler',
        exec_clean: 'Ingen feil eller advarsler',
        exec_top_action: 'Topp prioritet',
        // Scoring penalty breakdown
        scoring_breakdown_title: 'Hva trakk ned poengsummen',
        scoring_breakdown_hint: 'Hver regel kan maksimalt trekke fra et fast tak — én regel kan ikke ødelegge hele scoren.',
        scoring_bucket_critical_compliance: 'Kritisk',
        scoring_bucket_error: 'Feil',
        scoring_bucket_warning: 'Advarsel',
        open_in_finago: 'Åpne i Finago',
        finago_then_search: 'søk deretter etter firmaet',
        // P1 fix (2026-04-25): YoY widget
        yoy_no_change: 'Uendret',
        vs_previous_period: 'vs forrige periode {0}',
        // P1 fix (2026-04-25): Notes modal przy ack
        ack_history_was_checked: 'było Sjekket',
        ack_history_was_fixed: 'było Fikset',
        ack_history_total: 'totalt',
        ack_history_recurring_hint: 'sjekk om problemet vedvarer',
        ack_autofill_from: 'Notatka z',
        ack_autofill_hint: 'poprzednia notatka, wstaw tylko jeśli pasuje',
        ack_autofill_insert: 'Wstaw',
        ack_why_question: 'Hvorfor godkjente du dette feilen?',
        ack_note_placeholder: 'F.eks: Klient bekreftet, regnskapsført korrekt, ikke aktuell for denne perioden...',
        ack_client_followup_note_placeholder: 'Hva må avklares med klienten? F.eks. mangler forsikring, venter faktura eller trenger dokumentasjon.',
        ack_confirm: 'Bekreft og lagre',
        cancel: 'Avbryt',
        // P1 fix (2026-04-25): table column collapse
        table_show_more_cols: 'Vis flere kolonner (feil/advarsler/kategorier)',
        table_show_compact: 'Kompakt visning (5 kolonner)',
        // P1 fix (2026-04-25): empty state Varslingsstatus
        notif_kpi_sent: 'Sendt',
        notif_kpi_opened: 'Åpnet',
        notif_kpi_unopened: 'Ikke åpnet',
        notif_kpi_reminded: 'Påminnet',
        notif_kpi_processed: 'Behandlet',
        notif_th_accountant: 'Regnskapsfører',
        notif_th_period: 'Periode',
        notif_th_firms: 'Firmaer',
        notif_th_count: 'Ganger',
        notif_th_actions: 'Handlinger',
        notif_th_status: 'Status',
        notif_status_escalated: 'Eskalert',
        notif_status_unopened: 'Ikke åpnet',
        notif_status_active: 'Aktiv',
        notif_status_opened: 'Åpnet',
        notif_db_download: 'Last ned DB',
        notif_empty_title: 'Ingen varsler sendt ennå',
        notif_empty_desc: 'Når du sender en revisjonsrapport til en regnskapsfører, vil status vises her. Start med å kjøre en batch-revisjon.',
        notif_goto_dashboard: 'Gå til dashbord',
        // v29 — Users management
        users_title: 'Brukeradministrasjon',
        users_add_title: 'Inviter ny bruker',
        users_invite_desc: 'Brukeren mottar en e-post med lenke for å opprette passord.',
        users_email: 'E-post',
        users_email_required: 'E-post er påkrevd',
        users_role: 'Rolle',
        users_status: 'Status',
        users_2fa: '2FA',
        users_actions: 'Handlinger',
        users_created: 'Opprettet',
        users_invite: 'Send invitasjon',
        users_sending: 'Sender...',
        users_invite_sent: (email: string) => `Invitasjon sendt til ${email}`,
        users_created_no_email: 'Bruker opprettet (e-post ikke sendt — sjekk Resend-konfigurasjon)',
        users_resend_invite: 'Send invitasjon på nytt',
        users_invite_resent: 'Invitasjon sendt på nytt',
        users_invite_resent_no_email: 'Kunne ikke sende e-post — sjekk Resend-konfigurasjon',
        users_reset_pwd: 'Tilbakestill passord',
        users_reset_sent: 'E-post med lenke for passordtilbakestilling er sendt',
        users_reset_no_email: 'Passord tilbakestilt (e-post ikke sendt)',
        users_delete: 'Slett',
        users_delete_confirm: (email: string) => `Er du sikker på at du vil slette ${email}? En konto med lagret arbeid (bekreftelser, varsler, tilbakemeldinger) blir deaktivert i stedet, og arbeidet beholdes.`,
        users_deleted_ok: 'Bruker slettet',
        users_deactivated_ok: 'Bruker deaktivert – lagret arbeid er beholdt',
        users_status_deactivated: 'Deaktivert',
        users_no_users: 'Ingen brukere funnet',
        users_role_changed: 'Rolle endret',
        users_status_active: 'Aktiv',
        users_status_invited: 'Invitert',
        // v30 — Audit log
        audit_title: 'Aktivitetslogg',
        audit_time: 'Tidspunkt',
        audit_user: 'Bruker',
        audit_action: 'Handling',
        audit_detail: 'Detaljer',
        audit_ip: 'IP',
        audit_filter_all: 'Alle handlinger',
        audit_filter_user: 'Alle brukere',
        audit_filter_from: 'Fra dato',
        audit_filter_to: 'Til dato',
        audit_load_more: 'Last inn flere',
        audit_no_entries: 'Ingen loggoppføringer',
        // v18 — Home screen
        home_title: 'Revisjon av klienter',
        home_no_connection: 'Ingen API-tilkobling',
        home_configure_api: 'Konfigurer API-tilkobling i Innstillinger',
        home_select_all: 'Velg alle',
        home_all_accountants: 'Alle regnskapsførere',
        home_deselect_all: 'Fjern alle',
        home_run_audit_1: 'Kjør revisjon',
        home_run_audit_n: (n) => `Kjør revisjon (${n} firmaer)`,
        home_refresh_list: 'Oppdater liste',
        home_clients_count: 'klienter',
        home_search: 'Søk etter firma...',
        home_show_selected: (n) => `Vis valgte (${n})`,
        home_show_all: 'Vis alle',
        dashboard_filter_form: 'Selskapsform',
        dashboard_filter_form_all: 'Alle former',
        dashboard_hide_holdings: 'Ekskluder holding',
        dashboard_holding_tag: 'Holding',
        dashboard_hide_inactive: 'Ekskluder inaktive',
        dashboard_inactive_tag: 'Inaktiv',
        // v18 — Settings sections
        settings_api_section: 'API-tilkobling',
        settings_api_status_connected: (n) => `Tilkoblet (${n} klienter)`,
        settings_api_status_disconnected: 'Ikke tilkoblet',
        settings_api_test: 'Test tilkobling',
        settings_csv_section: 'Manuell revisjon (CSV/Excel)',
        settings_csv_select_system: 'Velg regnskapssystem',
        settings_csv_run: 'Kjør manuell revisjon',
        // v18 — YoY rules
        rule_yoy_revenue_drop: 'Inntektsfall >30 % YoY',
        rule_yoy_revenue_drop_desc: (curr, prev, pct) => `Inntekter (3xxx) i år: ${curr}\nInntekter forrige år: ${prev}\nEndring: ${pct}%\n\nSignifikant inntektsfall krever gjennomgang av driften.`,
        rule_yoy_cost_spike: 'Kostnadsøkning >50 % YoY',
        rule_yoy_cost_spike_desc: (curr, prev, pct) => `Kostnader (4xxx-7xxx) i år: ${curr}\nKostnader forrige år: ${prev}\nEndring: ${pct}%\n\nUvanlig stor kostnadsøkning. Sjekk om det skyldes engangskostnader.`,
        rule_yoy_equity_decline: 'Egenkapital falt >50 % YoY',
        rule_yoy_equity_decline_desc: (curr, prev, pct) => `Egenkapital (eiendeler minus gjeld) i år: ${curr}\nForrige år: ${prev}\nEndring: ${pct}%\n\nKritisk reduksjon i egenkapital.`,
        rule_yoy_debt_increase: 'Kreditsaldoer 2200-2999 økt over 50 %',
        rule_yoy_debt_increase_desc: (curr,prev,pct) => `Kreditsaldoer 2200-2999: ${curr}. Sammenligningsgrunnlag: ${prev}. Endring: ${pct} %. Debetsaldoer er utelatt; dette er ikke netto gjeld. Sammenligningsdatoer (nå / tidligere):`,
        rule_yoy_profitability: 'Overskudd → underskudd YoY',
        rule_yoy_profitability_desc: (curr, prev) => `Resultat i år: ${curr}\nResultat forrige år: ${prev}\n\nSelskapet gikk fra overskudd til underskudd. Krever umiddelbar oppmerksomhet.`,
        action_yoy_revenue_drop: 'Analyser inntektsfallet — ny kundestrategi eller markedsendringer?',
        action_yoy_cost_spike: 'Identifiser hovedårsaken til kostnadsøkningen. Engangskostnad eller varig endring?',
        action_yoy_equity_decline: 'Vurder egenkapitalsituasjonen. Handlingsplikt jf. aksjeloven § 3-4 kan gjelde.',
        action_yoy_debt_increase: 'Sjekk nye lån og kreditorer. Vurder gjeldsgrad og betjeningsevne.',
        action_yoy_profitability: 'Analyser endring i lønnsomhet. Identifiser drivere for underskudd.',
        // v18.1 — Report improvements
        data_source_label: 'Kilde',
        data_summary_accounts: 'kontoer',
        generatedAt: 'Generert',
        review_progress: 'Gjennomgang',
        bulk_ack_scope_count: (firms, findings) => `${firms} firmaer, ${findings} funn`,
        review_progress_hint: 'Teller feil, advarsler og kontrollsignaler som krever vurdering. Kontrollsignaler trekker ikke poeng. Andre informasjonspunkter er valgfrie.',
        audit_snapshot_notice: 'Lagret revisjonsresultat. Å åpne rapporten oppdaterer ikke regnskapsdataene.',
        report_view_date: 'Rapportvisning',
        audit_date_unknown: 'Dato for revisjonen er ikke lagret',
        audit_date_label: 'Revisjon utført',
        notify_missing_recipient: 'Ingen entydig regnskapsførerkonto. Rett tilordningen før sending.',
        notify_skipped_done: n => `Ikke sendt, ${n === 1 ? 'firmaet er' : 'firmaene er'} allerede ferdig gjennomgått:`,
        dispatch_all_accountants: 'Alle regnskapsførere',
        dispatch_accountant: 'Regnskapsfører',
        dispatch_recipients: n => `Regnskapsførere: ${n}`,
        dispatch_other_actions: 'Andre handlinger',
        dispatch_delivery: 'Utsending',
        dispatch_all_delivery: 'Alle rapporter',
        dispatch_search: 'Søk etter firma',
        dispatch_more_filters: 'Flere filtre',
        dispatch_visible: (n, total) => `Viser ${n} av ${total} firmaer`,
        dispatch_hidden: n => `${n} valgte firmaer er skjult av filtrene. Fjern dem før utsending.`,
        dispatch_clear_hidden: 'Fjern skjulte valg',
        dispatch_visible_scope: 'Rapporter i gjeldende filter',
        dispatch_no_recipient: 'Ingen regnskapsfører tilordnet',
        dispatch_selected_preview: n => `Forhåndsvis valgte (${n})`,
        dispatch_visible_preview: n => `Forhåndsvis filtrerte (${n})`,
        dispatch_status_error: 'Kunne ikke hente utsendingsstatus. Utsendte rapporter kan ikke skilles fra usendte.',
        dispatch_retry: 'Prøv igjen',
        notify_preview_hint: 'Kontroller mottakere og innhold. Etter sending minner appen om uåpnede rapporter etter 3 dager og eskalerer etter 7 dager.',
        notify_confirm_send: 'Send viste meldinger',
        notify_preview_title: 'Forhåndsvis varsler',
        ack_retain_option: 'Behold begrunnelsen uten utløpsdato, kun for disse dataene og perioden',
        settings_api_desc: 'API-tilkobling konfigureres av administrator via servermilj\u00f8variabler.',
        // v19 — Reports & Analytics
        reports_nav: 'Rapporter',
        reports_title: 'Rapporter & Analyse',
        reports_loading: 'Laster rapportdata...',
        reports_no_data: 'Ingen revisjonsdata. Kj\u00f8r batch-revisjon f\u00f8rst.',
        report_period_unknown: 'Perioden for denne kj\u00f8ringen er ukjent, s\u00e5 rapporten kan ikke \u00e5pnes herfra.',
        reports_avg_score: 'Gjennomsnittsscore',
        reports_firms_audited: 'Reviderte firma',
        reports_critical_firms: 'Kritiske firma',
        reports_error_rate: 'Feil per firma',
        reports_vs_previous: 'vs forrige',
        reports_accountant_ranking: 'Regnskapsf\u00f8rerrangering',
        reports_accountant: 'Regnskapsf\u00f8rer',
        reports_no_accountant: 'Ikke tildelt',
        reports_firms_count: 'Firma',
        reports_avg: 'Gj.snitt',
        reports_errors: 'Feil',
        reports_warnings: 'Adv.',
        reports_critical: 'Kritiske',
        reports_top_errors: 'Vanligste feil',
        reports_expand: 'Vis detaljer',
        reports_collapse: 'Skjul detaljer',
        reports_rule_frequency: 'Regelfrekvens',
        reports_affected: 'ber\u00f8rt',
        reports_filter_all: 'Alle',
        reports_filter_errors: 'Feil',
        reports_filter_warnings: 'Advarsler',
        reports_trend_title: 'Kvalitetstrend',
        reports_select_run: 'Velg kj\u00f8ring',
        reports_current_run: 'Gjeldende',
        reports_range_all: 'Alle',
        reports_range_year: 'Siste 12m',
        reports_range_6m: 'Siste 6m',
        reports_range_3m: 'Siste 3m',
        reports_completion: 'Ferdigstillelse',
        reports_not_audited: 'Ikke revidert',
        reports_per_accountant: 'Per regnskapsf\u00f8rer',
        reports_score: 'Score',
        reports_firms: 'Firmaer',
        reports_period: 'Periode',
        reports_of: 'av',
        reports_accountant_trend: 'Trend per regnskapsfører',
        reports_trend_loading: 'Laster trenddata...',
        reports_trend_no_history: 'Trenger minst 2 revisjoner',
        reports_trend_delta: 'Endring',
        reports_trend_show_all: 'Last historikk',
        reports_trend_period: 'Periode',
        // PIN auth
        pin_title: 'MTA Audit',
        pin_subtitle: 'Skriv inn PIN-kode for å fortsette',
        pin_placeholder: 'PIN-kode',
        pin_btn: 'Logg inn',
        pin_error_wrong: 'Feil PIN-kode',
        pin_error_network: 'Kunne ikke koble til server',
        // Manual upload for API client
        manual_upload_for: (name) => `Last opp filer for ${name}`,
        manual_upload_select_system: 'Velg system for filen',
        manual_upload_run: 'Kjør revisjon',
        // v29 — Auth UI
        auth_login_title: 'Logg inn',
        auth_email: 'E-post',
        auth_password: 'Passord',
        auth_login_btn: 'Logg inn',
        auth_logging_in: 'Logger inn...',
        auth_forgot: 'Glemt passord?',
        auth_remember_me: 'Husk meg i 30 dager',
        auth_forgot_title: 'Glemt passord',
        auth_send_reset: 'Send tilbakestillingslenke',
        auth_sending: 'Sender...',
        auth_back_to_login: 'Tilbake til innlogging',
        auth_email_sent_title: 'E-post sendt',
        auth_email_sent_msg: 'Sjekk innboksen din for en tilbakestillingslenke.',
        auth_new_password_title: 'Nytt passord',
        auth_new_password: 'Nytt passord',
        auth_set_password: 'Sett nytt passord',
        auth_updating: 'Oppdaterer...',
        auth_password_updated: 'Passord oppdatert',
        auth_password_updated_msg: 'Passordet er oppdatert!',
        auth_go_to_login: 'Gå til innlogging',
        auth_password_hint: 'Min. 8 tegn, 1 stor bokstav, 1 tall',
        auth_logout: 'Logg ut',
        auth_loading: 'Laster...',
        auth_session_expired: 'Økten har utløpt. Logg inn på nytt.',
        auth_change_password: 'Endre passord',
        auth_current_password: 'Nåværende passord',
        auth_new_password_label: 'Nytt passord',
        auth_change_btn: 'Endre passord',
        auth_changing: 'Endrer...',
        auth_password_changed: 'Passord endret!',
        auth_must_change: 'Du må endre passordet ditt før du kan fortsette.',
        auth_timeout: 'Tidsavbrudd — sjekk nettverkstilkobling',
        // v30 — Offline & UX
        offline_banner: 'Ingen internettforbindelse — endringer lagres lokalt',
        // v31 — 2FA
        twofa_title: 'Tofaktorautentisering',
        twofa_code_label: 'Kode fra autentiseringsapp',
        twofa_verify_btn: 'Bekreft',
        twofa_verifying: 'Bekrefter...',
        twofa_or_backup: 'Eller bruk en reservekode',
        twofa_back: 'Tilbake',
        twofa_setup_title: 'Tofaktorautentisering (2FA)',
        twofa_setup_desc: 'Beskytt kontoen din med en autentiseringsapp (Google Authenticator, Authy)',
        twofa_enable_btn: 'Aktiver 2FA',
        twofa_disable_btn: 'Deaktiver 2FA',
        twofa_status_on: '2FA aktivert',
        twofa_status_off: '2FA ikke aktivert',
        twofa_scan_qr: 'Skann QR-koden med autentiseringsappen din',
        twofa_manual_key: 'Manuell n\u00f8kkel',
        twofa_backup_title: 'Reservekoder',
        twofa_backup_desc: 'Lagre disse kodene p\u00e5 et trygt sted. Hver kode kan bare brukes \u00e9n gang.',
        twofa_confirm_code: 'Skriv inn koden fra appen for \u00e5 bekrefte',
        twofa_confirmed: '2FA er aktivert!',
        twofa_disable_confirm: 'Skriv inn passordet ditt for \u00e5 deaktivere 2FA',
        twofa_disabled: '2FA er deaktivert',
        // v33 — Panel
        panel_assignee: 'Tildelt',
        panel_issues_title: 'Funn',
        panel_notes: 'Notat',
        // v33 — Group by
        group_by_accountant: 'Grupper etter regnskapsf\u00f8rer',
        group_unassigned: 'Ikke tildelt',
        // v33 — Bulk actions
        bulk_run: 'Kj\u00f8r revisjon',
        bulk_mark_reviewed: 'Merk gjennomg\u00e5tt',
        bulk_assign: 'Tildel...',
        bulk_compare: 'Sammenlign',
        bulk_deselect: 'Fjern alle',
        bulk_selected: 'valgt',
        // P0 fix (2026-04-27): Bulk Ack
        bulk_ack_button: 'Bulk Ack',
        bulk_ack_tooltip: 'Bekreft samme regel for flere klienter samtidig',
        bulk_ack_modal_title: (n) => `Bulk ack: ${n} klienter`,
        bulk_ack_modal_hint: 'Velg regel som acknowledges for alle valgte klienter',
        bulk_ack_select_rule: 'Velg regel',
        bulk_ack_select_rule_placeholder: 'Velg felles regel',
        bulk_ack_firms_with_rule: 'klienter med problemet',
        bulk_ack_apply_matching: 'Bare matchende',
        bulk_ack_apply_matching_tooltip: 'Bekreft kun for klientene som faktisk har denne regelen — ignorer resten',
        bulk_ack_apply_all: 'Alle valgte',
        bulk_ack_apply_all_tooltip: 'Bekreft for alle valgte klienter selv om de ikke har denne regelen (kan skape støy)',
        bulk_ack_no_common_issues: 'Ingen felles regel funnet i valgte klienter',
        bulk_ack_action_label: 'Handling',
        bulk_ack_scope_label: 'Omfang',
        bulk_ack_scope_period: 'Kun denne perioden',
        bulk_ack_submit: (n) => `Bekreft for ${n} klienter`,
        bulk_ack_success: (n) => `${n} acks lagret`,
        // v33 — Compare
        compare_title: 'Sammenlign firmaer',
        compare_close: 'Lukk',
        compare_top_issues: 'Topp funn',
        compare_no_issues: 'Ingen funn',
        // v33 — Summary dashboard
        summary_heatmap: 'Firmaoversikt',
        summary_top_errors: 'Vanligste feil',
        summary_attention: 'Trenger oppmerksomhet',
        summary_show: 'Vis oversikt',
        summary_hide: 'Skjul oversikt',
        // v33 — Notes & Tags
        notes_placeholder: 'Skriv notat...',
        tag_clear_all: 'Fjern alle filtre',
        // v34 — Roles, Acknowledgments, MVA Window
        role_admin: 'Administrator',
        role_auditor: 'Revisor',
        accountant_name_label: 'Regnskapsfører',
        accountant_name_hint: 'Navn som i kundeliste',
        ack_checked: 'Sjekket',
        ack_fixed: 'Rettet',
        ack_client_followup: 'Avventer klient',
        ack_info_note: 'Kommentar',
        ack_confirm_checked: 'Marker som gjennomgått',
        ack_confirm_fixed: 'Marker som rettet',
        ack_show_hidden: 'Vis godkjente',
        ack_hide_checked: 'Skjul godkjente',
        ack_undo: 'Angre',
        ack_save_failed: 'Lagringen er ikke bekreftet. Oppdater og kontroller status før du prøver igjen.',
        ack_undo_failed: 'Angre mislyktes — prøv igjen',
        ack_notes_placeholder: 'Legg til kommentar (valgfritt)',
        ack_checked_tooltip: 'Gjennomgått — vises ikke i neste revisjon',
        ack_fixed_tooltip: 'Rettet — kontrolleres på nytt i neste revisjon',
        ack_client_followup_tooltip: 'Registrerer behov for kontakt. Sender ingen melding og lukker ikke funnet.',
        ack_info_note_tooltip: 'Legg til valgfri kommentar til informasjons-punktet. Teller ikke i fremdrift.',
        // Permanent ignore (P0 fix 2026-04-27)
        ack_permanent: "Behold forklaring",
        ack_permanent_tooltip: "Forklaringen beholdes. Nye perioder eller endrede funn må vurderes på nytt.",
        ack_permanent_modal_title: 'Sjekket med beholdt begrunnelse',
        ack_permanent_warning_title: "Avgrenset forklaring",
        ack_permanent_warning_body: "Forklaringen gjelder disse dataene i denne perioden. Nye dokumenter, beløp eller perioder åpner kontrollen igjen.",
        ack_permanent_min_chars: 'Minimum 10 tegn. Begrunn hvilke data forklaringen gjelder.',
        ack_permanent_confirm: 'Bekreft sjekket og behold begrunnelse',
        ack_permanent_badge: 'Sjekket, begrunnelse beholdt',
        ack_permanent_note_placeholder: 'Beskriv avklaringen og hvilke dokumenter, fakta og perioder den gjelder.',
        audit_window_locked: 'Revisjon er kun tilgjengelig i MVA-vinduet',
        audit_window_info: (term, start, end) => `MVA-vindu ${term}: ${start}–${end}, kl. 08:00–17:00`,
        audit_window_next: 'Neste vindu',
        audit_window_open: 'MVA-vindu åpent',
        admin_ack_summary: 'Teamoversikt',
        admin_firms_total: 'Selskaper',
        admin_findings_checked: 'Sjekket',
        admin_findings_fixed: 'Rettet',
        admin_findings_open: 'Åpne',
        admin_not_reviewed: 'Ikke gjennomgått',
        team_period: 'Periode',
        team_accountant: 'Regnskapsfører',
        team_firms: 'Klienter',
        team_audited: 'Revidert',
        team_errors: 'Feil',
        team_warnings: 'Advarsler',
        team_err_per_firm: 'Feil/firma',
        team_avg_score: 'Snitt',
        team_review_pct: 'Gjennomgått',
        team_last_audit: 'Siste',
        team_open_report: 'Se rapport',
        team_no_data: 'Kjør revisjon først for å se teamoversikt',
        team_run_audit: 'Gå til revisjon',
        team_back: 'Tilbake til oversikt',
        team_firm: 'Firma',
        team_score: 'Score',
        team_findings: 'Funn',
        team_reviewed: 'Gjennomgått',
        team_open: 'Åpne',
        team_fixed_by: 'Rettet av',
        team_checked_by: 'Sjekket av',
        team_activity_log: 'Aktivitetslogg',
        team_no_activity: 'Ingen aktivitet ennå',
        team_all: 'Alle',
        team_period_label: (y, m) => `pr ${String(m).padStart(2,'0')}.${y}`,
        // Dashboard Hero
        hero_audited: 'Revidert',
        hero_average: 'Gjennomsnitt',
        hero_critical: 'Kritisk',
        hero_critical_desc: (n) => `firmaer under ${n}`,
        hero_fixed: 'Løst',
        hero_fixed_pct: 'rettet',
        hero_completed_pct: 'fullført',
        hero_attention: 'Krever oppmerksomhet',
        hero_errors: 'feil',
        // Firm Timeline
        timeline_loading: 'Laster historikk...',
        timeline_first_audit: 'Første revisjon — ingen historikk ennå',
        timeline_1_period: 'Historikk (1 periode)',
        timeline_n_periods: (n) => `Historikk (${n} perioder)`,
        timeline_trend_next: 'trend vises etter neste revisjon',
        // Notify
        notify_sending: 'Sender...',
        notify_send_accountant: 'Forhåndsvis varsel til regnskapsfører',
        notify_sent: 'E-post sendt',
        notify_sent_n: (n) => `E-post sendt til ${n} regnskapsfører${n > 1 ? 'e' : ''}`,
        notify_none_sent: 'Ingen e-poster sendt',
        notify_failed: 'Sending feilet',
        notify_send_all: 'Forhåndsvis varsler',
        notify_confirm_all: (n) => `Sende e-postvarsel til regnskapsførere for ${n} selskap? (én samle-e-post per regnskapsfører)`,
        notify_badge_sent: 'Varslet',
        notify_badge_sent_title: 'Varsel sendt til regnskapsfører for denne perioden',
        dashboard_filter_sent: 'Varslet',
        dashboard_filter_not_sent: 'Ikke varslet',
        no_activity_badge: 'Ingen bevegelser',
        no_activity_title: 'Ingen føringer i valgt periode',
        no_activity_report: 'Dette selskapet har ingen føringer i valgt periode — lite å revidere.',
        // Reports tabs
        reports_tab_analytics: 'Analyse',
        reports_tab_team: 'Team',
        // Misc
        unassigned: 'Ikke tildelt',
        sidebar_show: 'Vis sidepanel',
        sidebar_hide: 'Skjul sidepanel',
        av_poeng: 'av 10.0 poeng',
        current_run: 'Gjeldende revisjon',
        latest: 'Siste',
        // --- i18n comprehensive fix: missing keys ---
        // Month names (short)
        month_short_1: 'Jan',
        month_short_2: 'Feb',
        month_short_3: 'Mar',
        month_short_4: 'Apr',
        month_short_5: 'Mai',
        month_short_6: 'Jun',
        month_short_7: 'Jul',
        month_short_8: 'Aug',
        month_short_9: 'Sep',
        month_short_10: 'Okt',
        month_short_11: 'Nov',
        month_short_12: 'Des',
        // CSV export
        csv_firma: 'Firma',
        csv_system: 'System',
        csv_accountant: 'Regnskapsfører',
        csv_score: 'Score',
        csv_errors: 'Feil',
        csv_warnings: 'Advarsler',
        csv_reviewed: 'Gjennomgått',
        csv_notes: 'Notater',
        csv_yes: 'Ja',
        csv_no: 'Nei',
        csv_exported: 'CSV eksportert',
        // Error messages
        error_generic: 'Feil',
        error_login: 'Innlogging mislyktes',
        error_verify: 'Verifisering mislyktes',
        error_reset: 'Tilbakestilling mislyktes',
        error_failed: 'Feilet',
        // PDF
        pdf_report_title: 'Revisjonsrapport',
        pdf_no_data: 'Ingen data å eksportere',
        pdf_generated: 'Generert',
        pdf_no_report: 'Ingen rapport å eksportere',
        // Misc labels
        label_feil: 'feil',
        label_advarsler: 'advarsler',
        label_info: 'info',
        // Confirm dialog
        confirm_cancel: 'Avbryt',
        confirm_ok: 'OK',
        // Data preview modal
        search_placeholder: 'Søk...',
        no_results: 'Ingen resultater',
        fileSaldo: 'Saldobalanse',
        fileResultat: 'Resultatrapport',
        col_account: 'Konto',
        col_name: 'Navn',
        col_accNum: 'Konto',
        col_currentIb: 'IB i år',
        col_previousUb: 'UB i fjor',
        col_diff: 'Differanse',
        col_total: 'Totalt',
        // PDF metric labels
        nav_errors: 'Feil',
        nav_warnings: 'Advarsler',
        more_rows: 'flere rader',
        // Auth — missing keys
        auth_passwords_mismatch: 'Passordene stemmer ikke overens',
        auth_confirm_password: 'Bekreft passord',
        // Toast messages
        toast_digest_sent: 'Rapport sendt på e-post',
        toast_ack_no_client: 'Feil: klient-ID mangler, kan ikke lagre',
        toast_ack_network_error: 'Lagring feilet: nettverksfeil',
        toast_syncing_kundeliste: 'Synkroniserer kundeliste...',
        toast_email_saved: 'E-post lagret',
        toast_email_error: 'Feil ved lagring av e-post',
        // Confirm dialogs
        confirm_select_title: 'Velg alle?',
        confirm_select_many: 'Vil du velge {0} firmaer?',
        confirm_abort_message: 'Er du sikker p\u00e5 at du vil avbryte?',
        // Auditor empty state
        auditor_no_results_title: 'Ingen revisjon funnet for dine klienter',
        auditor_no_results_desc: 'Administrator har ikke kj\u00f8rt revisjon enn\u00e5, eller det finnes ingen resultater for dine klienter.',
        // Dashboard
        dashboard_reset_filters: 'Tilbakestill filtre',
        reaudit: 'Kj\u00f8r revisjon p\u00e5 nytt',
        // --- MVA period check evidence text ---
        mva_termin: 'Termin',
        mva_utg_endring: 'Utg\u00e5ende MVA (endring)',
        mva_inn_endring: 'Inng\u00e5ende MVA (endring)',
        mva_beregnet: 'Netto bevegelse, inkludert omposteringer',
        mva_2740_saldo: '2740 saldo ved terminslutt',
        mva_uavstemte: 'Nye eller endrede restsaldoer',
        mva_termin_ok: (n) => `${n} termin(er) uten nye restsaldoer i denne kontrollen. Dette bekrefter ikke avstemming.`,
        mva_alle_ok: (n) => `${n} terminer kontrollert. Avstemming mot MVA-meldingen og innsending er ikke bekreftet her.`,
        mva_partial_period: 'Ufullstendige MVA-terminer i den valgte perioden er ikke kontrollert. Velg begge månedene i terminen.',
        voucher_ids_missing: (n, total) => `Kontrollen er ikke utført: ${n} av ${total} transaksjonslinjer mangler bilagsidentifikator. Hent fullstendige bilagsdata før denne kontrollen kan godkjennes.`,
        voucher_sample_small: 'Kontrollen er ikke utført: færre enn fem bilag med flere linjer. Kontroller bilagene manuelt.',
        voucher_convention_unknown: 'Kontrollen er ikke godkjent: over 30 % av bilagene balanserer ikke. Kontroller datagrunnlaget og fortegnene før ny beregning.',
        // --- Amortization group label ---
        amort_konto_group: (from, to, count) => `Konto ${from}\u2013${to} (${count} kontoer)`,
        // --- Invoice numbering gap ---
        invoice_gap: (from, to, missing, list) => `Luka: ${from} \u2192 ${to} (${missing} manglende: ${list})`,
        invoice_gap_more: '...',
        // --- Transaction detail labels ---
        tx_stempel: 'Stempel',
        tx_linkid: 'LinkId',
        tx_bundleid: 'BundleId',
        tx_faktura: 'Faktura',
        tx_konto: 'Konto',
        tx_id: 'ID',
        // --- Transaction skip fallback ---
        tx_skip_reason: (reason) => `\n\n\u00c5rsak: ${reason}`,
        tx_coverage_gap: (kontoer, mangler, verstKonto) =>
            `transaksjonslinjene dekker ikke saldobalansen p\u00e5 ${kontoer} konto (st\u00f8rst avvik: konto ${verstKonto}). Til sammen mangler ca. ${mangler.toLocaleString('nb-NO')} kr i linjer mot bevegelsen i saldobalansen, s\u00e5 uttrekket er ufullstendig.`,
        otp_ratio_desc: (salary, pension, ratio) => `Lønn i perioden: ${salary} kr. Netto pensjonskostnad: ${pension} kr (${ratio}%).`,
        otp_ratio_review: "Forholdet er under referansen 2 %. Avklar plikt, ansattgrunnlag, kontoomfang, fakturaperioder og premiefond. Dette er et avstemmingssignal, ikke en restanse.",
        otp_ratio_context: "Forholdstallet bekrefter ikke at OTP-plikten er oppfylt. Ansattgrunnlag, fakturaperioder og premiefond er ikke kontrollert.",
        audit_scope_unchecked: "Ikke vurdert: tilgjengelige data er ikke tilstrekkelige til å avgjøre kontrollen.",
        prior_year_data_missing: "Årsavslutning er ikke kontrollert: resultatrapport for hele foregående år mangler.",
        mva_scope_only: "Ingen signaler i posteringene som omfattes av regelen. Unntak og øvrige posteringer krever bilagskontroll; korrekt MVA er ikke bekreftet.",
        audit_coverage_notice: (count) => `${count} kontroller er ikke avgjort. Poengsummen gjelder påviste avvik, ikke regnskapets fullstendighet.`,
        tier_resolved: "Avklart eller rettet i dette omfanget",
        audit_coverage_title: "Kontroller uten tilstrekkelig grunnlag",
        prior_year_check_title: "Årsavslutning: mangler fullstendige fjorårsdata",
        audit_review_notice: (n) => `${n} kontrollsignaler krever avklaring. De er ikke bekreftede feil og trekker ikke poeng.`,
        audit_score_limited: 'Poeng for utførte kontroller. Uavklarte signaler eller begrenset grunnlag gjenstår.',
        audit_unresolved_count: (n) => `${n} uavklart`,
        coverage_reason_saldo: 'Mangler saldobalanse.',
        coverage_reason_disabled: 'Kontrollen er deaktivert og er ikke utført.',
        coverage_reason_resultat: 'Mangler resultatdata.',
        coverage_reason_both: 'Mangler balanse- eller resultatdata.',
        coverage_reason_transactions: 'Transaksjoner mangler eller er ufullstendige.',
        coverage_reason_context: 'Kontrollens forutsetninger er ikke oppfylt. Se forklaringen ved kontrollen.',
        bulk_ack_partial: (n) => `Lagringen ble ikke fullført. ${n} bekreftelser er lagret; last inn status på nytt før du fortsetter.`,
        audit_signals_label: 'Kontrollsignaler',
        ack_legacy_notice: (n) => `${n} tidligere avklaringer bevart i historikken`,
        ack_legacy_scope: 'Disse notatene er bevart. De var knyttet til en regel, ikke bestemte bilag. Ny fremdrift teller bare avklaringer med identifiserbart grunnlag; null betyr ikke at tidligere arbeid er slettet.',
        ack_evidence_missing: 'Kan ikke lagre: kontrollen mangler identifiserbart grunnlag. Last inn rapporten på nytt.',
        audit_unchecked_label: 'Ikke avklart',
        mva_subset_passed: (n) => `MVA-beløp finnes i ${n} kontrollerte bilag. Sats, fradragsrett og bilag utenfor kontrollens omfang er ikke vurdert.`,
    },
    pl: {
        balance_age_no_transactions: 'Nie ustalono składu salda po miesiącach, ponieważ brak linii transakcji.',
        balance_age_atypical: (account, ub) => `Konto ${account}: UB ${ub}. Saldo po stronie nietypowej, prawdopodobnie błąd. Sprawdź i popraw księgowanie.`,
        balance_age_older: (account, ub, parts) => `Konto ${account}: UB ${ub}. Saldo przypisano do najnowszych księgowań po normalnej stronie konta, a resztę do IB z poprzedniego roku. Skład od najstarszego: ${parts}.`,
        balance_age_unavailable: (account, ub) => `Konto ${account}: UB ${ub}. Brak okresu lub danych miesięcznych; nie można ustalić wieku salda. Sprawdź podstawę.`,
        rule_saldo_1530: 'Przychód naliczony, niezafakturowany – konto 1530',
        rule_saldo_1530_amounts: (ib, change, ub) => `Konto 1530: IB ${ib}, ruch okresu ${change}, UB ${ub}.`,
        rule_saldo_1530_negative_ub: 'Konto należności ma saldo ujemne. Sprawdź i popraw księgowanie.',
        rule_saldo_1530_current_year: 'Saldo powstało w bieżącym roku. Sprawdź, czy przychód został prawidłowo naliczony.',
        rule_saldo_1530_negative_ib: 'Saldo początkowe z poprzedniego roku było ujemne. Sprawdź podstawę i popraw ewentualne błędy.',
        rule_saldo_1530_unreversed: 'Kwota z poprzedniego roku nie została odwrócona. Odwróć periodisering.',
        rule_saldo_1530_increased: 'IB nie zostało odwrócone albo dopisano nowe kwoty. Sprawdź periodyzację.',
        rule_saldo_1530_partial: 'Część IB pozostała. Sprawdź, czy reszta powinna zostać odwrócona.',
        rule_saldo_1530_ub_only: (ub) => `Konto 1530 ma UB ${ub}. Brak kompletnej podstawy IB i ruchu. Sprawdź naliczony, niezafakturowany przychód.`,
        action_saldo_1530: 'Kwoty z poprzedniego roku i starszych miesięcy powinny być już odwrócone. Sprawdź odwrócenia na koncie 1530.',
        action_balance_age_atypical: 'Sprawdź, które księgowanie daje saldo po nietypowej stronie, i popraw je.',
        action_balance_age_unavailable: 'Saldo nie jest rozpisane na miesiące, bo brak linii księgowań. Uzgodnij saldo z dokumentami.',
        rule_personalkostnader_negative: 'Ujemne koszty pracownicze 5000–5999',
        rule_personalkostnader_negative_desc: (total, top) => `Suma kont 5000–5999 za okres wynosi ${total}. Największy wpływ (do trzech kont): ${top}. Sprawdź korekty i znaki księgowań.`,
        action_personalkostnader_negative: 'Uzgodnij ujemne koszty pracownicze z dokumentacją płacową i korektami.',
        rule_arsregnskap_mangler: 'Brak sprawozdania rocznego w Regnskapsregisteret',
        arsregnskap_no_year: 'brak zarejestrowanych sprawozdań',
        rule_arsregnskap_mangler_desc: (required, last, year) => `Brak sprawozdania za ${required} w Regnskapsregisteret. Ostatni zarejestrowany rok sprawozdawczy: ${last}. Termin 31.07.${year} minął. Za każdy tydzień zwłoki nalicza się forsinkelsesgebyr. Sprawdź w Altinn, czy sprawozdanie zostało wysłane i przyjęte.`,
        action_arsregnskap_mangler: 'Sprawdź potwierdzenie wysłania i przyjęcia w Altinn; wyjaśnij brak sprawozdania.',
        rule_skattetrekk_2610_balance: 'Saldo na koncie skattetrekk 2610',
        rule_skattetrekk_2610_balance_desc: (months) => 'Konto 2610 ma saldo końcowe o wartości bezwzględnej powyżej 1 kr. Wyjaśnij i uzgodnij saldo.' + (months == null ? '' : ` Liczba miesięcy z niezerowym ruchem netto na 2610 w dostępnych transakcjach: ${months}.`),
        action_skattetrekk_2610_balance: 'Potrącenia sprzed ostatniego miesiąca powinny być już zapłacone. Uzgodnij z wpłatami do Skatteetaten.',
        rule_skattetrekk_1950_balance: 'Saldo na dawnym koncie skattetrekk 1950',
        rule_skattetrekk_1950_balance_desc: 'Konto 1950 ma saldo końcowe o wartości bezwzględnej powyżej 1 kr. System rachunków skattetrekk został zniesiony od 2026; saldo wymaga wyjaśnienia.',
        action_skattetrekk_1950_balance: 'Sprawdź dokumentację bankową i wyjaśnij przeniesienie lub przeksięgowanie pozostałego salda 1950.',
        rule_financial_income_sign_80xx: 'Nieprawidłowy znak przychodów finansowych 8050/8060',
        rule_financial_income_sign_80xx_desc: 'Konto 8050 lub 8060 ma sumę wyniku za okres co najmniej 500 kr bezwzględnie, ze znakiem przeciwnym do przychodu w wybranym systemie księgowym.',
        action_financial_income_sign_80xx: 'Sprawdź dokumenty, storna i dobór kont 8050/8060; popraw ewentualne błędne księgowania.',
        rule_financial_cost_sign_815x_816x: 'Nieprawidłowy znak kosztów finansowych 8150–8169',
        rule_financial_cost_sign_815x_816x_desc: 'Konto z zakresu 8150–8169 ma sumę wyniku za okres co najmniej 500 kr bezwzględnie, ze znakiem przeciwnym do kosztu w wybranym systemie księgowym.',
        action_financial_cost_sign_815x_816x: 'Sprawdź dokumenty i storna na 8150–8169 z dokumentacją odsetek i kosztów finansowych.',
        rule_periodisering_2900_balance: 'Saldo na koncie rozliczeń okresowych 2900',
        rule_periodisering_2900_balance_desc: 'Konto 2900 ma saldo końcowe o wartości bezwzględnej powyżej 1 kr. Wyjaśnij podstawę rozliczenia i termin jego odwrócenia.',
        action_periodisering_2900_balance: 'Kwoty starsze niż ostatni miesiąc nie zostały rozliczone. Sprawdź periodisering na koncie 2900.',
        rule_7790_7798: 'Jednoczesne użycie kont 7790 i 7798',
        rule_7790_7798_desc: 'Oba konta 7790 i 7798 mają niezerowe saldo. Sprawdź, czy ten sam rodzaj kosztu nie został podzielony między konta.',
        action_7790_7798: 'Wybierz jedno z kont 7790 lub 7798 i przeksięguj drugie.',
        action_conflict_7790_7798: 'Wybierz jedno z kont 7790 lub 7798 i przeksięguj drugie.',
        rule_mva_registered_no_vat_postings: 'Rejestracja MVA bez wykazanego ruchu MVA',
        rule_mva_registered_no_vat_postings_desc: (company) => `${company || 'Firma'} jest zarejestrowana w MVA, ale dostępne dane nie wykazują ruchu ani salda o wartości bezwzględnej powyżej 1 kr na kontach 2700–2749 ani dostępnych linii transakcji na tych kontach.`,
        action_mva_registered_no_vat_postings: 'Sprawdź aktywność w okresie, kody MVA, deklaracje MVA i kompletność danych księgowych.',
        otp_basis_mixed: "Konto łączy OTP z AFP. Bez rozbicia nie obliczamy wskaźnika OTP.",
        otp_ytd_missing: "Nie uzyskano wynagrodzeń i składek od stycznia do końca audytu; kontrola OTP nie została wykonana.",
        otp_source_unverified: 'Nie potwierdzono identyfikatora firmy w obu odpowiedziach źródłowych. Pobierz dane ponownie, aby obliczyć OTP.',
        project_pnl_missing_ids: 'Część zapisów ma nazwę projektu bez identyfikatora. Nie można potwierdzić rozdzielenia projektów.',
        evidence_voucher: "Numer księgowy (bilagu)",
        evidence_stamp: "Stempel (ID dokumentu)",
        evidence_invoice: "Numer faktury",
        evidence_date: "Data księgowania",
        evidence_description: "Opis",
        evidence_amount: "Kwota (NOK)",
        evidence_record_id: "Identyfikator zapisu",
        evidence_project: "Projekt",
        evidence_project_id: "ID projektu",
        evidence_assigned_sales: "Przychody przypisane (NOK)",
        evidence_assigned_costs: "Koszty przypisane (NOK)",
        evidence_assigned_net: "Wynik przypisanych zapisów (NOK)",
        evidence_tx_count: "Liczba zapisów",
        evidence_note: "Okres / uwagi",
        evidence_entity_type: "Rodzaj",
        evidence_entity_name: "Projekt / klient",
        evidence_booked_sales: "Przychody księgowe netto (NOK)",
        invoice_registry_missing: "Brak pełnego rejestru faktur z seriami numeracji i anulowaniami; numeracja nie została sprawdzona.",
        vat_document_evidence_missing: "Brak kwoty i kodu VAT z dokumentu źródłowego; VAT nie został sprawdzony.",
        otp_period_unknown: "Brak okresu objętego kontrolą OTP.",
        audit_history_score: "Historyczny wynik. Uruchom ponowny audyt, aby uzyskać aktualną ocenę.",
        audit_history_notice: "Ukryto ustalenia z wycofanych kontroli. Oryginalny raport, dowody i wynik pozostają zapisane; wynik nie został przeliczony.",
        vat_legacy_scope: "Zapisany raport nie zawiera danych terminów ani statusów Oppgaver. Historyczne salda kont zachowano. Uruchom ponowny audyt; treść deklaracji nie została sprawdzona.",
        otp_period_scope: (year,from,to) => (year + ', miesiące kontroli OTP: ' + from + '-' + to + '.'),
        utbytte_change_unknown: 'Brak danych o zmianie netto na 2800/2801; nie można wnioskować o wypłatach.',
        mva_carried: "Saldo przeniesione z poprzedniego terminu, nadal do wyjaśnienia",
        duplicates_weak_title: "Jednakowe kwoty w różnych dokumentach: słaby sygnał",
        previous_balance_date_unknown: "data wcześniejszego salda niedostępna",
        no_data: "Brak danych",
        evidence_no_monthly_breakdown: 'Raport nie zawiera rozbicia miesięcznego',
        evidence_monthly_movements: 'Kolumny miesięcy pokazują ruch netto. Saldo (UB) oznacza saldo na koniec okresu.',
        none: "Brak",
        duplicates_evidence_desc: (all,strong,weak) => `${all} grup z tym samym numerem faktury, zidentyfikowanym kontrahentem i identycznym pełnym księgowaniem w różnych bilagach. Nie znaleziono wystarczającego storna. Przed korektą sprawdź dokumenty źródłowe.`,
        bank_change_no_comparison: 'Brak por\u00f3wnania',
        bank_eom_observed: (negative,drops) => `1920, ujemne salda końca miesiąca: ${negative}. Spadki ponad 50% wobec poprzedniego miesiąca: ${drops}. To historyczne salda księgowe, nie dzisiejsze saldo banku.`,
        revisor_registered: (names, date) => `Rewident zarejestrowany w Brreg: ${names}. Odczyt: ${date}.`,
        revisor_empty: (date) => `Brak zarejestrowanego rewidenta w odpowiedzi Brreg. Odczyt: ${date}.`,
        revisor_unknown: 'Nie udało się potwierdzić rewidenta w Brreg. Brak danych nie oznacza, że firma nie ma rewidenta.',
        revisor_boundary: 'Informacja dotyczy rejestru w chwili odczytu, nie stanu historycznego w audytowanym okresie. Wpis nie potwierdza wykonania rewizji.',
        revisor_source: (source) => `Źródło: Brreg, zarejestrowane role (REVI). ${source}`,
        dividend_net_desc: (amount) => `Saldo netto kont 2800/2801: ${amount} kr. Uzgodnij uchwały, wypłaty i przeksięgowania. Samo saldo nie dowodzi uchwalonej ani niewypłaconej dywidendy.`,

        selectSystem: 'Wybierz System Ksi\u0119gowy',
        changeSystem: 'Zmie\u0144 system',
        uploadFiles: 'Wgraj Pliki',
        dropHere: 'Upu\u015b\u0107 pliki tutaj!',
        dragHere: 'Przeci\u0105gnij pliki tutaj',
        filesDesc: 'Bilans sald oraz Rachunek wyników (CSV)',
        selectFromDisk: 'Wybierz z dysku',
        waitingSaldo: 'Oczekuj\u0119 na Bilans sald...',
        waitingResultat: 'Oczekuj\u0119 na Rachunek wynik\u00f3w...',
        runAuditBtn: 'Uruchom Audyt',
        auditResult: 'Wynik Audytu',
        collapse: 'Zwi\u0144',
        expand: 'Rozwi\u0144',
        fullPreview: 'Pe\u0142ny Podgl\u0105d',
        newFiles: 'Nowe pliki',
        exportData: 'Eksportuj przetworzone dane:',
        zipAll: 'ZIP (Wszystko)',
        generatingPdf: 'Generuj\u0119 PDF...',
        downloadPdf: 'Pobierz raport (PDF)',
        noErrors: 'Brak dodatkowych b\u0142\u0119d\u00f3w!',
        dataPreviewTitle: 'Pe\u0142ny Podgl\u0105d Danych',
        tabSaldo: 'Bilans sald',
        tabResultat: 'Rachunek wynik\u00f3w',
        searchAccount: 'Szukaj konta...',
        account: 'Konto',
        accountName: 'Nazwa',
        change: 'Zmiana',
        sum: 'Suma',
        saldoUB: 'Saldo (UB)',
        currentIb: 'IB bie\u017c\u0105cy',
        previousUb: 'UB poprzedni',
        diff: 'R\u00f3\u017cnica',
        month: 'Miesi\u0105c',
        sumVertical: 'Suma (Pionowa)',
        status: 'Status',
        algoStatus: 'Status Algorytmu',
        retired: 'Wycofane/Zero',
        noDepreciation: 'BRAK ODPIS\u00d3W',
        deprAccumulated: 'OK (zbiorcza amort.)',
        newPurchase: 'Nowy zakup?',
        investment: 'Inwestycja (+)',
        wrongSign: 'Z\u0141Y ZNAK',
        noResultsFor: 'Brak wynik\u00f3w dla',
        errorOccurred: 'Wyst\u0105pi\u0142 b\u0142\u0105d',
        errorDesc: 'Aplikacja napotkała nieoczekiwany problem. Od\u015bwie\u017c stron\u0119 i spr\u00f3buj ponownie.',
        refreshPage: 'Od\u015bwie\u017c stron\u0119',
        sumLabel: 'SUMA',
        sumAccounts5xxx: 'Suma kont 5000-5999',
        positive: 'dodatnia',
        negative: 'ujemna',
        subtitle_home: 'Automatyczny audyt norweskiej ksi\u0119gowo\u015bci',
        label_system: 'System',
        label_score: 'Wynik',
        label_total: '\u0141\u0105cznie',
        label_analyzing: 'Analizuj\u0119...',
        label_active_clients: 'aktywnych klient\u00f3w',
        label_audit_done: (name) => `Audyt zako\u0144czony: ${name}`,
        label_dark_mode: 'Tryb ciemny',
        label_light_mode: 'Tryb jasny',
        label_saldo_csv: 'Bilans sald (CSV)',
        label_resultat_csv: 'Rachunek wynik\u00f3w (CSV)',
        label_missing_key: 'Podaj URL i klucz API.',
        label_disabled_rules: (n) => `${n} reguł wyłączonych — ocena może być niepełna.`,
        toast_file_too_big: (name, sizeMB) => `Plik "${name}" przekracza limit 10 MB (${sizeMB} MB).`,
        toast_bad_mime: (name, mime) => `Nieobs\u0142ugiwany format pliku "${name}" (${mime}). Akceptowane: CSV, XLS, XLSX.`,
        toast_excel_error: (name, msg) => `B\u0142\u0105d konwersji Excel (${name}): ${msg}`,
        toast_unknown_type: (name, sysName) => `Nie rozpoznano typu pliku: "${name}". Sprawd\u017a czy wybra\u0142e\u015b w\u0142a\u015bciwy system (${sysName}).`,
        toast_parse_error: (name, msg) => `B\u0142\u0105d parsowania ${name}: ${msg}`,
        toast_no_accounts: (name, sysName) => `Nie znaleziono kont w pliku "${name}". Sprawd\u017a system (${sysName}) i format pliku.`,
        toast_loaded: (type, count, name) => `${type === 'saldo' ? 'Bilans sald' : 'Rachunek wynik\u00f3w'}: za\u0142adowano ${count} kont z "${name}"`,
        toast_missing_saldo: 'Uwaga: brakuje Bilansu sald \u2014 audyt bilansu nie zostanie wykonany. Wynik mo\u017ce by\u0107 niepe\u0142ny.',
        toast_missing_resultat: 'Uwaga: brakuje Rachunku wynik\u00f3w \u2014 analiza wyniku finansowego nie zostanie wykonana. Wynik mo\u017ce by\u0107 niepe\u0142ny.',
        toast_no_data: 'Brak danych do pobrania. Wgraj pliki najpierw.',
        toast_no_data_type: (type) => `Brak danych dla ${type}. Wgraj odpowiedni plik najpierw.`,
        toast_pdf_ok: 'PDF wygenerowany pomy\u015blnie.',
        toast_pdf_error: 'B\u0142\u0105d generowania PDF.',
        toast_zip_error: 'Nie uda\u0142o si\u0119 utworzy\u0107 archiwum ZIP.',
        toast_header_missing: 'Brak nag\u0142\u00f3wka',
        rule_financial_profit: 'Wynik Finansowy: ZYSK',
        rule_financial_loss: 'Wynik Finansowy: STRATA',
        rule_financial_desc: (amount) => `Suma wyniku: ${amount}.`,
        rule_neg_assets: 'Ujemne saldo aktyw\u00f3w (1xxx)',
        rule_neg_assets_desc: "Ujemne salda na wskazanych kontach 1xxx wymagają wyjaśnienia na podstawie rodzaju konta i zapisów.",
        rule_1580_title: 'Konto 1580 \u2014 rezerwa na straty',
        rule_1580_desc: 'Konto 1580 wykazuje saldo (rezerw\u0119 na straty). Nale\u017cy zweryfikowa\u0107 status zad\u0142u\u017cenia:\n\n\u2022 Czy podj\u0119to kroki windykacyjne (purring, inkassovarsel)?\n\u2022 Czy zaleg\u0142o\u015b\u0107 powinna zosta\u0107 przeksi\u0119gowana jako strata definitywna?\n\u2022 Czy d\u0142u\u017cnik og\u0142osi\u0142 upad\u0142o\u015b\u0107?',
        rule_pos_liabilities: 'Dodatnie saldo pasyw\u00f3w (2xxx)',
        rule_pos_liabilities_desc: 'Konta zobowi\u0105za\u0144 zwykle maj\u0105 saldo ujemne (Credit), ale cz\u0119\u015b\u0107 kont 2xxx mo\u017ce by\u0107 wyj\u0105tkiem. Sprawd\u017a, czy saldo wynika z poprawnego typu konta, czy z b\u0142\u0119dnej periodyzacji/klasyfikacji.',
        rule_pos_liabilities_payroll_bridge: 'System płac: przejście 2780/2785',
        rule_pos_liabilities_payroll_bridge_desc: 'Dodatnie saldo na 2780/2785 może wynikać ze zmiany systemu płac albo braku salda początkowego. Sprawdź powiązanie z 2785 z poprzedniego roku przed traktowaniem tego jako błędu.',
        rule_pos_liabilities_periodization: 'Konto periodyzacji 29xx z debetem',
        rule_pos_liabilities_periodization_desc: 'Konto 29xx ma dodatnie saldo. To może być tymczasowa periodyzacja odwracana w kolejnym okresie, więc punkt jest tylko informacją, o ile saldo nie zostaje na stałe.',
        rule_high_1571: 'Wysokie saldo 1571',
        rule_high_1571_desc: 'Saldo powy\u017cej 50 000 NOK. Wymagana weryfikacja.',
        rule_high_1370: 'Wysokie saldo 1370',
        rule_high_1370_desc: 'Saldo powy\u017cej 50 000 NOK na koncie 1370 (nale\u017cno\u015bci od w\u0142a\u015bcicieli). Wymagana dokumentacja \u2014 sprawd\u017a umow\u0119 po\u017cyczkow\u0105.',
        rule_7100: 'Kilometr\u00f3wka (7100)',
        rule_7100_desc: (amount, hasLonnSystem) => `Kwota: ${amount}\n\nSprawd\u017a:\n\u2022 Czy istnieje kj\u00f8rebok (ksi\u0105\u017cka jazd)? (data, trasa, cel, km)\n\u2022 Czy stawka jest poprawna? (maks 3,50 kr/km za pierwsze 10 000 km)\n${hasLonnSystem ? '\u2714 Firma ma system p\u0142ac \u2014 zweryfikuj czy 7100 jest raportowane przez A-melding (opplysningspliktig ytelse).' : '\u26a0 Firma nie ma systemu p\u0142ac (5000/2600) \u2014 nie mo\u017cna zweryfikowa\u0107 A-melding. Sprawd\u017a czy kilometr\u00f3wka jest poprawnie raportowana.'}`,
        rule_6301_no_rent: 'Potr\u0105cenia (6301) bez czynszu (6300)',
        rule_6301_no_rent_desc: 'Zaksi\u0119gowano potr\u0105cenia za mieszkanie, ale brak koszt\u00f3w najmu.',
        rule_6301_high: 'Potr\u0105cenie wy\u017csze ni\u017c czynsz (6301 > 6300)',
        rule_6301_high_desc: 'Firma wykazuje zysk na najmie pracowniczym.',
        rule_7791_7799: 'Konflikt 7791 i 7799',
        rule_7791_7799_desc: 'U\u017cyto obu kont jednocze\u015bnie. Nale\u017cy wybra\u0107 jedno.',
        rule_high_7791: 'Wysokie saldo 7791',
        rule_high_7791_desc: 'Powy\u017cej 30 000 NOK.',
        rule_4000_4300: 'Konflikt Handel/Produkcja',
        rule_4000_4300_desc: 'U\u017cyto konta towar\u00f3w (4000) i produkcji (4300). Sugerowane rozdzielenie.',
        rule_amort_12xx: 'Analiza Amortyzacji (12xx)',
        rule_amort_12xx_desc: 'Porównanie księgowych sald aktywów i odpisów; ewidencja środków trwałych nie została sprawdzona.',
        rule_amort_system_error: 'B\u0142\u0105d systemowy amortyzacji',
        rule_amort_system_error_desc: 'Istniej\u0105 aktywa, ale brak ksi\u0119gowa\u0144 na kontach amortyzacji (60xx). Uwaga: przy audycie za cz\u0119\u015b\u0107 roku odpisy mog\u0105 by\u0107 ksi\u0119gowane przy zamkni\u0119ciu roku.',
        rule_amort_partial_missing: 'Brak amortyzacji w okresie cz\u0105stkowym',
        rule_amort_partial_missing_desc: 'Istniej\u0105 \u015brodki trwa\u0142e, ale w tym okresie cz\u0105stkowym nie ma ksi\u0119gowa\u0144 na kontach amortyzacji (60xx). To mo\u017ce by\u0107 poprawne, je\u015bli amortyzacja jest ksi\u0119gowana przy zamkni\u0119ciu roku, ale nale\u017cy to sprawdzi\u0107.',
        rule_wrong_sign_costs: 'Koszty z przeciwnym znakiem (4xxx-7xxx)',
        rule_wrong_sign_costs_desc: (sysName, expected) => `Dla systemu ${sysName} kontrola porównuje znak sumy kosztów z konwencją przyjętą w konfiguracji (${expected}). Odmienny znak wymaga sprawdzenia konwencji raportu i zapisów; sam nie potwierdza błędu.`,
        rule_anomalies_6xxx: 'Anomalie w kosztach (6xxx)',
        rule_anomalies_6xxx_desc: "Wskazane miesiące zawierają wartości 0 lub kwoty odbiegające od średniej miesięcznej. To sygnał porównawczy, a nie potwierdzony błąd księgowania.",
        rule_high_6540: 'Wysoki zakup wyposa\u017cenia (6540)',
        rule_high_6540_desc: 'Pojedynczy bilag/postering na 6540 przekracza 30 000 NOK. Rozwa\u017c czy koszt nie powinien zosta\u0107 aktywowany jako \u015brodek trwa\u0142y.',
        rule_salary_sign: 'Płace: miesięczna suma 5xxx do wyjaśnienia',
        rule_salary_sign_desc: 'Miesięczna suma kont 5000-5999 ma znak przeciwny do konwencji kosztów. To sygnał do kontroli, nie potwierdzony błąd. Sprawdź konta i oznaczone miesiące.',
        rule_missing_5920: 'Brak ubezpieczenia wypadkowego (5920)',
        rule_missing_5920_desc: 'Zaksi\u0119gowano wynagrodzenia (konto 5000), ale brakuje ubezpieczenia wypadkowego na koncie 5920. Ubezpieczenie wypadkowe jest obowi\u0105zkowe.',
        rule_skattetrekk: 'Zaliczka na podatek: brak potr\u0105ce\u0144 (2600)',
        rule_skattetrekk_desc: 'Firma wyp\u0142aca wynagrodzenia (konto 5000), ale konto 2600/26xx nie pojawia si\u0119 w raporcie. Sprawd\u017a, czy forskuddstrekk jest naliczony i op\u0142acony razem z wynagrodzeniem. Je\u015bli jest uzgodniony, oznacz punkt jako Sprawdzone.',
        rule_aga: 'Sk\u0142adka pracodawcy: brak AGA (5400)',
        rule_aga_desc: 'Firma wyp\u0142aca wynagrodzenia (konto 5000), ale nie nalicza sk\u0142adki pracodawcy (konto 5400). AGA jest obowi\u0105zkowe przy wyp\u0142acie wynagrodze\u0144.',
        rule_feriepenger: 'Wynagrodzenie urlopowe: brak naliczenia',
        rule_feriepenger_desc: 'Firma wyp\u0142aca wynagrodzenia (konto 5000), ale nie nalicza wynagrodzenia urlopowego (konto 5020/5021/5090-5093/5210/5211). Wynagrodzenie urlopowe = 10.2% (12% dla 60+) wynagrodzenia.',
        rule_otp: "OTP: relacja kosztów do wynagrodzeń",
        rule_otp_desc: "Relacja kosztów OTP do wynagrodzeń jest wskaźnikiem do weryfikacji, nie wyliczeniem obowiązku ani zaległości.",
        rule_balanse_error: 'Balansekontroll: aktywa \u2260 pasywa',
        rule_balanse_error_desc: (sumA, sumP, diff) => `Suma aktyw\u00f3w (1xxx): ${sumA}\nSuma pasyw\u00f3w (2xxx): ${sumP}\nR\u00f3\u017cnica: ${diff}\n\nAktywa + Pasywa powinny sumowa\u0107 si\u0119 do 0. Niezgodno\u015b\u0107 mo\u017ce wynika\u0107 z brakuj\u0105cego bilansu otwarcia (IB/tilleggspostering) lub b\u0142\u0119du ksi\u0119gowego.`,
        rule_balanse_partial: 'Balansekontroll: brak pe\u0142nej sumy raportu',
        rule_balanse_partial_desc: (sumA, sumP, diff) => `Suma aktyw\u00f3w z API (1xxx): ${sumA}\nSuma pasyw\u00f3w/kapita\u0142u z API (2xxx): ${sumP}\nR\u00f3\u017cnica po wyniku: ${diff}\n\nDane GetAggregated z API nie zawsze zawieraj\u0105 t\u0119 sam\u0105 sum\u0119 ko\u0144cow\u0105, kt\u00f3r\u0105 wida\u0107 w balanserapport, np. "Sum egenkapital og gjeld". To sygna\u0142 o niepe\u0142nych danych wej\u015bciowych, nie b\u0142\u0105d ksi\u0119gowy, i nie obni\u017ca score.`,
        rule_balanse_ok: 'Balansekontroll: OK',
        rule_balanse_ok_desc: (sumA, sumP) => `Aktywa (${sumA}) + Pasywa (${sumP}) = balans OK.`,
        rule_neg_equity: 'Ujemny kapita\u0142 w\u0142asny (konto 2050)',
        rule_neg_equity_desc: (amount) => `Kapita\u0142 w\u0142asny jest dodatni (${amount}) \u2014 oznacza to, \u017ce sp\u00f3\u0142ka utraci\u0142a kapita\u0142 w\u0142asny.\nObowi\u0105zek dzia\u0142ania wg aksjeloven \u00a7 3-4: zarz\u0105d musi podj\u0105\u0107 dzia\u0142ania.`,
        rule_kasse_neg: 'Kassekonto 1900: ujemne saldo',
        rule_kasse_neg_desc: (amount) => `Saldo kasy: ${amount}. Ujemne saldo kasy jest fizycznie niemo\u017cliwe \u2014 nie mo\u017cna mie\u0107 mniej ni\u017c 0 NOK w kasie. Prawdopodobnie brakuje dokument\u00f3w ksi\u0119gowych lub jest b\u0142\u0105d w ksi\u0119gowaniu.`,
        rule_mva: 'Uzgodnienie MVA: netto pozycja MVA',
        rule_mva_desc: (utg, inn, netto) => `MVA nale\u017cny (2700-2709): ${utg}\nMVA naliczony (2710-2719): ${inn}\nNetto pozycja MVA: ${netto}\n\nNetto MVA powinno by\u0107 bliskie 0 gdy wszystkie terminy s\u0105 zadeklarowane i zap\u0142acone.`,
        rule_mva_period: 'Kontrola okres\u00f3w MVA',
        rule_mva_period_desc: (month) => 'Dla każdego terminu pokazujemy status wysyłki z Oppgaver i salda kont VAT. Pozostałe saldo wymaga uzgodnienia, ale samo nie dowodzi pominięcia zapisów w deklaracji.',
        mva_balance_latest: (month) => 'saldo na ' + month,
        mva_balance_since: (from, to) => 'ta sama kwota na końcach terminów od ' + from + ' do ' + to,
        rule_mva_period_ok: 'W badanej księdze nie znaleziono nowych niewyjaśnionych sald pozostałych.',
        rule_bil: 'Prywatne u\u017cytkowanie samochodu: brak korekty (7099)',
        rule_bil_desc: 'Firma ma koszty samochodu (konto 7000), ale brak korekty za prywatne u\u017cytkowanie (konto 7099). Je\u015bli samoch\u00f3d jest u\u017cywany prywatnie, korekta jest obowi\u0105zkowa.',
        rule_period_label: 'Periodyzacja: du\u017ce kwoty w ostatnim miesi\u0105cu',
        rule_period: (month, accId) => `Periodyzacja: du\u017ca kwota w ${month} na koncie ${accId}`,
        rule_period_desc: (accId, accName, month, amount, avg) => `Konto ${accId} (${accName}): kwota w ${month} = ${amount}, \u015brednia pozosta\u0142ych miesi\u0119cy = ${avg}.\n\n${month} > 3\u00d7 \u015brednia \u2014 sprawd\u017a czy koszt powinien by\u0107 roz\u0142o\u017cony na okresy.`,
        rule_kundefordringer: 'Nale\u017cno\u015bci od klient\u00f3w vs obr\u00f3t: wysoki poziom nale\u017cno\u015bci',
        rule_kundefordringer_desc: (kf, oms, pct) => `Nale\u017cno\u015bci od klient\u00f3w (1500): ${kf}\nObr\u00f3t (3xxx): ${oms}\nStosunek: ${pct}%\n\nNale\u017cno\u015bci stanowi\u0105 ponad 25% obrotu. Sprawd\u017a status windykacji i rezerwy na straty.`,
        rule_revisjon: 'Obowiązek rewizji: brak zarejestrowanego rewizora',
        rule_revisjon_fravalg_mulig: 'Zarejestrowany rewizor: możliwe zwolnienie wymaga ustalenia',
        rule_revisjon_fravalg_mulig_desc: (income, assets, year) => `Firma ma zarejestrowanego rewizora. Liczby z ostatniego pełnego roku (${year}) są poniżej progów kwotowych aksjeloven § 7-6: przychody operacyjne całej działalności ${income} (< 7 000 000 kr), suma bilansowa ${assets} (< 27 000 000 kr). Potwierdź, że podstawą jest ostatnie roczne sprawozdanie. AUDYTOR nie sprawdza warunku średnio najwyżej 10 etatów rocznych (≤ 10 årsverk). Dla spółki matki warunki dotyczą całego koncernu. Zwolnienie nie jest możliwe, gdy inna ustawa wymaga rewizji. Wymagana jest decyzja generalforsamling i rejestracja w Foretaksregisteret. To sygnał do rozmowy z klientem, nie zalecenie rezygnacji z rewizji. Ta informacja pojawia się raz w roku (audyt za okres do września).`,
        action_revisjon_fravalg_mulig: 'Omów z klientem; ustal ostatnie sprawozdanie roczne, årsverk, koncern i pozostałe wymogi rewizji przed ewentualną decyzją i rejestracją.',
        rule_revisjon_desc: (year, income, assets, auditYear) => `Sprawozdanie za ${year} wykazuje przychody operacyjne ${income} i sumę bilansową ${assets} (progi zwolnienia: przychody poniżej 7 000 000 kr i bilans poniżej 27 000 000 kr). Sprawozdanie za ${auditYear} podlega więc rewizji zgodnie z aksjeloven § 7-6 ust. 3. W Brreg brak zarejestrowanego rewizora. Zarząd bez zwłoki zwołuje generalforsamling w celu wyboru rewizora i zgłasza wybór do Foretaksregisteret (§ 7-6 ust. 7). AUDYTOR nie sprawdza warunku średnio najwyżej 10 etatów rocznych (årsverk).`,
        // Nowe regu\u0142y v17
        rule_skattetrekk_bank: 'Zaliczka na podatek: konto bankowe (1950) \u2260 zobowi\u0105zanie (2600)',
        rule_skattetrekk_bank_desc: (bank, gjeld, diff) => `Konto bankowe zaliczki podatkowej (1950): ${bank}\nZobowi\u0105zanie z tytu\u0142u zaliczki (2600): ${gjeld}\nR\u00f3\u017cnica: ${diff}\n\nFirma nie odk\u0142ada wystarczaj\u0105cych \u015brodk\u00f3w na zaliczk\u0119 podatkow\u0105. Konto 1950 powinno pokrywa\u0107 zobowi\u0105zanie na 2600.`,
        rule_likviditet: 'Wska\u017anik p\u0142ynno\u015bci poni\u017cej 1,0',
        rule_likviditet_desc: (ratio, om, kg) => `Wsp\u00f3\u0142czynnik p\u0142ynno\u015bci: ${ratio}\nAktywa obrotowe: ${om}\nZobowi\u0105zania kr\u00f3tkoterminowe: ${kg}\n\nFirma mo\u017ce mie\u0107 problemy z regulowaniem bie\u017c\u0105cych zobowi\u0105za\u0144. Zalecane: > 1,5.`,
        rule_levgjeld: 'Wysokie zobowi\u0105zania wobec dostawc\u00f3w vs zakupy',
        rule_levgjeld_desc: (lev, varekjop, pct) => `Zobowi\u0105zania wobec dostawc\u00f3w (2400): ${lev}\nZakup towar\u00f3w (4xxx): ${varekjop}\nStosunek: ${pct}%\n\nZobowi\u0105zania wobec dostawc\u00f3w stanowi\u0105 ponad 40% rocznych zakup\u00f3w. Sprawd\u017a czy s\u0105 przeterminowane faktury.`,
        rule_husleie: 'Czynsz: nieregularne obci\u0105\u017cenia miesi\u0119czne',
        rule_husleie_desc: (accId, accName, months) => `Konto ${accId} (${accName}):\n${months}\n\nCzynsz powinien by\u0107 r\u00f3wny co miesi\u0105c. Du\u017ce odchylenia mog\u0105 oznacza\u0107 b\u0142\u0119dne ksi\u0119gowanie lub brak periodyzacji.`,
        rule_prior_year_not_closed: 'Rok poprzedni nie jest domknięty do zera',
        rule_prior_year_not_closed_desc: (remainder, disposition) => `Reszta po dyspozycji: ${remainder}\nZaksięgowana dyspozycja (88xx-89xx): ${disposition}\n\nWynik roku poprzedniego został zadysponowany, ale konta wynikowe 3000-8999 nie sumują się do zera. Reszta została w wyniku.`,
        prior_year_remainder_row: 'Reszta wyniku roku poprzedniego po dyspozycji',
        rule_neg_bank: 'Ujemne saldo bankowe (1920-1999)',
        rule_neg_bank_desc: (amount) => `Saldo bankowe: ${amount}\n\nUjemne saldo = kredyt w rachunku bie\u017c\u0105cym. Zweryfikuj:\n\u2022 Czy firma ma umow\u0119 kredytu w rachunku bie\u017c\u0105cym?\n\u2022 Czy odsetki s\u0105 poprawnie ksi\u0119gowane (konto 8150)?`,
        rule_aksjonaerlan: 'Saldo należności 1370: ustal kontrahenta',
        rule_aksjonaerlan_desc: (amount) => `Saldo debetowe 1370: ${amount}. Przekracza techniczny próg kontroli 50 000 NOK, który nie jest progiem podatkowym. Samo konto nie identyfikuje pożyczkobiorcy. Sprawdź kontrahenta, dokumenty i umowę. Jeżeli to pożyczka dla akcjonariusza będącego osobą fizyczną, oceń zasady podatkowe i wyjątki według dat i kwot.`,
        rule_utbytte_2800: 'Saldo kont 2800/2801',
        rule_utbytte_2800_desc: (amount) => `Zarezerwowana dywidenda: ${amount}\n\nDywidenda uchwalona ale nie wyp\u0142acona. Sprawd\u017a:\n\u2022 Kiedy uchwalono dywidend\u0119?\n\u2022 Czy mie\u015bci si\u0119 w wolnym kapitale?\n\u2022 Czy uwzgl\u0119dniono zaliczk\u0119 na podatek?`,
        rule_no_accountant: 'Brak ksi\u0119gowego (6705)',
        rule_no_accountant_desc: 'Brak ksi\u0119gowa\u0144 na koncie 6705 (Honorar regnskap). Kto prowadzi ksi\u0119gowo\u015b\u0107? Je\u015bli firma prowadzi sama, zweryfikuj kompetencje i procedury.',
        rule_lonn_aga: 'Wynagrodzenia vs AGA: podejrzane odchylenie',
        rule_lonn_aga_desc: (lonn, aga, pct) => `Wynagrodzenia (5000+5020): ${lonn}\nAGA (5400): ${aga}\nUdzia\u0142 AGA: ${pct}%\n\nOczekiwane AGA: 0\u201314,1% w zale\u017cno\u015bci od strefy. Odchylenie poza normalnym zakresem.`,
        // Settings
        settingsTitle: 'Regu\u0142y Audytu',
        settingsDesc: 'W\u0142\u0105czaj/wy\u0142\u0105czaj regu\u0142y audytu. Ustawienia zapisuj\u0105 si\u0119 automatycznie.',
        settingsAllSystems: 'Wszystkie systemy',
        settingsRulesActive: (on, total) => `${on} z ${total} regu\u0142 aktywnych`,
        settingsEnableAll: 'W\u0142\u0105cz wszystkie',
        settingsDisableAll: 'Wy\u0142\u0105cz wszystkie',
        settingsBack: 'Powr\u00f3t',
        settingsCategory_financial: 'Wynik Finansowy',
        settingsCategory_balance: 'Bilans (Saldo)',
        settingsCategory_result: 'Rachunek wynik\u00f3w',
        settingsCategory_compliance: 'Wynagrodzenia & zgodno\u015b\u0107',
        settingsCategory_analysis: 'Analiza & periodyzacja',
        rulesDisabledBanner: (count) => `${count} regu\u0142 wy\u0142\u0105czonych`,
        // Scoring
        rule_scoring_title: (score) => `Ocena ko\u0144cowa: ${score}/10`,
        rule_scoring_desc: (errors, warnings, infos) => `Alerty wysokiego priorytetu: ${errors} • Ostrzeżenia: ${warnings} • Informacje: ${infos}\n\nWynik przesiewowych kontroli dostępnych danych. Alerty wymagają wyjaśnienia; wynik nie potwierdza błędu ani poprawności ksiąg.`,
        // localStorage
        loadLastAudit: 'Wczytaj ostatni audyt',
        lastAuditInfo: (sysName, date) => `${sysName} \u2014 ${date}`,
        toast_last_loaded: 'Wczytano ostatni audyt.',
        // === PIRAMIDA WARTOŚCI: Verdict & Tier & Category UI ===
        verdict_excellent: 'Wysoka ocena w wykonanych kontrolach. Sprawdź ewentualne uwagi poniżej.',
        verdict_good: 'Wysoka ocena; sprawdź otwarte uwagi. Ocena nie potwierdza poprawności księgowości.',
        verdict_acceptable: 'Kilka uwag wymaga wyjaśnienia przed ewentualną korektą.',
        verdict_needs_fix: (n) => `${n} uwag o wysokim priorytecie wymaga wyjaśnienia. Potwierdź przyczynę przed korektą.`,
        verdict_critical: 'Niska ocena: pilnie wyjaśnij uwagi i popraw potwierdzone błędy.',
        tier_critical: 'Wysoki priorytet: wyjaśnij',
        tier_check: 'Do sprawdzenia',
        tier_info: 'Do wiadomości',
        tier_passed: 'Brak odchyleń',
        summary_title: 'Podsumowanie dla księgowego',
        summary_fix: 'Wysoki priorytet:',
        summary_check: 'Do sprawdzenia:',
        summary_ok: "Brak otwartych błędów i ostrzeżeń w sprawdzonym zakresie. Sprawdź także sygnały oraz niewykonane kontrole poniżej.",
        summary_copy: 'Kopiuj podsumowanie',
        summary_copied: 'Skopiowano!',
        action_label: 'Co należy zrobić:',
        // Kontrakt karty (11.10.2026): dlaczego, sprawdziłem za Ciebie, pewność.
        card_why_label: 'Dlaczego to może być problem',
        card_verified_label: 'Sprawdziłem za Ciebie',
        confidence_confirmed: 'Potwierdzone odchylenie',
        confidence_open: 'Do wyjaśnienia',
        confidence_info: 'Informacja',
        period_end_generic: 'koniec okresu',
        rule_neg_assets_desc_at: (date) => `Ujemne salda na wskazanych kontach 1xxx na ${date} wymagają wyjaśnienia. Kolumna Zmiana dotyczy okresu; sam znak salda nie potwierdza błędu.`,
        neg_assets_why: "Sam znak salda nie wyjaśnia jego przyczyny ani nie potwierdza błędu. Sprawdź przeznaczenie konta, zapisy i dokumenty przed ewentualną korektą.",
        neg_assets_mirror: (a, b, amt) => `${a} i ${b} mają tę samą kwotę o przeciwnym znaku (${amt}). Ta zgodność wskazuje konta do porównania; nie potwierdza powiązania zapisów ani błędu. Sprawdź dokumenty przed ewentualnym przeksięgowaniem.`,
        neg_assets_no_mirror: 'Żadne konto w tej samej grupie nie ma przeciwnej kwoty; konta lustrzanego nie znaleziono automatycznie.',
        wrong_sign_transfer_note: (account, refs, amount) => `Konto ${account}: w dostępnych zapisach bilagów ${refs} znaleziono ${amount} NOK przeniesień na inne konta kosztowe. To wyjaśnia część ujemnych zapisów; nie potwierdza poprawności ich klasyfikacji.`,
        wrong_sign_why: 'Przeciwny znak może wynikać z korekty, przeksięgowania, odwrócenia naliczenia lub błędu. Przyczynę trzeba ustalić z powiązanych zapisów i dokumentów.',
        wrong_sign_provision_first_month: (acc, month) => `${acc} ujemne tylko w ${month}: rozwiązanie rezerwy z 31.12 poprzedniego roku, nie flagowane.`,
        rule_neg_bank_desc_at: (amount, date) => `Saldo bankowe na ${date}: ${amount}\n\nUjemne saldo = kredyt w rachunku bieżącym. Zweryfikuj:\n• Czy firma ma umowę kredytu w rachunku bieżącym?\n• Czy odsetki są poprawnie księgowane (konto 8150)?`,
        neg_bank_why: 'To saldo księgowe na koniec okresu, nie saldo banku; minus, który znika pierwszego dnia następnego miesiąca, to timing, minus trwały to kredyt w rachunku albo brak księgowań.',
        bank_last_entry: (acc, date, end) => `Ostatnia pozycja na ${acc}: ${date}; okres kończy się ${end}. Uzgodnienia z wyciągiem tu nie ma.`,
        bank_last_entry_nodate: (acc, date) => `Ostatnia pozycja na ${acc}: ${date}. Uzgodnienia z wyciągiem tu nie ma.`,
        bank_last_entry_none: (acc) => `Brak pozycji na ${acc} w pobranych transakcjach.`,
        bank_last_entry_unknown: 'Data ostatniej pozycji na koncie bankowym niedostępna bez transakcji.',
        duplicates_why: 'Kontrola wymaga zgodności faktury, kontrahenta i pełnego zbilansowanego księgowania. Sam wspólny opis lub kwota opłaty nie trafiają do ustaleń.',
        duplicates_netted: (v, i) => `Usunięte przed parowaniem: ${v} bilagów, które same się zerują, i ${i} faktur, gdzie storno i ponowne księgowanie zostawiają jedną kopię.`,
        duplicates_nothing_netted: 'Wśród kandydatów nie było storn ani bilagów zerujących się samych.',
        invoice_gap_why: 'Luka w numeracji faktur to zwykle faktury zaksięgowane w następnym okresie, noty kredytowe albo skasowane szkice; brakiem jest tylko numer, którego nie ma nigdzie.',
        invoice_gap_checked: 'Numery istniejące w innych latach i na należnościach (1500) są odliczone. Następny miesiąc nie był pobrany, więc numery zaksięgowane po końcu okresu nadal wyglądają jak luka.',
        project_pnl_no_conflicts: 'brak',
        project_pnl_allocation_note: (sales,costs,conflicts) => `Niepełne przypisanie do projektów: przychody bez projektu ${sales} NOK, koszty bez projektu ${costs} NOK. Różne nazwy pod tym samym ID: ${conflicts}. Tabela pokazuje tylko przypisane zapisy; nie potwierdza straty ani rentowności projektu. Wynik informacyjny, bez obniżenia oceny.`,
        project_pnl_why: 'Projekt z kosztami bez sprzedaży w okresie jest zafakturowany w innym okresie, źle zaalokowany albo naprawdę nierentowny; daty pokazują, jak długo projekt ma księgowania.',
        project_pnl_span: (from, to) => `pozycje ${from}–${to}`,
        project_pnl_span_note: 'Daty przy projekcie to pierwsza i ostatnia pozycja w badanym okresie, nie początek i koniec projektu.',
        project_pnl_prior_checked: (year) => `Projekty istniejące w ${year} zostały wydzielone; nie ma ich na liście, chyba że obrót przekracza próg.`,
        amort_why: 'Sprawdź nabycia, zbycia, okres używania i plan amortyzacji w ewidencji. Pełne umorzenie nie oznacza konieczności likwidacji.',
        amort_depr_in_period: (sum) => `Odpisy amortyzacyjne (60xx) zaksięgowane w okresie: ${sum}.`,
        amort_no_depr: 'Brak odpisów amortyzacyjnych (60xx) w okresie.',
        otp_why: 'Koszt emerytalny i wynagrodzenia mogą mieć różne podstawy i okresy ujęcia. Relacja jest tylko sygnałem do kontroli.',
        otp_ratio_ok: (ratio) => `Relacja kwot w księdze: ${ratio}%. Powyżej punktu odniesienia 2%, ale podstawa pracownicza i wykonanie obowiązku OTP nie są potwierdzone.`,
        otp_ratio_low: (ratio) => `Relacja kwot w księdze: ${ratio}%, poniżej punktu odniesienia 2%. To nie wylicza zaległości.`,
        utbytte_why: 'Saldo debetowe i kredytowe mogą mieć różne przyczyny. Uzgodnij uchwały, wypłaty i przeksięgowania z dokumentami.',
        dividend_net_desc_at: (amount, date) => `Saldo netto kont 2800/2801 na ${date}: ${amount} kr. Uzgodnij uchwały, wypłaty i przeksięgowania. Samo saldo nie dowodzi uchwalonej ani niewypłaconej dywidendy.`,
        utbytte_unpaid: (date) => `Brak zmiany netto na 2800/2801 w badanym okresie do ${date}. To nie wyklucza wypłaty i nowego naliczenia tej samej kwoty.`,
        utbytte_unpaid_period: 'Brak zmiany netto na 2800/2801 w badanym okresie. Ewentualne wypłaty trzeba ustalić z dokumentów.',
        utbytte_moved: (amt) => `Ruch na 2800/2801 w okresie, netto ${amt}; co wypłacono, a co przeksięgowano, trzeba odczytać z bilagów.`,
        salary_why: 'Zmiany mogą wynikać z feriepenger, premii, zatrudnienia, wyrównań lub periodyzacji. Przyczynę trzeba ustalić z dokumentów.',
        rule_salary_periodisering_desc_months: (list) => `Suma kosztów osobowych (5xxx) zmienia się o ponad 50 % między miesiącami: ${list}.`,
        reverse_period_why: 'Periodyzacja może obejmować wiele miesięcy i dokumentów. Ustalenie przyczyny wymaga powiązania salda z dokumentami.',
        rule_reverse_period_desc_plain: (movement, balance, date) => `Ruch netto na 3009 w okresie: ${movement}. Saldo 1530 na ${date}: ${balance}. Sam znak i saldo nie dowodzą odwrócenia konkretnej periodyzacji. Sprawdź dokumenty i fakturowanie.`,
        reverse_period_pair: (acc,a,b) => `1530 (${a}) i ${acc} (${b}) mają przeciwne salda. Zgodność kwot nie dowodzi powiązania dokumentów ani błędnego księgowania.`,
        reverse_period_no_pair: 'Brak konta lustrzanego o przeciwnej kwocie w 153x.',
        score_breakdown: 'Obliczenie punktów (% zdanych)',
        category_breakdown: 'Szczegóły per kategoria',
        category_label_compliance: 'Wynagrodzenia & zgodno\u015b\u0107',
        category_label_balance: 'Bilans',
        category_label_financial: 'Wynik finansowy',
        category_label_result: 'Rachunek wynik\u00f3w',
        category_label_analysis: 'Analiza & periodyzacja',
        col_category: 'Kategoria',
        col_weight: 'Waga',
        col_errors: 'Błędy',
        col_warnings: 'Ostrzeżenia',
        col_deduction: 'Wynik',
        col_passed: 'Zaliczone',
        passed_rules_label: 'zaliczonych',
        show_details: 'Pokaż szczegóły',
        hide_details: 'Ukryj szczegóły',
        // === Actions per rule ===
        action_neg_assets: "Uzgodnij wskazane konta 1xxx z dokumentami i przeznaczeniem konta. Wyjaśnij ujemne saldo; koryguj dopiero po potwierdzeniu błędu.",
        action_acc_1580: 'Oceń czy należność powinna być odpisana jako strata, lub czy należy podjąć kroki windykacyjne.',
        action_pos_liabilities: 'Sprawd\u017a, czy konto zobowi\u0105za\u0144 faktycznie mo\u017ce mie\u0107 saldo debetowe, czy wynika to z b\u0142\u0119dnej periodyzacji/klasyfikacji.',
        action_high_1571: 'Uzgodnij konto 1571 z faktycznymi należnościami. Oceń czy saldo wymaga przeksięgowania.',
        action_high_1370: 'Sprawdź czy należność od właściciela powinna być zaraportowana jako wynagrodzenie/dywidenda.',
        action_mileage_7100: 'Sprawdź książkę jazd (data, trasa, cel, km). Zweryfikuj stawkę i A-melding.',
        action_rent_6301: 'Sprawdź czy czynsz (6300) jest zaksięgowany. Odliczenie bez czynszu to błąd.',
        action_conflict_7791_7799: 'Wybierz jedno z kont 7791 lub 7799 i przeksięguj drugie.',
        action_conflict_4000_4300: 'Rozdziel konto towarów (4000) od produkcji (4300) — wybierz właściwą klasyfikację.',
        action_amortization_12xx: 'Zweryfikuj środki trwałe i poprawność odpisów amortyzacyjnych (60xx).',
        action_balance_control: 'Znajdź różnicę między aktywami a pasywami. Sprawdź wszystkie księgowania.',
        action_neg_equity_2050: 'Obowiązek działania wg aksjeloven § 3-4. Zarząd musi podjąć działania.',
        action_negative_cash_1900: 'Sprawdź konto kasy pod kątem brakujących dokumentów lub błędów.',
        action_mva_reconciliation: 'Uzgodnij konta MVA z wysłanymi deklaracjami MVA.',
        action_mva_period_check: 'Porównaj salda z tabeli z księgowaniem rozliczenia VAT. Status wysyłki jest pokazany osobno na podstawie Oppgaver.',
        action_private_car_7000: 'Zaksięguj korektę za prywatne użytkowanie samochodu (7099).',
        action_wrong_sign_costs: 'Ustal, czy to nota kredytowa, odwrócenie czy błąd. Koryguj dopiero po potwierdzeniu błędu.',
        action_anomalies_6xxx: "Porównaj wskazane miesiące z dokumentami, okresem raportu i działalnością firmy. Wyjaśnij, czy zmienność wynika z fakturowania, periodyzacji lub zmiany działalności.",
        action_high_6540: 'Sprawdź bilag/postering powyżej 30 000 NOK i oceń, czy nie powinien być aktywowany jako środek trwały.',
        action_salary_sign: 'Uzgodnij oznaczone miesiące z listami płac, periodyzacją i korektami kosztów emerytalnych. Sam znak nie uzasadnia korekty księgowania.',
        action_missing_5920: 'Zaksięguj ubezpieczenie wypadkowe (5920), jeśli istnieje. Jeśli klient nie ma ubezpieczenia albo trzeba to wyjaśnić, użyj Do klienta z krótką notatką.',
        action_skattetrekk: 'Sprawdź konto 2600 — upewnij się że potrącenia podatkowe są naliczane.',
        action_aga_5400: 'Zaksi\u0119guj sk\u0142adk\u0119 pracodawcy (5400) \u2014 obowi\u0105zkowe przy wyp\u0142acie wynagrodze\u0144.',
        action_feriepenger: 'Zaksi\u0119guj wynagrodzenie urlopowe (5210/5211) \u2014 10,2% wynagrodzenia (12% dla 60+).',
        action_otp_5930: 'Ustal pracowników objętych obowiązkiem OTP i porównaj z umową. Sprawdź podstawę, okresy, faktury i premiefond.',
        action_periodisering: 'Sprawdź czy duże kwoty powinny być rozłożone na kilka miesięcy.',
        action_kundefordringer_vs_omsetning: 'Sprawdź status windykacji i oceń rezerwę na straty.',
        action_revisjonsplikt: 'Ustal z klientem wybór rewizora i zgłoszenie do Foretaksregisteret.',
        action_skattetrekk_bank: 'Uzgodnij konto bankowe zaliczki podatkowej (1950) z zobowi\u0105zaniem (2600).',
        action_likviditetsgrad: 'Oceń płynność — zobowiązania krótkoterminowe przekraczają aktywa obrotowe.',
        action_leverandorgjeld_ratio: 'Sprawdź czy są przeterminowane faktury. Oceń plan płatności.',
        action_husleie_consistency: 'Sprawdź nieregularności w czynszu — powinien być równy co miesiąc.',
        action_negativ_bank: "Uzgodnij ujemne saldo księgowe z wyciągiem i dokumentami bankowymi. Wyjaśnij przyczynę oraz ewentualne przeksięgowania; samo saldo nie potwierdza istnienia umowy kredytowej.",
        action_prior_year_not_closed: 'Sprawd\u017a bilagi rozliczenia rocznego za rok poprzedni: kwoty, strony, podw\u00f3jne ksi\u0119gowanie i koszty dopisane po dyspozycji.',
        action_aksjonaerlan_skatt: 'Ustal kontrahenta i podstawę należności przed oceną pożyczki dla akcjonariusza.',
        action_utbytte_2800: 'Uzgodnij uchwały i płatności. Obowiązek podatkowy oceń według odbiorcy i transakcji, nie samego salda.',
        action_no_accountant: 'Zweryfikuj kto prowadzi księgowość i procedury kontroli jakości.',
        action_lonn_vs_aga: 'Sprawdź obliczenie AGA — odchylenie poza normalnym zakresem (0–14,1%).',

        // v18 — leasing, banklån, nowe reguły
        rule_leasing_6440: 'Leasing: brak miesięcznego kosztu',
        rule_leasing_6440_desc: 'Konto leasingowe jest używane, ale brak kosztu w niektórych miesiącach od pierwszego zaksięgowania.',
        action_leasing_6440: 'Sprawdź umowę leasingową — leasing powinien być księgowany co miesiąc od rozpoczęcia.',
        rule_banklan_8150: 'Ruch na 8150 bez rozpoznanego salda kredytu na koniec okresu',
        rule_banklan_8150_fallback: 'Odsetki od kredytu bankowego',
        rule_banklan_8150_desc: (name) => `8150 (${name}) ma zapisy w okresie. Na koniec okresu nie rozpoznano salda kredytu na sprawdzanych kontach bilansowych. Kredyt mógł zostać spłacony lub ujęty na innym koncie. Sprawdź dokumenty i plan kont.`,
        action_banklan_8150: 'Zweryfikuj czy 8150 jest właściwym kontem odsetek dla klienta. Popraw tylko wtedy, gdy odsetki faktycznie dotyczą dostawców albo błędnej klasyfikacji.',
        rule_salary_periodisering: 'Koszty osobowe: duża zmiana między miesiącami',
        rule_salary_periodisering_desc: 'Suma kosztów osobowych (5xxx) zmienia się o ponad 50% miesiąc do miesiąca. Sprawdź periodyzację.',
        action_salary_periodisering: 'Zweryfikuj koszty wynagrodzeń w oznaczonych miesiącach — możliwy błąd periodyzacji lub wyrównanie.',

        // v23 — martwe miesiące, skoki kosztów, IB mismatch
        rule_dead_months: 'Martwe miesiące — brak księgowań',
        rule_dead_months_desc: (months, count) => `${count} miesi\u0105c(e) bez ksi\u0119gowa\u0144 w \u015brodku aktywnego okresu: ${months}.\nMo\u017ce to oznacza\u0107 brakuj\u0105ce dokumenty ksi\u0119gowe lub op\u00f3\u017anione ksi\u0119gowanie.`,
        action_dead_months: 'Sprawd\u017a czy brakuje dokument\u00f3w ksi\u0119gowych w zaznaczonych miesi\u0105cach. Zweryfikuj z klientem.',
        rule_cost_spike_ext: 'Skok kosztów na koncie operacyjnym (4xxx–7xxx)',
        rule_cost_spike_ext_desc: (count) => `${count} konto/kont z wartościami powyżej progu porównania (>3,5× średnia). Odchylenie wymaga wyjaśnienia i nie potwierdza błędu księgowania.`,
        action_cost_spike_extended: "Porównaj wskazane kwoty z dokumentami, okresem raportu i kosztami jednorazowymi. Koryguj dopiero po potwierdzeniu błędu.",
        rule_ib_mismatch: 'Rozbieżność IB między latami',
        rule_ib_mismatch_desc: (count) => `${count} konto/kont gdzie bilans otwarcia (IB) w tym roku nie zgadza się z bilansem zamknięcia (UB) poprzedniego roku.\nOznacza to błąd w zamknięciu roku lub korekty w złym okresie.`,
        action_yoy_ib_ub_continuity: 'Sprawdź zamknięcie roku — UB poprzedniego roku musi zgadzać się z IB bieżącego roku dla wszystkich kont bilansowych.',

        // v24 — reguły oparte na transakcjach (Faza 6)
        rule_duplicate_sales: 'Czy tę samą sprzedaż zafakturowano dwa razy?',
        rule_duplicate_sales_ok: 'Nie znaleziono grup spełniających kryteria możliwych podwójnych faktur sprzedaży. Faktur bez odcisku pozycji nie porównano.',
        duplicate_sales_desc: (count) => `Liczba grup z tym samym klientem, dniem, kwotą, pozycjami i saldami kont, ale różnymi numerami faktur: ${count}. Czy dotyczą tej samej pracy? Mogą to być dwie różne prace. Sprawdź dokumenty.`,
        duplicate_sales_why: 'Zgodność pozycji i księgowań może wskazywać na podwójne fakturowanie, ale może też dotyczyć dwóch różnych prac. Księgowy musi sprawdzić, co faktycznie wykonano.',
        duplicate_sales_verified: 'Porównano klienta, dzień, kwotę, odcisk pozycji i salda netto kont w zbilansowanych zapisach bez salda netto na kontach bankowych. Uwzględniono liczbę kredytów tego klienta na tę samą kwotę.',
        invoice_lines_missing: 'Nie sprawdzono: źródło nie zawiera odcisków pozycji potrzebnych do porównania faktur sprzedaży.',
        action_duplicate_sales_invoices: 'Czy faktury dotyczą tej samej pracy, czy dwóch różnych prac? Sprawdź faktury i wykonane usługi. Jeśli tę samą pracę zafakturowano dwa razy, wystaw kreditnotę i w razie potrzeby skoryguj MVA.',
        rule_duplicates: 'Możliwe duplikaty w księgowaniu',
        rule_duplicates_ok: 'Nie wykryto powtórzeń spełniających ścisłe kryteria kontroli. Nie potwierdzono unikalności dokumentów bez wystarczającej identyfikacji.',
        rule_duplicates_desc: (count) => `${count} potencjalnych duplikat\u00f3w znalezionych (to samo konto, data i kwota w r\u00f3\u017cnych dokumentach).`,
        action_duplicate_entries: 'Sprawd\u017a oznaczone dokumenty \u2014 kwota, konto i data s\u0105 identyczne. Zweryfikuj czy to nie podw\u00f3jne ksi\u0119gowanie.',
        rule_round_amounts: 'Dużo okrągłych kwot na kontach kosztowych',
        rule_round_amounts_ok: '✓ Udział okrągłych kwot w normie — brak oznak szacunków.',
        rule_round_amounts_desc: (pct, round, total) => `${pct}% transakcji kosztowych to okrągłe kwoty (podzielne przez 1000): ${round} z ${total} transakcji.\nMoże to oznaczać szacunki zamiast prawdziwych faktur.`,
        action_round_amounts: 'Zweryfikuj czy koszty bazują na fakturach, a nie szacunkach. Szczególnie duże okrągłe kwoty powinny być udokumentowane.',
        rule_mva_voucher: 'Dokumenty bez ksi\u0119gowania MVA',
        rule_mva_voucher_ok: '\u2713 Wszystkie dokumenty kosztowe powy\u017cej 1 000 kr maj\u0105 ksi\u0119gowanie MVA (konto 27xx).',
        rule_mva_voucher_desc: (count, extra) => `${count} dokumentów kosztowych w zakresie kontroli bez niezerowego MVA (27xx).${extra || ""} Sprawdź faktury i prawo do odliczenia. Powtarzalność nie dowodzi zwolnienia ani błędu.`,
        action_mva_per_voucher: 'Zweryfikuj oznaczone dokumenty \u2014 brak MVA mo\u017ce wynika\u0107 z faktury zagranicznej, reverse charge lub zakupu zwolnionego z MVA.',
        rule_mva_sales: 'Fakturowanie bez MVA nale\u017cnego',
        rule_mva_sales_ok: '\u2713 Wszystkie dokumenty sprzeda\u017cowe powy\u017cej 500 kr maj\u0105 MVA nale\u017cny (konto 2700-2709).',
        rule_mva_sales_desc: (count, extra) => `${count} dokumentów na koncie 3000 bez niezerowego MVA należnego (2700-2709).${extra || ""} Sprawdź dokument, miejsce dostawy i podstawę stawki lub zwolnienia. Liczba takich zapisów nie dowodzi błędu.`,
        action_mva_sales_voucher: "Sprawdź wskazane dokumenty i podstawę rozliczenia MVA. Nie zmieniaj stawki na podstawie samego numeru konta.",
        rule_mva_not_registered_vat_postings: 'MVA zaksi\u0119gowane bez rejestracji MVA',
        rule_mva_not_registered_vat_postings_desc: (count, company) => `Brreg pokazuje, \u017ce ${company || 'firma'} nie jest zarejestrowana w MVA-registeret, ale znaleziono ${count} kont/kod\u00f3w MVA w ksi\u0119gowaniu.`,
        action_mva_not_registered_vat_postings: 'Sprawd\u017a status w Brreg i popraw kody/posteringi MVA. Je\u015bli firma powinna by\u0107 MVA-pliktig, trzeba wyja\u015bni\u0107 rejestracj\u0119.',
        rule_invoice_numbering: 'Luki w numeracji faktur',
        rule_invoice_numbering_ok: (count, first, last) => `${count} widocznych numerów faktur (${first} do ${last}): brak luk przekraczających próg reguły. Nie sprawdzono pełnego rejestru faktur ani innych serii.`,
        rule_invoice_numbering_desc: (gaps, missing) => `${gaps} luk w numeracji: ${missing} numerów nie ma na transakcjach sprzedażowych ani należnościowych w wybranym okresie. Sekwencję wyznaczają konta sprzedaży (3xxx); numer na należnościach (1500) liczy się jako obecny, ale sam nie dowodzi wystawienia faktury. Faktury mogą być zaksięgowane w innym okresie. To nie potwierdza braku dokumentów.`,
        action_invoice_numbering: 'Wyszukaj numery na liście faktur, również poza wybranym okresem, zanim uznasz dokumenty za brakujące.',
        fromInvoice: 'Od faktury',
        toInvoice: 'Do faktury',
        missingCount: 'Brakuje',
        missingInvoices: 'Brakuj\u0105ce numery',
        rule_varelager: 'Brak zapas\u00f3w (1400-1499)',
        rule_varelager_desc: (total) => `Firma ma koszt zakupu towar\u00f3w na ${total}, ale brak zapas\u00f3w w bilansie. Rozwa\u017c czy nie powinno by\u0107 przeprowadzone liczenie zapas\u00f3w na koniec roku.`,
        action_varelager_check: 'Rozwa\u017c przeprowadzenie inwentaryzacji i aktywowanie zapas\u00f3w na koniec roku.',
        rule_bank_eom: 'Saldo bankowe per miesi\u0105c',
        rule_bank_eom_desc: (months) => `Konto bankowe (1920) wykazuje ujemne saldo lub dramatyczny spadek w ${months}.`,
        rule_bank_eom_action: 'Porównaj wskazane miesiące z wyciągiem i płatnościami. Sam spadek nie oznacza ujemnego salda ani obecnego problemu płynności.',
        rule_bank_eom_ok: 'Saldo bankowe stabilne w ca\u0142ym okresie.',
        action_bank_saldo_eom: "Porównaj wskazane salda końca miesiąca i zmiany z wyciągiem oraz płatnościami. Wyjaśnij udokumentowane okoliczności; historyczne salda same nie określają obecnej płynności ani korzystania z kredytu bankowego.",
        rule_reverse_period: 'Periodyzacja: ruch 3009 i saldo 1530',
        rule_reverse_period_desc: 'Konto 3009 i 1530 wskazują na odwrócenie/periodyzację przychodów. To może być całkowicie normalne przy rozliczeniu między miesiącami albo kwartałami, więc punkt jest tylko informacją.',
        rule_reverse_period_action: 'Sprawdź, czy periodyzacja jest oczekiwana. Jeśli to normalne odwrócenie, dodaj ewentualnie krótki komentarz.',
        action_reverse_periodisering: 'Sprawdź, czy periodyzacja jest oczekiwana. Jeśli to normalne odwrócenie, dodaj ewentualnie krótki komentarz.',
        rule_tx_skipped: 'Reguły transakcyjne pominięte',
        rule_tx_verified_empty: 'Potwierdzone zero transakcji',
        rule_tx_verified_empty_desc: 'Źródło potwierdziło zero transakcji w okresie. Kontrole transakcyjne nie zostały wykonane i nadal pozostają oznaczone jako niesprawdzone.',
        rule_tx_skipped_desc: 'Regu\u0142y wykrywania duplikat\u00f3w i MVA per dokument wymagaj\u0105 danych transakcji z API. Uruchom audyt w trybie batch przez API.',
        rule_recurring: 'Wykryte powtarzalne koszty',
        rule_recurring_desc: (count) => `${count} powtarzalnych pozycji kosztowych (ta sama kwota ±10%, minimum 3 wystąpienia).`,
        action_recurring_detection: 'Informacja: to zidentyfikowane koszty stałe. Przydatne do budżetowania i analizy cash flow.',
        rule_project_pnl: 'Wynik zapisów przypisanych do projektu',
        rule_project_pnl_ok: (count) => `${count} projektów ma nieujemną sumę przypisanych zapisów w tym okresie.`,
        rule_project_pnl_desc: (losing,total,loss) => `${losing} z ${total} projektów ma ujemny wynik księgowy w badanym okresie, łącznie ${loss}. To nie jest wynik całego projektu. Sprawdź okresy fakturowania i przypisanie kosztów.`,
        rule_project_pnl_partial_desc: (losing, total, totalLoss) => `${losing} z ${total} projektów ma ujemną sumę przypisanych zapisów: ${totalLoss}. Okres jest krótszy niż kwartał. To nie jest potwierdzenie straty projektu.`,
        action_project_pnl_summary: 'Sprawdź projekty z ujemnym netto: brak fakturacji, błędne alokacje kosztów, czy projekt jest faktycznie nierentowny?',
        project_pnl_costs: 'koszty',
        project_pnl_sales: 'sprzedaż',
        project_pnl_net: 'netto',
        // 11.10.2026 — karta pokazuje tylko projekty wymagające uwagi (decyzja ownera)
        project_pnl_scope_note: (shown, listed, omitted, priorYear, profitable, terskel) =>
            `Pokazano: ${shown} projekt(ów) na minusie nieobecnych w danych poprzedniego roku albo z obrotem powyżej ${terskel}${listed < shown ? ` (${listed} na liście)` : ''}.`
            + (omitted > 0 ? ` Pominięto: ${omitted} projekt(ów) z ${priorYear} poniżej progu — wynik może siedzieć w zeszłorocznej fakturacji.` : '')
            + ` ${profitable} projekt(ów) jest na plusie i nie ma ich na liście.`,
        project_pnl_scope_note_unknown: (shown, listed, profitable) =>
            `Pokazano: ${shown} projekt(ów) na minusie${listed < shown ? ` (${listed} na liście)` : ''}. ${profitable} projekt(ów) jest na plusie i nie ma ich na liście.`,
        project_pnl_prior_unknown: 'Lista projektów z poprzedniego roku była niedostępna, więc pokazano wszystkie projekty na minusie.',
        project_pnl_from_prior_year: (year) => `z ${year}`,
        mva_voucher_series: (count, from, to) => `${count} bilagów ${from} – ${to}`,
        mva_voucher_grouped: (series, rows) => `Powtarzające się bilagi z tego samego konta i kontrahenta zebrano razem (${series} serii, ${rows} linii).`,
        action_prosjektregnskap_terskel: 'Ustal wartość kontraktu, branżę i próg na właściwą datę; następnie sprawdź ewidencję projektu.',
        action_import_integrity: 'Porównaj wszystkie linie, debet, kredyt i daty z dokumentem źródłowym.',
        // v40 — ciągłość IB/UB, integralność importu, prosjektregnskap
        rule_ib_ub_continuity: 'Bilans otwarcia nie zgadza się z zamknięciem zeszłego roku',
        rule_ib_ub_continuity_desc: (count, total) => `${count} kont(o) bilansowych ma bilans otwarcia (IB) niezgodny z zamknięciem zeszłego roku (UB) — różnica łącznie ${total}. IB musi równać się UB z poprzedniego roku. Sprawdź bilans otwarcia, ręczne księgowania lub zapisy w zamkniętym roku.`,
        rule_import_integrity: 'Bilagi które się nie bilansują (debet ≠ kredyt)',
        rule_import_integrity_ok: (count) => `✓ ${count} bilag(ów) sprawdzonych — wszystkie się bilansują (debet = kredyt).`,
        rule_import_integrity_desc: (bad,total) => `${bad} z ${total} bilagów nie sumuje się do zera w pobranych liniach. Przyczyna nie została ustalona. Przed korektą porównaj pełny dokument i zakres dat ze źródłem.`,
        rule_prosjektregnskap: 'Prosjektregnskap — próg przekroczony (sprawdź ręcznie)',
        rule_prosjektregnskap_missing_desc: (count,limit) => `${count} klientów ma obrót księgowy netto ponad próg kontroli ${limit}, a mniej niż 20% linii kosztowych ma projekt. Domyślny próg to 650 800 NOK (5 × G od 01.05.2025), chyba że ustawiono inny. Ustal branżę, wartość kontraktu i właściwą datę G. To sygnał przesiewowy, nie potwierdzony brak ewidencji projektów.`,
        rule_prosjektregnskap_check_desc: (p,c,limit) => `Obrót księgowy netto ponad próg kontroli ${limit}: ${p} projektów i ${c} klientów. Domyślny próg to 5 × G od 01.05.2025 (650 800 NOK), chyba że ustawiono inny. To kontrola przesiewowa, nie ocena wartości kontraktu ani obowiązku. Ustal branżę, kontrakt i właściwą datę G.`,
        prosjektregnskap_project: 'Projekt',
        prosjektregnskap_customer: 'Klient',
        showing: 'wyświetlono',

        // --- 24SO API ---
        api_mode: '24SO API',
        api_mode_desc: 'Połącz z 24SO przez RAPPORTER API',
        api_url_label: 'URL API',
        api_key_label: 'Klucz API',
        api_connect: 'Połącz',
        api_select_client: 'Wybierz klienta',
        api_search_placeholder: 'Szukaj firmy...',
        api_year: 'Rok',
        api_month_from: 'Od miesiąca',
        api_month_to: 'Do miesiąca',
        api_run_audit: (name) => `Uruchom audyt — ${name}`,
        api_fetching_clients: 'Pobieram listę klientów...',
        api_fetching_data: 'Pobieram dane księgowe...',
        api_no_clients: 'Brak aktywnych klientów',
        api_connection_error: 'Nie można połączyć z API. Sprawdź URL i klucz.',
        api_data_error: 'Nie można pobrać danych księgowych. Spróbuj ponownie.',
        rapporter_err_empty_period: 'Brak księgowań na kontach wynikowych w okresie. Okres nie jest zaksięgowany albo zapisy znoszą się do zera.',
        rapporter_err_no_fiscal_year: 'Okres leży poza rokiem obrotowym klienta w Finago.',
        rapporter_err_busy: 'Finago jest zajęte innym raportem. Spróbuj za chwilę.',
        rapporter_err_timeout: 'Finago nie odpowiedziało na czas. Spróbuj za kilka minut.',
        api_or: 'lub',
        api_back: 'Wróć do wyboru',
        // === Batch & Dashboard (v17) ===
        period_label: 'Okres',
        period_per: 'Per',
        batch_mode: 'Audyt zbiorczy',
        batch_connect_first: 'Najpierw połącz z API, aby użyć audytu zbiorczego.',
        batch_select_title: 'Wybierz firmy do audytu zbiorczego',
        batch_select_all: 'Zaznacz wszystkie',
        batch_deselect_all: 'Odznacz wszystkie',
        batch_start: (n) => `Start audytu (${n} firm)`,
        batch_running: 'Trwa audyt zbiorczy...',
        batch_progress: (done, total, name) => `${done}/${total} — ${name}`,
        batch_rule_progress: (rDone, rTotal, ruleName) => `Sprawdzam regułę ${rDone}/${rTotal}: ${ruleName}`,
        batch_eta: (mins) => `ok. ${mins} min pozostało`,
        batch_done: (n) => `Gotowe! Zaudytowano ${n} firm.`,
        batch_abort: 'Przerwij',
        batch_aborted: 'Audyt zbiorczy przerwany.',
        batch_error_count: (n) => `${n} błędów`,
        batch_period_label: 'Okres audytu',
        dashboard_title: 'Panel audytu',
        dashboard_empty_title: 'Brak wyników audytu',
        dashboard_empty_desc: 'Wybierz klientów i uruchom audyt, aby zobaczyć wyniki.',
        dashboard_empty_go: 'Przejdź do listy klientów',
        dashboard_firms: 'Firmy',
        dashboard_avg_score: 'Średnia',
        dashboard_critical: (n) => `${n} krytycznych`,
        dashboard_top_error: 'Najczęstszy błąd',
        dashboard_filter_all: 'Wszystkie',
        dashboard_filter_critical: (n) => `Krytyczne (<${n})`,
        dashboard_filter_warning: (a, b) => `Do sprawdzenia (${a}–<${b})`,
        dashboard_filter_ok: (n) => `Ocena ≥ ${n}`,
        dashboard_filter_unreviewed: 'Niesprawdzone',
        dashboard_filter_assigned: 'Przypisane',
        dashboard_export_csv: 'Eksportuj CSV',
        dashboard_mark_reviewed: 'Sprawdzone',
        dashboard_assign: 'Przypisz',
        dashboard_full_report: 'Pełny raport',
        dashboard_ranking_title: 'TOP 10 najczęstszych problemów',
        dashboard_back: 'Wróć do panelu',
        dashboard_no_results: 'Żadna firma nie pasuje do filtra.',
        dashboard_score: 'Wynik',
        dashboard_errors: 'Błędy',
        dashboard_warnings: 'Ostrz.',
        dashboard_system: 'System',
        dashboard_status_bar: (done, total) => `${done} z ${total} zaudytowanych`,
        dashboard_filter_audited: 'Zaudytowane',
        dashboard_filter_not_audited: 'Bez audytu',
        dashboard_select_unaudited: (n) => `Zaznacz wszystkie bez audytu (${n})`,
        history_label: 'Historia audytów',
        history_load: 'Wczytaj',
        history_delete: 'Usuń',
        history_empty: 'Brak wcześniejszych audytów.',
        history_firms: (n) => `${n} firm`,
        history_date: 'Data',
        team_unassigned: 'Nieprzypisany',
        team_manage: 'Zarządzaj zespołem',
        team_add: 'Dodaj osobę',
        team_name_placeholder: 'Imię...',
        team_title: 'Zespół audytowy',
        // v18 — Kundeliste
        kundeliste_section: 'Lista klient\u00f3w (firma \u2192 ksi\u0119gowy)',
        kundeliste_import: 'Importuj CSV',
        kundeliste_import_desc: 'Eksportuj list\u0119 klient\u00f3w z Google Sheets jako CSV i wgraj tutaj.',
        kundeliste_count: (n) => `${n} firm wczytanych`,
        kundeliste_clear: 'Usu\u0144 list\u0119 klient\u00f3w',
        kundeliste_col_accountant: 'Księgowy',
        kundeliste_drop: 'Upuść plik CSV lub kliknij aby wybrać',
        cat_compliance: 'Zgodność',
        cat_balance: 'Bilans',
        cat_result: 'Wynik',
        cat_financial: 'Finanse',
        cat_analysis: 'Analiza',
        // v18 — Navigation
        nav_home: 'Klienci',
        nav_dashboard: 'Dashboard',
        nav_settings: 'Ustawienia',
        nav_users: 'Użytkownicy',
        nav_work_activity: 'Aktywność pracy',
        nav_activity: 'Aktywność',
        nav_report: 'Raport',
        nav_reports: 'Raporty',
        nav_notifications: 'Powiadomienia',
        nav_history: 'Historia',
        nav_permanent_acks: 'Permanent log',
        nav_my_firms: 'Moje firmy',
        // Model B — My firms dashboard
        myfirms_title: 'Moje firmy — przegląd',
        myfirms_period: 'Okres',
        myfirms_firms: 'klientów',
        myfirms_no_run: 'Brak audytów do pokazania',
        myfirms_kpi_all: 'Wszystkie',
        myfirms_kpi_attention: 'Wymaga akcji',
        myfirms_kpi_in_progress: 'W trakcie',
        myfirms_kpi_done: 'Gotowe',
        myfirms_kpi_clean: 'Bez błędów',
        myfirms_overall_progress: 'Postęp ogólny',
        myfirms_col_firm: 'Klient',
        myfirms_col_progress: 'Postęp',
        myfirms_col_status: 'Status',
        myfirms_col_notified: 'Wysłane',
        myfirms_col_opened: 'Otwarte',
        myfirms_status_waiting: 'Czeka',
        myfirms_status_in_progress: 'W trakcie',
        myfirms_status_done: 'Gotowe',
        myfirms_status_no_issues: 'Bez błędów',
        myfirms_status_not_notified: 'Niewysłane',
        myfirms_errors: 'błędów',
        myfirms_empty_filter: 'Brak klientów w tym filtrze',
        myfirms_show_all: 'Pokaż wszystkie',
        myfirms_admin_note: 'Jako admin widzisz wszystkich klientów z najnowszego runa.',
        myfirms_period_selector_label: 'Okres',
        myfirms_period_all: 'Wszystkie okresy',
        myfirms_no_periods: 'Brak okresów',
        myfirms_period_firms_count: 'klientów',
        myfirms_period_acked_pct: 'acked',
        refresh: 'Odśwież',
        // Phase 3 D++ — Permanent acks log admin screen
        permanent_acks_title: 'Permanent ignore — log audytowy',
        permanent_acks_subtitle: 'Wszystkie reguły permanentnie ignorowane (cross-period). Tylko admin.',
        permanent_acks_total: 'Razem permanent',
        permanent_acks_top_user: 'Top user',
        permanent_acks_top_rules: 'Najczęściej permanent',
        permanent_acks_search_placeholder: 'Szukaj w notatkach / kliencie / regule / userze...',
        permanent_acks_all_users: 'Wszyscy userzy',
        permanent_acks_col_date: 'Data',
        permanent_acks_col_user: 'User',
        permanent_acks_col_client: 'Klient',
        permanent_acks_col_rule: 'Reguła',
        permanent_acks_col_notes: 'Notatki (uzasadnienie)',
        permanent_acks_empty: 'Brak permanent acks',
        permanent_acks_rows_shown: 'rekordów',
        permanent_acks_truncated: 'limit 500 — zawęź filtr',
        collapse_sidebar: 'Zwiń menu',
        // P0 fix (2026-04-25): empty state Historia + loading
        loading: 'Ładowanie...',
        history_title: 'Historia audytów',
        history_empty_desc: 'Brak audytów w historii. Uruchom pierwszy audyt, aby zacząć budować historię.',
        history_run_first_audit: 'Uruchom pierwszy audyt',
        // P2 fix (2026-04-25): aria-label for status pills (WCAG SC 1.4.1)
        status_errors: 'Błędy',
        status_warnings: 'Ostrzeżenia',
        status_ok: 'OK',
        // P1 fix (2026-04-25): KPI tooltips
        hero_audited_tooltip: 'Liczba firm zaudytowanych / łączna liczba firm na liście',
        hero_average_tooltip: 'Średnia ocena (0-10) ze wszystkich zaudytowanych firm. Wyższa = lepsza jakość',
        hero_critical_tooltip: (n) => `Firmy z oceną poniżej ${n} wymagają przeglądu`,
        hero_fixed_tooltip: 'Liczba błędów oznaczonych jako "Naprawione" / łączna liczba błędów',
        // EN4 fix (2026-04-25): YoY disabled message
        rule_yoy_disabled_desc: 'Porównanie YoY niedostępne — wgraj dane z poprzedniego roku, aby aktywować analizę trendów.',
        // P0 fix (2026-04-25): firm row click → full report
        open_full_report: 'Otwórz pełen raport',
        // P1 fix (2026-04-25): Executive summary nad VerdictBanner
        error: 'błąd',
        errors: 'błędów',
        warning: 'ostrzeżenie',
        warnings: 'ostrzeżeń',
        exec_clean: 'Brak błędów i ostrzeżeń',
        exec_top_action: 'Priorytet',
        // Scoring penalty breakdown
        scoring_breakdown_title: 'Co obniżyło wynik',
        scoring_breakdown_hint: 'Każda reguła może zabrać maksymalnie ustaloną liczbę punktów — pojedyncza reguła nie może zniszczyć całego wyniku.',
        scoring_bucket_critical_compliance: 'Krytyczne',
        scoring_bucket_error: 'Błąd',
        scoring_bucket_warning: 'Ostrzeżenie',
        open_in_finago: 'Otwórz w Finago',
        finago_then_search: 'następnie wyszukaj firmę',
        // P1 fix (2026-04-25): YoY widget
        yoy_no_change: 'Bez zmian',
        vs_previous_period: 'vs poprzedni okres {0}',
        // P1 fix (2026-04-25): Notes modal przy ack
        ack_history_was_checked: 'było Sprawdzone',
        ack_history_was_fixed: 'było Naprawione',
        ack_history_total: 'łącznie',
        ack_history_recurring_hint: 'sprawdź czy problem nadal występuje',
        ack_autofill_from: 'Notatka z',
        ack_autofill_hint: 'poprzednia notatka, wstaw tylko jeśli pasuje',
        ack_autofill_insert: 'Wstaw',
        ack_why_question: 'Dlaczego akceptujesz ten błąd?',
        ack_note_placeholder: 'Np: Klient potwierdził, zaksięgowane poprawnie, nie dotyczy tego okresu...',
        ack_client_followup_note_placeholder: 'Co trzeba wyjaśnić z klientem? Np. brak ubezpieczenia, czekamy na fakturę albo dokumentację.',
        ack_confirm: 'Potwierdź i zapisz',
        cancel: 'Anuluj',
        // P1 fix (2026-04-25): table column collapse
        table_show_more_cols: 'Pokaż więcej kolumn (błędy/ostrzeżenia/kategorie)',
        table_show_compact: 'Widok kompaktowy (5 kolumn)',
        // P1 fix (2026-04-25): empty state Varslingsstatus
        notif_kpi_sent: 'Wysłane',
        notif_kpi_opened: 'Otwarte',
        notif_kpi_unopened: 'Nieotwarte',
        notif_kpi_reminded: 'Przypomniane',
        notif_kpi_processed: 'Przerobione',
        notif_th_accountant: 'Księgowy',
        notif_th_period: 'Okres',
        notif_th_firms: 'Firmy',
        notif_th_count: 'Razy',
        notif_th_actions: 'Akcje',
        notif_th_status: 'Status',
        notif_status_escalated: 'Eskalowane',
        notif_status_unopened: 'Nieotwarte',
        notif_status_active: 'Aktywne',
        notif_status_opened: 'Otwarte',
        notif_db_download: 'Pobierz DB',
        notif_empty_title: 'Brak wysłanych powiadomień',
        notif_empty_desc: 'Gdy wyślesz raport audytu do księgowego, status pojawi się tutaj. Zacznij od uruchomienia batch audytu.',
        notif_goto_dashboard: 'Przejdź do panelu',
        // v29 — Users management
        users_title: 'Zarządzanie użytkownikami',
        users_add_title: 'Zaproś nowego użytkownika',
        users_invite_desc: 'Użytkownik otrzyma email z linkiem do ustawienia hasła.',
        users_email: 'E-mail',
        users_email_required: 'E-mail jest wymagany',
        users_role: 'Rola',
        users_status: 'Status',
        users_2fa: '2FA',
        users_actions: 'Akcje',
        users_created: 'Utworzony',
        users_invite: 'Wyślij zaproszenie',
        users_sending: 'Wysyłanie...',
        users_invite_sent: (email: string) => `Zaproszenie wysłane do ${email}`,
        users_created_no_email: 'Użytkownik utworzony (email nie wysłany — sprawdź konfigurację Resend)',
        users_resend_invite: 'Wyślij zaproszenie ponownie',
        users_invite_resent: 'Zaproszenie wysłane ponownie',
        users_invite_resent_no_email: 'Nie udało się wysłać emaila — sprawdź konfigurację Resend',
        users_reset_pwd: 'Resetuj hasło',
        users_reset_sent: 'Email z linkiem do resetu hasła został wysłany',
        users_reset_no_email: 'Hasło zresetowane (email nie wysłany)',
        users_delete: 'Usuń',
        users_delete_confirm: (email: string) => `Czy na pewno chcesz usunąć ${email}? Konto z zapisaną pracą (potwierdzenia, powiadomienia, uwagi) zostanie dezaktywowane, a praca zachowana.`,
        users_deleted_ok: 'Użytkownik usunięty',
        users_deactivated_ok: 'Konto dezaktywowane — zapisana praca została zachowana',
        users_status_deactivated: 'Dezaktywowany',
        users_no_users: 'Brak użytkowników',
        users_role_changed: 'Rola zmieniona',
        users_status_active: 'Aktywny',
        users_status_invited: 'Zaproszony',
        // v30 — Audit log
        audit_title: 'Dziennik aktywności',
        audit_time: 'Czas',
        audit_user: 'Użytkownik',
        audit_action: 'Akcja',
        audit_detail: 'Szczegóły',
        audit_ip: 'IP',
        audit_filter_all: 'Wszystkie akcje',
        audit_filter_user: 'Wszyscy użytkownicy',
        audit_filter_from: 'Od daty',
        audit_filter_to: 'Do daty',
        audit_load_more: 'Załaduj więcej',
        audit_no_entries: 'Brak wpisów',
        // v18 — Home screen
        home_title: 'Audyt klientów',
        home_no_connection: 'Brak połączenia API',
        home_configure_api: 'Skonfiguruj połączenie API w Ustawieniach',
        home_select_all: 'Zaznacz wszystkie',
        home_all_accountants: 'Wszyscy księgowi',
        home_deselect_all: 'Odznacz wszystkie',
        home_run_audit_1: 'Uruchom audyt',
        home_run_audit_n: (n) => `Uruchom audyt (${n} firm)`,
        home_refresh_list: 'Odśwież listę',
        home_clients_count: 'klientów',
        home_search: 'Szukaj firmy...',
        home_show_selected: (n) => `Zaznaczone (${n})`,
        home_show_all: 'Pokaż wszystkie',
        dashboard_filter_form: 'Forma działalności',
        dashboard_filter_form_all: 'Wszystkie formy',
        dashboard_hide_holdings: 'Wyklucz holdingi',
        dashboard_holding_tag: 'Holding',
        dashboard_hide_inactive: 'Wyklucz nieaktywne',
        dashboard_inactive_tag: 'Nieaktywna',
        // v18 — Settings sections
        settings_api_section: 'Połączenie API',
        settings_api_status_connected: (n) => `Połączono (${n} klientów)`,
        settings_api_status_disconnected: 'Nie połączono',
        settings_api_test: 'Testuj połączenie',
        settings_csv_section: 'Audyt ręczny (CSV/Excel)',
        settings_csv_select_system: 'Wybierz system księgowy',
        settings_csv_run: 'Uruchom audyt ręczny',
        // v18 — YoY rules
        rule_yoy_revenue_drop: 'Spadek przychodów >30% YoY',
        rule_yoy_revenue_drop_desc: (curr, prev, pct) => `Przychody (3xxx) w tym roku: ${curr}\nPrzychody rok wcześniej: ${prev}\nZmiana: ${pct}%\n\nZnaczący spadek przychodów wymaga analizy działalności.`,
        rule_yoy_cost_spike: 'Wzrost kosztów >50% YoY',
        rule_yoy_cost_spike_desc: (curr, prev, pct) => `Koszty (4xxx-7xxx) w tym roku: ${curr}\nKoszty rok wcześniej: ${prev}\nZmiana: ${pct}%\n\nNiezwykły wzrost kosztów. Sprawdź czy to koszty jednorazowe.`,
        rule_yoy_equity_decline: 'Spadek kapitału własnego >50% YoY',
        rule_yoy_equity_decline_desc: (curr, prev, pct) => `Kapitał własny (aktywa minus zobowiązania) w tym roku: ${curr}\nRok wcześniej: ${prev}\nZmiana: ${pct}%\n\nKrytyczny spadek kapitału własnego.`,
        rule_yoy_debt_increase: 'Wzrost sald kredytowych 2200-2999 ponad 50%',
        rule_yoy_debt_increase_desc: (curr,prev,pct) => `Salda kredytowe 2200-2999: ${curr}. Podstawa porównania: ${prev}. Zmiana: ${pct}%. Salda debetowe pominięto; to nie jest zadłużenie netto. Daty porównania (obecnie / wcześniej):`,
        rule_yoy_profitability: 'Zysk → strata YoY',
        rule_yoy_profitability_desc: (curr, prev) => `Wynik w tym roku: ${curr}\nWynik rok wcześniej: ${prev}\n\nFirma przeszła z zysku w stratę. Wymaga natychmiastowej uwagi.`,
        action_yoy_revenue_drop: 'Przeanalizuj spadek przychodów — nowa strategia czy zmiany rynkowe?',
        action_yoy_cost_spike: 'Zidentyfikuj główną przyczynę wzrostu kosztów. Jednorazowy wydatek czy trwała zmiana?',
        action_yoy_equity_decline: 'Oce\u0144 sytuacj\u0119 kapita\u0142ow\u0105. Mo\u017ce obowi\u0105zywa\u0107 obowi\u0105zek dzia\u0142ania wg aksjeloven \u00a7 3-4.',
        action_yoy_debt_increase: 'Sprawdź nowe kredyty i wierzycieli. Oceń zdolność obsługi długu.',
        action_yoy_profitability: 'Przeanalizuj zmianę rentowności. Zidentyfikuj czynniki straty.',
        // v18.1 — Report improvements
        data_source_label: 'Źródło',
        data_summary_accounts: 'kont',
        generatedAt: 'Wygenerowano',
        review_progress: 'Przegl\u0105d',
        bulk_ack_scope_count: (firms, findings) => `${firms} firm, ${findings} ustaleń`,
        review_progress_hint: 'Liczy błędy, ostrzeżenia i sygnały kontrolne wymagające decyzji. Sygnały nie obniżają oceny. Pozostałe informacje są opcjonalne.',
        audit_snapshot_notice: 'Zapisany wynik audytu. Samo otwarcie raportu nie odświeża danych księgowych.',
        report_view_date: 'Widok raportu',
        audit_date_unknown: 'Data wykonania audytu nie została zapisana',
        audit_date_label: 'Audyt wykonany',
        notify_missing_recipient: 'Brak jednoznacznego konta księgowego. Popraw przypisanie przed wysyłką.',
        notify_skipped_done: n => `Pominięto, ${n === 1 ? 'firma jest już zrobiona' : 'firmy są już zrobione'}:`,
        dispatch_all_accountants: 'Wszyscy księgowi',
        dispatch_accountant: 'Księgowy',
        dispatch_recipients: n => `Księgowi: ${n}`,
        dispatch_other_actions: 'Inne akcje',
        dispatch_delivery: 'Wysyłka',
        dispatch_all_delivery: 'Wszystkie raporty',
        dispatch_search: 'Szukaj firmy',
        dispatch_more_filters: 'Więcej filtrów',
        dispatch_visible: (n, total) => `Widoczne firmy: ${n} z ${total}`,
        dispatch_hidden: n => `${n} zaznaczonych firm jest ukrytych przez filtry. Odznacz je przed wysyłką.`,
        dispatch_clear_hidden: 'Odznacz ukryte',
        dispatch_visible_scope: 'Raporty z bieżącego filtra',
        dispatch_no_recipient: 'Brak przypisanego księgowego',
        dispatch_selected_preview: n => `Podgląd zaznaczonych (${n})`,
        dispatch_visible_preview: n => `Podgląd widocznych (${n})`,
        dispatch_status_error: 'Nie udało się odczytać statusu wysyłki. Nie można rozróżnić wysłanych i niewysłanych raportów.',
        dispatch_retry: 'Ponów odczyt',
        notify_preview_hint: 'Sprawdź adresatów i treść. Po wysłaniu aplikacja przypomina po 3 dniach, a po 7 dniach eskaluje nieotwarte raporty.',
        notify_confirm_send: 'Wyślij pokazane wiadomości',
        notify_preview_title: 'Podgląd powiadomień',
        ack_retain_option: 'Zachowaj uzasadnienie bez terminu wygaśnięcia, tylko dla tych danych i okresu',
        settings_api_desc: 'Po\u0142\u0105czenie API konfigurowane jest przez administratora na serwerze.',
        // v19 — Reports & Analytics
        reports_nav: 'Raporty',
        reports_title: 'Raporty i Analiza',
        reports_loading: 'Ładowanie danych...',
        reports_no_data: 'Brak danych. Uruchom batch audyt.',
        report_period_unknown: 'Okres tego biegu jest nieznany, więc raportu nie da się stąd otworzyć.',
        reports_avg_score: 'Średni wynik',
        reports_firms_audited: 'Zaudytowane firmy',
        reports_critical_firms: 'Firmy krytyczne',
        reports_error_rate: 'Błędy na firmę',
        reports_vs_previous: 'vs poprzedni',
        reports_accountant_ranking: 'Ranking księgowych',
        reports_accountant: 'Księgowy',
        reports_no_accountant: 'Nieprzypisany',
        reports_firms_count: 'Firmy',
        reports_avg: 'Średnia',
        reports_errors: 'Błędy',
        reports_warnings: 'Ostrz.',
        reports_critical: 'Krytyczne',
        reports_top_errors: 'Najczęstsze błędy',
        reports_expand: 'Pokaż szczegóły',
        reports_collapse: 'Ukryj szczegóły',
        reports_rule_frequency: 'Częstotliwość reguł',
        reports_affected: 'dotknięte',
        reports_filter_all: 'Wszystkie',
        reports_filter_errors: 'Błędy',
        reports_filter_warnings: 'Ostrzeżenia',
        reports_trend_title: 'Trend jakości',
        reports_select_run: 'Wybierz przebieg',
        reports_current_run: 'Bieżący',
        reports_range_all: 'Wszystkie',
        reports_range_year: 'Ost. 12m',
        reports_range_6m: 'Ost. 6m',
        reports_range_3m: 'Ost. 3m',
        reports_completion: 'Realizacja',
        reports_not_audited: 'Niezaudytowane',
        reports_per_accountant: 'Wg księgowego',
        reports_score: 'Wynik',
        reports_firms: 'Firmy',
        reports_period: 'Okres',
        reports_of: 'z',
        reports_accountant_trend: 'Trend wg księgowego',
        reports_trend_loading: 'Ładowanie trendu...',
        reports_trend_no_history: 'Potrzeba min. 2 audytów',
        reports_trend_delta: 'Zmiana',
        reports_trend_show_all: 'Załaduj historię',
        reports_trend_period: 'Okres',
        // PIN auth
        pin_title: 'MTA Audit',
        pin_subtitle: 'Wpisz kod PIN, aby kontynuować',
        pin_placeholder: 'Kod PIN',
        pin_btn: 'Zaloguj',
        pin_error_wrong: 'Nieprawidłowy PIN',
        pin_error_network: 'Brak połączenia z serwerem',
        // Manual upload for API client
        manual_upload_for: (name) => `Wgraj pliki dla ${name}`,
        manual_upload_select_system: 'Wybierz system pliku',
        manual_upload_run: 'Uruchom audyt',
        // v29 — Auth UI
        auth_login_title: 'Zaloguj się',
        auth_email: 'E-mail',
        auth_password: 'Hasło',
        auth_login_btn: 'Zaloguj',
        auth_logging_in: 'Logowanie...',
        auth_forgot: 'Zapomniałeś hasła?',
        auth_remember_me: 'Zapamiętaj na 30 dni',
        auth_forgot_title: 'Odzyskaj hasło',
        auth_send_reset: 'Wyślij link do zresetowania',
        auth_sending: 'Wysyłanie...',
        auth_back_to_login: 'Wróć do logowania',
        auth_email_sent_title: 'E-mail wysłany',
        auth_email_sent_msg: 'Sprawdź skrzynkę — wysłaliśmy link do zresetowania hasła.',
        auth_new_password_title: 'Nowe hasło',
        auth_new_password: 'Nowe hasło',
        auth_set_password: 'Ustaw nowe hasło',
        auth_updating: 'Aktualizacja...',
        auth_password_updated: 'Hasło zaktualizowane',
        auth_password_updated_msg: 'Hasło zostało zmienione!',
        auth_go_to_login: 'Przejdź do logowania',
        auth_password_hint: 'Min. 8 znaków, 1 wielka litera, 1 cyfra',
        auth_logout: 'Wyloguj',
        auth_loading: 'Ładowanie...',
        auth_session_expired: 'Sesja wygasła. Zaloguj się ponownie.',
        auth_change_password: 'Zmień hasło',
        auth_current_password: 'Aktualne hasło',
        auth_new_password_label: 'Nowe hasło',
        auth_change_btn: 'Zmień hasło',
        auth_changing: 'Zmieniam...',
        auth_password_changed: 'Hasło zmienione!',
        auth_must_change: 'Musisz zmienić hasło przed kontynuacją.',
        auth_timeout: 'Przekroczono czas — sprawdź połączenie sieciowe',
        // v30 — Offline & UX
        offline_banner: 'Brak po\u0142\u0105czenia z internetem — zmiany zapisywane lokalnie',
        // v31 — 2FA
        twofa_title: 'Weryfikacja dwuetapowa',
        twofa_code_label: 'Kod z aplikacji uwierzytelniaj\u0105cej',
        twofa_verify_btn: 'Weryfikuj',
        twofa_verifying: 'Weryfikacja...',
        twofa_or_backup: 'Lub u\u017cyj kodu zapasowego',
        twofa_back: 'Wr\u00f3\u0107',
        twofa_setup_title: 'Weryfikacja dwuetapowa (2FA)',
        twofa_setup_desc: 'Chro\u0144 konto aplikacj\u0105 uwierzytelniaj\u0105c\u0105 (Google Authenticator, Authy)',
        twofa_enable_btn: 'W\u0142\u0105cz 2FA',
        twofa_disable_btn: 'Wy\u0142\u0105cz 2FA',
        twofa_status_on: '2FA w\u0142\u0105czone',
        twofa_status_off: '2FA wy\u0142\u0105czone',
        twofa_scan_qr: 'Zeskanuj kod QR aplikacj\u0105 uwierzytelniaj\u0105c\u0105',
        twofa_manual_key: 'Klucz r\u0119czny',
        twofa_backup_title: 'Kody zapasowe',
        twofa_backup_desc: 'Zapisz te kody w bezpiecznym miejscu. Ka\u017cdy kod mo\u017cna u\u017cy\u0107 tylko raz.',
        twofa_confirm_code: 'Wpisz kod z aplikacji aby potwierdzi\u0107',
        twofa_confirmed: '2FA w\u0142\u0105czone!',
        twofa_disable_confirm: 'Wpisz has\u0142o aby wy\u0142\u0105czy\u0107 2FA',
        twofa_disabled: '2FA wy\u0142\u0105czone',
        // v33 — Panel
        panel_assignee: 'Przypisany',
        panel_issues_title: 'Wykryte problemy',
        panel_notes: 'Notatka',
        // v33 — Group by
        group_by_accountant: 'Grupuj wg ksi\u0119gowego',
        group_unassigned: 'Nieprzypisane',
        // v33 — Bulk actions
        bulk_run: 'Uruchom audyt',
        bulk_mark_reviewed: 'Oznacz jako sprawdzone',
        bulk_assign: 'Przypisz...',
        bulk_compare: 'Por\u00f3wnaj',
        bulk_deselect: 'Odznacz wszystkie',
        bulk_selected: 'zaznaczonych',
        // P0 fix (2026-04-27): Bulk Ack
        bulk_ack_button: 'Bulk Ack',
        bulk_ack_tooltip: 'Potwierdz te same regule dla wielu klientow naraz',
        bulk_ack_modal_title: (n) => `Bulk ack: ${n} klientow`,
        bulk_ack_modal_hint: 'Wybierz regule do acknowledge dla wszystkich zaznaczonych klientow',
        bulk_ack_select_rule: 'Wybierz regule',
        bulk_ack_select_rule_placeholder: 'Wybierz wspolna regule',
        bulk_ack_firms_with_rule: 'klientow z problemem',
        bulk_ack_apply_matching: 'Tylko pasujacy',
        bulk_ack_apply_matching_tooltip: 'Potwierdz tylko dla klientow ktorzy faktycznie maja te regule — reszte pomin',
        bulk_ack_apply_all: 'Wszyscy',
        bulk_ack_apply_all_tooltip: 'Potwierdz dla wszystkich zaznaczonych klientow nawet bez tej reguly (moze tworzyc szum)',
        bulk_ack_no_common_issues: 'Brak wspolnej reguly w zaznaczonych klientach',
        bulk_ack_action_label: 'Akcja',
        bulk_ack_scope_label: 'Zakres',
        bulk_ack_scope_period: 'Tylko ten okres',
        bulk_ack_submit: (n) => `Potwierdz dla ${n} klientow`,
        bulk_ack_success: (n) => `${n} acks zapisanych`,
        // v33 — Compare
        compare_title: 'Por\u00f3wnanie firm',
        compare_close: 'Zamknij',
        compare_top_issues: 'G\u0142\u00f3wne problemy',
        compare_no_issues: 'Brak problem\u00f3w',
        // v33 — Summary dashboard
        summary_heatmap: 'Mapa firm',
        summary_top_errors: 'Najcz\u0119stsze b\u0142\u0119dy',
        summary_attention: 'Wymagaj\u0105 uwagi',
        summary_show: 'Poka\u017c podsumowanie',
        summary_hide: 'Ukryj podsumowanie',
        // v33 — Notes & Tags
        notes_placeholder: 'Wpisz notatk\u0119...',
        tag_clear_all: 'Wyczy\u015b\u0107 wszystkie filtry',
        // v34 — Role, Acknowledgmenty, Okno MVA
        role_admin: 'Administrator',
        role_auditor: 'Audytor',
        accountant_name_label: 'Ksi\u0119gowy',
        accountant_name_hint: 'Nazwa jak w li\u015bcie klient\u00f3w',
        ack_checked: 'Sprawdzone',
        ack_fixed: 'Naprawione',
        ack_client_followup: 'Do kontaktu',
        ack_info_note: 'Komentarz',
        ack_confirm_checked: 'Oznacz jako sprawdzone',
        ack_confirm_fixed: 'Oznacz jako naprawione',
        ack_show_hidden: 'Poka\u017c sprawdzone',
        ack_hide_checked: 'Ukryj sprawdzone',
        ack_undo: 'Cofnij',
        ack_save_failed: 'Zapis nie został potwierdzony. Odśwież i sprawdź status przed ponowną próbą.',
        ack_undo_failed: 'Cofnięcie nie powiodło się — spróbuj ponownie',
        ack_notes_placeholder: 'Dodaj komentarz (opcjonalnie)',
        ack_checked_tooltip: 'Sprawdzone \u2014 nie pojawi si\u0119 w nast\u0119pnym audycie',
        ack_fixed_tooltip: 'Naprawione \u2014 zostanie sprawdzone ponownie',
        ack_client_followup_tooltip: 'Zapisuje potrzebę kontaktu. Nie wysyła wiadomości i nie zamyka ustalenia.',
        ack_info_note_tooltip: 'Dodaj opcjonalny komentarz do punktu informacyjnego. Nie liczy się do postępu.',
        // Permanent ignore (P0 fix 2026-04-27)
        ack_permanent: "Zachowaj wyjaśnienie",
        ack_permanent_tooltip: "Zachowuje wyjaśnienie. Nowy okres lub zmiana ustaleń wymaga ponownej oceny.",
        ack_permanent_modal_title: 'Sprawdzone z zachowanym uzasadnieniem',
        ack_permanent_warning_title: "Zakres wyjaśnienia",
        ack_permanent_warning_body: "Wyjaśnienie dotyczy tych danych i tego okresu. Nowe dokumenty, kwoty lub okres otwierają kontrolę ponownie.",
        ack_permanent_min_chars: 'Minimum 10 znaków. Uzasadnij, jakich danych dotyczy wyjaśnienie.',
        ack_permanent_confirm: 'Potwierdź sprawdzenie i zachowaj uzasadnienie',
        ack_permanent_badge: 'Sprawdzone, uzasadnienie zachowane',
        ack_permanent_note_placeholder: 'Opisz rozstrzygnięcie i dokumenty, fakty oraz okresy, których dotyczy.',
        audit_window_locked: 'Audyt dost\u0119pny tylko w oknie MVA',
        audit_window_info: (term, start, end) => `Okno MVA ${term}: ${start}\u2013${end}, godz. 08:00\u201317:00`,
        audit_window_next: 'Nast\u0119pne okno',
        audit_window_open: 'Okno MVA otwarte',
        admin_ack_summary: 'Przegl\u0105d zespo\u0142u',
        admin_firms_total: 'Firmy',
        admin_findings_checked: 'Sprawdzone',
        admin_findings_fixed: 'Naprawione',
        admin_findings_open: 'Otwarte',
        admin_not_reviewed: 'Niesprawdzone',
        team_period: 'Okres',
        team_accountant: 'Ksi\u0119gowy',
        team_firms: 'Klienci',
        team_audited: 'Zaudytowano',
        team_errors: 'B\u0142\u0119dy',
        team_warnings: 'Ostrze\u017cenia',
        team_err_per_firm: 'B\u0142./firma',
        team_avg_score: '\u015arednia',
        team_review_pct: 'Sprawdzono',
        team_last_audit: 'Ostatni',
        team_open_report: 'Raport',
        team_no_data: 'Uruchom audyt aby zobaczy\u0107 przegl\u0105d zespo\u0142u',
        team_run_audit: 'Przejd\u017a do audytu',
        team_back: 'Wr\u00f3\u0107 do przegl\u0105du',
        team_firm: 'Firma',
        team_score: 'Ocena',
        team_findings: 'Wyniki',
        team_reviewed: 'Sprawdzone',
        team_open: 'Otwarte',
        team_fixed_by: 'Naprawione przez',
        team_checked_by: 'Sprawdzone przez',
        team_activity_log: 'Log aktywno\u015bci',
        team_no_activity: 'Brak aktywno\u015bci',
        team_all: 'Wszyscy',
        team_period_label: (y, m) => `na ${String(m).padStart(2,'0')}.${y}`,
        // Dashboard Hero
        hero_audited: 'Zaudytowane',
        hero_average: 'Średnia',
        hero_critical: 'Krytyczne',
        hero_critical_desc: (n) => `firm poniżej ${n}`,
        hero_fixed: 'Naprawione',
        hero_fixed_pct: 'naprawione',
        hero_completed_pct: 'ukończone',
        hero_attention: 'Wymaga uwagi',
        hero_errors: 'błędów',
        // Firm Timeline
        timeline_loading: 'Ładowanie historii...',
        timeline_first_audit: 'Pierwszy audyt — brak historii',
        timeline_1_period: 'Historia (1 okres)',
        timeline_n_periods: (n) => `Historia (${n} okresów)`,
        timeline_trend_next: 'trend pojawi się po następnym audycie',
        // Notify
        notify_sending: 'Wysyłanie...',
        notify_send_accountant: 'Podgląd powiadomienia księgowego',
        notify_sent: 'E-mail wysłany',
        notify_sent_n: (n) => `E-mail wysłany do ${n} księgow${n > 1 ? 'ych' : 'ego'}`,
        notify_none_sent: 'Nie wysłano e-maili',
        notify_failed: 'Wysyłanie nie powiodło się',
        notify_send_all: 'Podgląd powiadomień',
        notify_confirm_all: (n) => `Wysłać powiadomienia e-mail do księgowych dla ${n} firm? (jeden zbiorczy mail na księgową)`,
        notify_badge_sent: 'Wysłane',
        notify_badge_sent_title: 'Powiadomienie wysłane do księgowej w tym okresie',
        dashboard_filter_sent: 'Wysłane',
        dashboard_filter_not_sent: 'Niewysłane',
        no_activity_badge: 'Brak ruchów',
        no_activity_title: 'Brak księgowań w wybranym okresie',
        no_activity_report: 'Ta firma nie ma księgowań w wybranym okresie — niewiele do audytu.',
        // Reports tabs
        reports_tab_analytics: 'Analiza',
        reports_tab_team: 'Zespół',
        // Misc
        unassigned: 'Nieprzypisany',
        sidebar_show: 'Pokaż panel',
        sidebar_hide: 'Ukryj panel',
        av_poeng: 'z 10.0 pkt',
        current_run: 'Bieżący audyt',
        latest: 'Ostatni',
        // --- i18n comprehensive fix: missing keys ---
        // Month names (short)
        month_short_1: 'Sty',
        month_short_2: 'Lut',
        month_short_3: 'Mar',
        month_short_4: 'Kwi',
        month_short_5: 'Maj',
        month_short_6: 'Cze',
        month_short_7: 'Lip',
        month_short_8: 'Sie',
        month_short_9: 'Wrz',
        month_short_10: 'Pa\u017a',
        month_short_11: 'Lis',
        month_short_12: 'Gru',
        // CSV export
        csv_firma: 'Firma',
        csv_system: 'System',
        csv_accountant: 'Ksi\u0119gowy',
        csv_score: 'Wynik',
        csv_errors: 'B\u0142\u0119dy',
        csv_warnings: 'Ostrze\u017cenia',
        csv_reviewed: 'Sprawdzone',
        csv_notes: 'Notatki',
        csv_yes: 'Tak',
        csv_no: 'Nie',
        csv_exported: 'CSV wyeksportowany',
        // Error messages
        error_generic: 'B\u0142\u0105d',
        error_login: 'Logowanie nie powiod\u0142o si\u0119',
        error_verify: 'Weryfikacja nie powiod\u0142a si\u0119',
        error_reset: 'Resetowanie nie powiod\u0142o si\u0119',
        error_failed: 'Niepowodzenie',
        // PDF
        pdf_report_title: 'Raport audytu',
        pdf_no_data: 'Brak danych do eksportu',
        pdf_generated: 'Wygenerowany',
        pdf_no_report: 'Brak raportu do eksportu',
        // Misc labels
        label_feil: 'b\u0142\u0119d\u00f3w',
        label_advarsler: 'ostrze\u017ce\u0144',
        label_info: 'info',
        // Confirm dialog
        confirm_cancel: 'Anuluj',
        confirm_ok: 'OK',
        // Data preview modal
        search_placeholder: 'Szukaj...',
        no_results: 'Brak wynik\u00f3w',
        fileSaldo: 'Bilans sald',
        fileResultat: 'Rachunek wynik\u00f3w',
        col_account: 'Konto',
        col_name: 'Nazwa',
        col_accNum: 'Konto',
        col_currentIb: 'IB bie\u017c\u0105cy',
        col_previousUb: 'UB poprzedni',
        col_diff: 'R\u00f3\u017cnica',
        col_total: '\u0141\u0105cznie',
        // PDF metric labels
        nav_errors: 'B\u0142\u0119dy',
        nav_warnings: 'Ostrze\u017cenia',
        more_rows: 'wi\u0119cej wierszy',
        // Auth — missing keys
        auth_passwords_mismatch: 'Has\u0142a nie s\u0105 zgodne',
        auth_confirm_password: 'Potwierd\u017a has\u0142o',
        // Toast messages
        toast_digest_sent: 'Raport wys\u0142any e-mailem',
        toast_ack_no_client: 'B\u0142\u0105d: brak ID klienta, nie mo\u017cna zapisa\u0107',
        toast_ack_network_error: 'Zapis nie powi\u00f3d\u0142 si\u0119: b\u0142\u0105d sieci',
        toast_syncing_kundeliste: 'Synchronizacja listy klient\u00f3w\u2026',
        toast_email_saved: 'E-mail zapisany',
        toast_email_error: 'B\u0142\u0105d zapisu e-maila',
        // Confirm dialogs
        confirm_select_title: 'Zaznaczy\u0107 wszystkie?',
        confirm_select_many: 'Czy chcesz zaznaczy\u0107 {0} firm?',
        confirm_abort_message: 'Czy na pewno chcesz przerwa\u0107?',
        // Auditor empty state
        auditor_no_results_title: 'Brak audytu dla Twoich klient\u00f3w',
        auditor_no_results_desc: 'Administrator nie uruchomi\u0142 jeszcze audytu lub brak wynik\u00f3w dla Twoich klient\u00f3w.',
        // Dashboard
        dashboard_reset_filters: 'Resetuj filtry',
        reaudit: 'Uruchom audyt ponownie',
        // --- MVA period check evidence text ---
        mva_termin: 'Termin',
        mva_utg_endring: 'MVA nale\u017cny (zmiana)',
        mva_inn_endring: 'MVA naliczony (zmiana)',
        mva_beregnet: 'Ruch netto, łącznie z przeksięgowaniami',
        mva_2740_saldo: '2740 saldo na koniec terminu',
        mva_uavstemte: 'Nowe lub zmienione salda pozostałe',
        mva_termin_ok: (n) => `${n} terminów bez nowych sald pozostałych w tej kontroli. To nie potwierdza uzgodnienia.`,
        mva_alle_ok: (n) => `Sprawdzono ${n} terminów. Uzgodnienie z deklaracją i jej wysłanie nie są tutaj potwierdzone.`,
        mva_partial_period: 'Niepełne terminy VAT w wybranym okresie nie zostały sprawdzone. Wybierz oba miesiące terminu.',
        voucher_ids_missing: (n, total) => `Kontrola nie została wykonana: ${n} z ${total} linii transakcji nie ma identyfikatora bilagu. Pobierz pełne dane dokumentów przed zatwierdzeniem tej kontroli.`,
        voucher_sample_small: 'Kontrola nie została wykonana: mniej niż pięć bilagów z wieloma liniami. Sprawdź dokumenty ręcznie.',
        voucher_convention_unknown: 'Kontrola nie została zatwierdzona: ponad 30% bilagów nie bilansuje się. Sprawdź kompletność danych i konwencję znaków przed ponownym obliczeniem.',
        // --- Amortization group label ---
        amort_konto_group: (from, to, count) => `Konto ${from}\u2013${to} (${count} kont)`,
        // --- Invoice numbering gap ---
        invoice_gap: (from, to, missing, list) => `Luka: ${from} \u2192 ${to} (${missing} brakuj\u0105cych: ${list})`,
        invoice_gap_more: '...',
        // --- Transaction detail labels ---
        tx_stempel: 'Stempel',
        tx_linkid: 'LinkId',
        tx_bundleid: 'BundleId',
        tx_faktura: 'Faktura',
        tx_konto: 'Konto',
        tx_id: 'ID',
        // --- Transaction skip fallback ---
        tx_skip_reason: (reason) => `\n\nPrzyczyna: ${reason}`,
        tx_coverage_gap: (kontoer, mangler, verstKonto) =>
            `linie transakcji nie pokrywają saldobalanse na ${kontoer} kontach (największy rozjazd: konto ${verstKonto}). Łącznie brakuje ok. ${mangler.toLocaleString('pl-PL')} kr linii wobec ruchu w saldobalanse, więc pobranie jest niekompletne.`,
        otp_ratio_desc: (salary, pension, ratio) => `Wynagrodzenia w badanym okresie: ${salary} kr. Koszt emerytalny netto: ${pension} kr (${ratio}%).`,
        otp_ratio_review: "Relacja poniżej punktu odniesienia 2%. Sprawdź obowiązek, podstawę pracowniczą, zakres kont, okres faktur i użycie premiefond. To sygnał do uzgodnienia, nie kwota zaległości.",
        otp_ratio_context: "Sama relacja nie potwierdza spełnienia obowiązku OTP. Brakuje danych pracowników, podstawy składek, okresów faktur i premiefond.",
        audit_scope_unchecked: "Nie oceniono: dostępne dane nie pozwalają rozstrzygnąć tej kontroli.",
        prior_year_data_missing: "Nie sprawdzono zamknięcia roku: brak rachunku wyniku za pełny poprzedni rok.",
        prior_year_check_title: "Zamknięcie roku: brak pełnych danych poprzedniego roku",
        mva_scope_only: "W objętej regułą części zapisów nie znaleziono sygnału. Wyłączenia i zapisy poza zakresem wymagają dokumentów; poprawność MVA nie została potwierdzona.",
        audit_coverage_notice: (count) => `Poza dostępnymi danymi pozostaje ${count} kontroli. To informacja o zakresie, nie błąd księgowy ani obniżenie punktacji.`,
        tier_resolved: "Wyjaśnione lub poprawione w tym zakresie",
        audit_coverage_title: "Kontrole bez wystarczających danych",
        audit_review_notice: (n) => `${n} sygnałów wymaga wyjaśnienia. Nie są potwierdzonymi błędami i nie obniżają punktacji.`,
        audit_score_limited: 'Punktacja wykonanych kontroli. Pozostają niewyjaśnione sygnały lub ograniczenia danych.',
        audit_unresolved_count: (n) => `${n} nierozstrzygniętych`,
        coverage_reason_saldo: 'Brak saldobalanse.',
        coverage_reason_disabled: 'Kontrola została wyłączona i nie została wykonana.',
        coverage_reason_resultat: 'Brak rachunku wyniku.',
        coverage_reason_both: 'Brak danych bilansu lub wyniku.',
        coverage_reason_transactions: 'Brak transakcji lub niepełny zakres pobrania.',
        coverage_reason_context: 'Warunki kontroli nie są spełnione. Zobacz wyjaśnienie przy tej kontroli.',
        bulk_ack_partial: (n) => `Nie zakończono zapisu. Potwierdzono ${n} zapisów; odśwież status przed kontynuacją.`,
        audit_signals_label: 'Sygnały do wyjaśnienia',
        ack_legacy_notice: (n) => `${n} wcześniejszych wyjaśnień zachowanych w historii`,
        ack_legacy_scope: 'Te notatki są zachowane. Dotyczyły reguły, bez powiązania z konkretnymi dokumentami. Nowy postęp liczy tylko wyjaśnienia powiązane z dowodami; zero nie oznacza usunięcia wcześniejszej pracy.',
        ack_evidence_missing: 'Nie można zapisać: ustalenie nie ma rozpoznawalnych dowodów. Wczytaj raport ponownie.',
        audit_unchecked_label: 'Nierozstrzygnięte',
        mva_subset_passed: (n) => `Niezerowy zapis MVA występuje w ${n} sprawdzonych dokumentach. Nie oceniono stawki, prawa do odliczenia ani dokumentów poza zakresem kontroli.`,
    }
};

export function t(key: string, ...args: any[]): string {
    const val = TRANSLATIONS[_currentLang]?.[key] ?? TRANSLATIONS.no?.[key] ?? key;
    if (typeof val === 'function') return (val as (...a: any[]) => string)(...args);
    return val as string;
}

// Expose to window for backward compatibility with inline scripts
Object.defineProperty(window, 'currentLang', {
    get: () => _currentLang,
    set: (v: string) => { _currentLang = v; },
    configurable: true,
});
(window as any).TRANSLATIONS = TRANSLATIONS;
(window as any).t = t;
